/* JapanSolved™ Icon Registry v1 — MORPHOLOGY CLASSIFIED + USER PURGE APPLIED
   Generated from uploaded registry + icon sweep/removal screenshots.
   Active registry excludes user-purged icons.
*/
(function () {
  'use strict';
  window.JapanSolvedIconRegistry = {
  "version": "2026-07-07.icon-registry.v1.morphology-purge",
  "generatedAt": "2026-07-07T04:30:00Z",
  "source": "japansolved-icon-registry-v1.js + icons for sweep.zip + remove icons.zip",
  "count": 189,
  "previousCount": 211,
  "purgedCount": 22,
  "missingUrlRepairs": [
    "JSICON-0068"
  ],
  "morphologyDoctrine": {
    "defaultBoxedSlotRule": "Only containerEligible icons may be placed inside page-made boxes.",
    "doubleFrameRule": "If intrinsicFrame is not none, do not add a page-made icon container unless an explicit user override allows it.",
    "hardOverrideRule": "Page-body hard overrides win, but must still pass morphology compatibility unless data-jsi-allow-double-frame is true.",
    "noIconRule": "No icon is preferred over a visually wrong icon."
  },
  "icons": [
    {
      "id": "JSICON-0019",
      "sequence": 19,
      "filename": "icon-1-japansolved-solutions-business-market-entry-structured-expansion.svg",
      "handle": "icon-1-japansolved-solutions-business-market-entry-structured-expansion",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-1-japansolved-solutions-business-market-entry-structured-expansion.svg?v=1777816111",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-business-market-entry-tower",
      "rotationGroup": "solution-expansion-01",
      "cleanLabel": "Structured Expansion Tower",
      "primaryCategory": "business-market-entry",
      "categoryTokens": [
        "business-market-entry"
      ],
      "purposeTags": [
        "business-expansion",
        "market-entry",
        "corporate-growth",
        "structured-setup"
      ],
      "visualTags": [
        "line",
        "tower",
        "formal",
        "expansion",
        "black-stroke"
      ],
      "sectionFit": [
        "hub-card",
        "service-card",
        "business-section",
        "process-step"
      ],
      "rawBestSectionUse": "hub-card, service-card, business-section, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "market-entry",
        "business-routing",
        "strategy-alignment",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "business-market-entry"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"business-market-entry\" data-jsi-section=\"hub-card\" data-jsi-page-wing=\"business-market-entry\" data-jsi-pillars=\"market-entry, business-routing, strategy-alignment, native-intake, paid-routing, client-briefing\" data-jsi-category=\"business-market-entry\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "business-expansion",
        "business-market-entry",
        "business-routing",
        "business-section",
        "client-briefing",
        "container-eligible",
        "corporate-growth",
        "excellent",
        "expansion",
        "formal",
        "good-with-ivory-plate-or-css-filter",
        "hub-card",
        "icon-1-japansolved-solutions-business-market-entry-structured-expansion",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-business-market-entry-tower",
        "line",
        "market-entry",
        "medium",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-medium",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "service-card",
        "solution-expansion-01",
        "strategy-alignment",
        "structured-expansion-tower",
        "structured-setup",
        "tower"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0020",
      "sequence": 20,
      "filename": "icon-2-japansolved-solutions-investments-capital-precision-flow.svg",
      "handle": "icon-2-japansolved-solutions-investments-capital-precision-flow",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-2-japansolved-solutions-investments-capital-precision-flow.svg?v=1777816125",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-investments-capital-database",
      "rotationGroup": "solution-capital-01",
      "cleanLabel": "Capital Precision Flow",
      "primaryCategory": "investments-capital",
      "categoryTokens": [
        "investments-capital"
      ],
      "purposeTags": [
        "capital",
        "payment-flow",
        "investment",
        "finance",
        "precision"
      ],
      "visualTags": [
        "line",
        "database",
        "yen",
        "flow",
        "black-stroke"
      ],
      "sectionFit": [
        "investment-card",
        "product-ladder",
        "trust-card",
        "finance-note"
      ],
      "rawBestSectionUse": "investment-card, product-ladder, trust-card, finance-note",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "asset-intelligence",
        "capital-review",
        "risk-screening"
      ],
      "pageWingFit": [
        "asset-capital-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"investments-capital\" data-jsi-section=\"investment-card\" data-jsi-page-wing=\"asset-capital-intelligence\" data-jsi-pillars=\"asset-intelligence, capital-review, risk-screening\" data-jsi-category=\"investments-capital\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "asset-capital-intelligence",
        "asset-intelligence",
        "balanced",
        "black-stroke",
        "capital",
        "capital-precision-flow",
        "capital-review",
        "container-eligible",
        "database",
        "excellent",
        "finance",
        "finance-note",
        "flow",
        "good-with-ivory-plate-or-css-filter",
        "icon-2-japansolved-solutions-investments-capital-precision-flow",
        "investment",
        "investment-card",
        "investments-capital",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-investments-capital-database",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "payment-flow",
        "precision",
        "premium-monoline",
        "primary-default",
        "product-ladder",
        "recommended-boxed-or-free",
        "risk-screening",
        "solution-capital-01",
        "trust-card",
        "yen"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0021",
      "sequence": 21,
      "filename": "icon-3-japansolved-solutions-property-relocation-transition-move.svg",
      "handle": "icon-3-japansolved-solutions-property-relocation-transition-move",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-3-japansolved-solutions-property-relocation-transition-move.svg?v=1777816138",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-property-relocation-home",
      "rotationGroup": "solution-relocation-01",
      "cleanLabel": "Relocation Transition Move",
      "primaryCategory": "property-relocation",
      "categoryTokens": [
        "property-relocation"
      ],
      "purposeTags": [
        "relocation",
        "moving",
        "housing",
        "transition",
        "local-setup"
      ],
      "visualTags": [
        "line",
        "home",
        "arrow",
        "transition",
        "black-stroke"
      ],
      "sectionFit": [
        "relocation-section",
        "property-card",
        "process-step",
        "related-card"
      ],
      "rawBestSectionUse": "relocation-section, property-card, process-step, related-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "relocation-support",
        "local-setup",
        "property-routing"
      ],
      "pageWingFit": [
        "property-relocation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"property-relocation\" data-jsi-section=\"relocation-section\" data-jsi-page-wing=\"property-relocation\" data-jsi-pillars=\"relocation-support, local-setup, property-routing\" data-jsi-category=\"property-relocation\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "arrow",
        "balanced",
        "black-stroke",
        "container-eligible",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "home",
        "housing",
        "icon-3-japansolved-solutions-property-relocation-transition-move",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-property-relocation-home",
        "line",
        "local-setup",
        "medium",
        "morphology-none",
        "moving",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process-step",
        "property-card",
        "property-relocation",
        "property-routing",
        "recommended-boxed-or-free",
        "related-card",
        "relocation",
        "relocation-section",
        "relocation-support",
        "relocation-transition-move",
        "solution-relocation-01",
        "transition"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0023",
      "sequence": 23,
      "filename": "icon-5-japansolved-solutions-logistics-representation-controlled-movement.svg",
      "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-5-japansolved-solutions-logistics-representation-controlled-movement.svg?v=1777816159",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-logistics-representation-truck",
      "rotationGroup": "solution-logistics-01",
      "cleanLabel": "Controlled Movement Truck",
      "primaryCategory": "logistics-representation",
      "categoryTokens": [
        "logistics-representation"
      ],
      "purposeTags": [
        "logistics",
        "shipping",
        "controlled-movement",
        "delivery",
        "execution"
      ],
      "visualTags": [
        "line",
        "truck",
        "movement",
        "practical",
        "black-stroke"
      ],
      "sectionFit": [
        "logistics-card",
        "process-step",
        "service-card",
        "cargo-section"
      ],
      "rawBestSectionUse": "logistics-card, process-step, service-card, cargo-section",
      "styleFamily": [
        "premium-monoline",
        "operations-symbol"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"logistics-representation\" data-jsi-section=\"logistics-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"logistics-representation\" data-jsi-style=\"premium-monoline, operations-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "balanced",
        "black-stroke",
        "cargo-execution",
        "cargo-section",
        "concierge-presence",
        "container-eligible",
        "controlled-movement",
        "controlled-movement-truck",
        "cultural-navigation",
        "delivery",
        "excellent",
        "execution",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-logistics-representation-truck",
        "line",
        "local-representation",
        "logistics",
        "logistics-card",
        "logistics-local-representation",
        "logistics-representation",
        "medium",
        "morphology-none",
        "movement",
        "no-double-frame-risk",
        "operations-symbol",
        "outline-medium",
        "practical",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "service-card",
        "shipping",
        "solution-logistics-01",
        "truck"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0024",
      "sequence": 24,
      "filename": "icon-6-japansolved-solutions-travel-cultural-access-curated-gateway.svg",
      "handle": "icon-6-japansolved-solutions-travel-cultural-access-curated-gateway",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-6-japansolved-solutions-travel-cultural-access-curated-gateway.svg?v=1777816168",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-travel-cultural-access-torii-gate",
      "rotationGroup": "solution-cultural-access-01",
      "cleanLabel": "Curated Access Gateway",
      "primaryCategory": "travel-cultural-access",
      "categoryTokens": [
        "travel-cultural-access"
      ],
      "purposeTags": [
        "cultural-access",
        "curated-gateway",
        "travel",
        "experiences",
        "private-access"
      ],
      "visualTags": [
        "line",
        "torii-gate",
        "heritage",
        "gateway",
        "black-stroke"
      ],
      "sectionFit": [
        "travel-card",
        "cultural-access-section",
        "related-card",
        "hub-card"
      ],
      "rawBestSectionUse": "travel-card, cultural-access-section, related-card, hub-card",
      "styleFamily": [
        "premium-monoline",
        "japan-cultural-symbol"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"travel-cultural-access\" data-jsi-section=\"travel-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"travel-cultural-access\" data-jsi-style=\"premium-monoline, japan-cultural-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "balanced",
        "black-stroke",
        "concierge-presence",
        "container-eligible",
        "cultural-access",
        "cultural-access-section",
        "cultural-navigation",
        "curated-access-gateway",
        "curated-gateway",
        "excellent",
        "experiences",
        "gateway",
        "good-with-ivory-plate-or-css-filter",
        "heritage",
        "hub-card",
        "icon-6-japansolved-solutions-travel-cultural-access-curated-gateway",
        "japan-cultural-symbol",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-travel-cultural-access-torii-gate",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "private-access",
        "recommended-boxed-or-free",
        "related-card",
        "solution-cultural-access-01",
        "torii-gate",
        "travel",
        "travel-card",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0025",
      "sequence": 25,
      "filename": "icon-7-japansolved-solutions-advisory-intelligence-analytical-insight.svg",
      "handle": "icon-7-japansolved-solutions-advisory-intelligence-analytical-insight",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-7-japansolved-solutions-advisory-intelligence-analytical-insight.svg?v=1777816178",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-advisory-intelligence-magnifier",
      "rotationGroup": "solution-intelligence-01",
      "cleanLabel": "Analytical Insight Lens",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "intelligence",
        "analysis",
        "insight",
        "due-diligence",
        "research"
      ],
      "visualTags": [
        "line",
        "magnifier",
        "chart",
        "analytical",
        "black-stroke"
      ],
      "sectionFit": [
        "intelligence-block",
        "process-step",
        "review-card",
        "trust-card"
      ],
      "rawBestSectionUse": "intelligence-block, process-step, review-card, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"intelligence-block\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "advisory-intelligence",
        "analysis",
        "analytical",
        "analytical-insight-lens",
        "balanced",
        "black-stroke",
        "chart",
        "container-eligible",
        "discretion",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-7-japansolved-solutions-advisory-intelligence-analytical-insight",
        "insight",
        "intelligence",
        "intelligence-block",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-advisory-intelligence-magnifier",
        "line",
        "magnifier",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-step",
        "recommended-boxed-or-free",
        "research",
        "review-card",
        "review-intelligence",
        "review-routing",
        "solution-intelligence-01",
        "trust-card",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0026",
      "sequence": 26,
      "filename": "icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentColor.svg",
      "handle": "icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentcolor",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentColor.svg?v=1777821188",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-privacy-discretion-shield",
      "rotationGroup": "solution-protection-01",
      "cleanLabel": "CurrentColor Protection Shield",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "protection",
        "privacy",
        "security",
        "safeguarding",
        "sensitive-handling"
      ],
      "visualTags": [
        "line",
        "shield",
        "lock",
        "currentcolor",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "boundary-note",
        "intake-confirmation",
        "security-strip"
      ],
      "rawBestSectionUse": "trust-card, boundary-note, intake-confirmation, security-strip",
      "styleFamily": [
        "premium-monoline",
        "theme-adaptive",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-theme-adaptive",
      "visualDensity": "balanced",
      "lineWeight": "theme-adaptive-stroke",
      "intensity": "quiet",
      "darkThemeFit": "excellent",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "currentColor-safe: can inherit theme color",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 67.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline, theme-adaptive, trust-symbol\" data-jsi-fill=\"outline_theme_adaptive\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "boundary-note",
        "client-briefing",
        "container-eligible",
        "currentcolor",
        "currentcolor-protection-shield",
        "discretion",
        "excellent",
        "icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentcolor",
        "intake-confirmation",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-privacy-discretion-shield",
        "line",
        "lock",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-theme-adaptive",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "privacy",
        "privacy-discretion",
        "privacy-routing",
        "protection",
        "quiet",
        "recommended-boxed-or-free",
        "safeguarding",
        "security",
        "security-strip",
        "sensitive-discreet-routing",
        "sensitive-handling",
        "shield",
        "solution-protection-01",
        "theme-adaptive",
        "theme-adaptive-stroke",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0027",
      "sequence": 27,
      "filename": "icon-9-japansolved-process-submit-request-structured-intake.svg",
      "handle": "icon-9-japansolved-process-submit-request-structured-intake",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-9-japansolved-process-submit-request-structured-intake.svg?v=1777825341",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-intake-request-document",
      "rotationGroup": "process-intake-01",
      "cleanLabel": "Structured Intake Request",
      "primaryCategory": "intake-request",
      "categoryTokens": [
        "intake-request"
      ],
      "purposeTags": [
        "request",
        "intake",
        "form",
        "structured-intake",
        "case-file"
      ],
      "visualTags": [
        "line",
        "document",
        "checklist",
        "clean",
        "black-stroke"
      ],
      "sectionFit": [
        "intake",
        "process-step",
        "cta-card",
        "request-box"
      ],
      "rawBestSectionUse": "intake, process-step, CTA-card, request-box",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "sourcing",
        "private-buyer",
        "procurement-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"intake-request\" data-jsi-section=\"intake\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"sourcing, private-buyer, procurement-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"intake-request\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "case-file",
        "checklist",
        "clean",
        "client-briefing",
        "container-eligible",
        "cta-card",
        "document",
        "excellent",
        "form",
        "good-with-ivory-plate-or-css-filter",
        "icon-9-japansolved-process-submit-request-structured-intake",
        "intake",
        "intake-request",
        "line",
        "morphology-none",
        "native-intake",
        "native-intake-system",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-intake-request-document",
        "object-cube-package",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "private-buyer",
        "process-intake-01",
        "process-step",
        "procurement-routing",
        "quiet",
        "recommended-boxed-or-free",
        "request",
        "request-box",
        "sourcing",
        "structured-intake",
        "structured-intake-request",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [
          "cube/package object; not a frame, but low-fit in premium boxed UI unless exact"
        ],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "cube/package",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0028",
      "sequence": 28,
      "filename": "icon-10-japansolved-process-case-review-analytical-evaluation.svg",
      "handle": "icon-10-japansolved-process-case-review-analytical-evaluation",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-10-japansolved-process-case-review-analytical-evaluation.svg?v=1777825351",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-case-review-magnifier",
      "rotationGroup": "process-evaluation-01",
      "cleanLabel": "Analytical Evaluation Lens",
      "primaryCategory": "case-review",
      "categoryTokens": [
        "case-review"
      ],
      "purposeTags": [
        "evaluation",
        "review",
        "analysis",
        "suitability",
        "diagnosis"
      ],
      "visualTags": [
        "line",
        "magnifier",
        "circle",
        "analytical",
        "black-stroke"
      ],
      "sectionFit": [
        "review-card",
        "process-step",
        "intelligence-block",
        "product-card"
      ],
      "rawBestSectionUse": "review-card, process-step, intelligence-block, product-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"case-review\" data-jsi-section=\"review-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"case-review\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "analysis",
        "analytical",
        "analytical-evaluation-lens",
        "balanced",
        "black-stroke",
        "case-review",
        "circle",
        "container-eligible",
        "diagnosis",
        "discretion",
        "due-diligence",
        "evaluation",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-10-japansolved-process-case-review-analytical-evaluation",
        "intelligence",
        "intelligence-block",
        "line",
        "magnifier",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-case-review-magnifier",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-evaluation-01",
        "process-step",
        "product-card",
        "recommended-boxed-or-free",
        "review",
        "review-card",
        "review-intelligence",
        "review-routing",
        "suitability",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0029",
      "sequence": 29,
      "filename": "icon-11-japansolved-process-strategy-alignment-structured-coordination.svg",
      "handle": "icon-11-japansolved-process-strategy-alignment-structured-coordination",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-11-japansolved-process-strategy-alignment-structured-coordination.svg?v=1777825358",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-strategy-alignment-connected-nodes",
      "rotationGroup": "process-coordination-01",
      "cleanLabel": "Structured Coordination Nodes",
      "primaryCategory": "strategy-alignment",
      "categoryTokens": [
        "strategy-alignment"
      ],
      "purposeTags": [
        "coordination",
        "alignment",
        "planning",
        "managed-route",
        "team-flow"
      ],
      "visualTags": [
        "line",
        "connected-nodes",
        "people",
        "structured",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "strategy-section",
        "service-card",
        "support-card"
      ],
      "rawBestSectionUse": "process-step, strategy-section, service-card, support-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"strategy-alignment\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion, route-intelligence, coordination, strategy\" data-jsi-category=\"strategy-alignment\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "alignment",
        "balanced",
        "black-stroke",
        "completion",
        "connected-nodes",
        "container-eligible",
        "coordination",
        "excellent",
        "execution-support",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "icon-11-japansolved-process-strategy-alignment-structured-coordination",
        "line",
        "managed-route",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-strategy-alignment-connected-nodes",
        "outcome-control",
        "outline-medium",
        "people",
        "planning",
        "premium-monoline",
        "primary-default",
        "process-coordination-01",
        "process-step",
        "recommended-boxed-or-free",
        "route-intelligence",
        "service-card",
        "strategy",
        "strategy-alignment",
        "strategy-section",
        "structured",
        "structured-coordination-nodes",
        "support-card",
        "team-flow"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0030",
      "sequence": 30,
      "filename": "icon-12-japansolved-process-execution-support-controlled-delivery.svg",
      "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-12-japansolved-process-execution-support-controlled-delivery.svg?v=1777825363",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-execution-support-check-circle",
      "rotationGroup": "process-delivery-01",
      "cleanLabel": "Controlled Delivery Check",
      "primaryCategory": "execution-support",
      "categoryTokens": [
        "execution-support"
      ],
      "purposeTags": [
        "support",
        "delivery",
        "execution",
        "completion",
        "controlled-handoff"
      ],
      "visualTags": [
        "line",
        "check-circle",
        "clean",
        "completion",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "support-card",
        "product-card",
        "outcome-section"
      ],
      "rawBestSectionUse": "process-step, support-card, product-card, outcome-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"execution-support\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, execution-support, outcome-control, completion\" data-jsi-category=\"execution-support\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "cargo-execution",
        "check-circle",
        "clean",
        "completion",
        "container-risk",
        "controlled-delivery-check",
        "controlled-handoff",
        "delivery",
        "double-frame-risk",
        "excellent",
        "execution",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "icon-12-japansolved-process-execution-support-controlled-delivery",
        "line",
        "local-representation",
        "logistics-local-representation",
        "medium",
        "morphology-circle",
        "numbered-general-icon-set",
        "numbered-general-icon-set-execution-support-check-circle",
        "outcome-control",
        "outcome-section",
        "outline-medium",
        "premium-monoline",
        "process-delivery-01",
        "process-step",
        "product-card",
        "recommended-free-only",
        "secondary-variant",
        "support",
        "support-card"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0031",
      "sequence": 31,
      "filename": "icon-13-japansolved-values-discreet-confidential-shield.svg",
      "handle": "icon-13-japansolved-values-discreet-confidential-shield",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-13-japansolved-values-discreet-confidential-shield.svg?v=1777825377",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-privacy-discretion-shield",
      "rotationGroup": "value-confidentiality-01",
      "cleanLabel": "Confidential Shield",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "confidential",
        "privacy",
        "value-set",
        "protection",
        "sensitive-cases"
      ],
      "visualTags": [
        "line",
        "shield",
        "layered",
        "formal",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "boundary-note",
        "sensitive-case-card",
        "confirmation-line"
      ],
      "rawBestSectionUse": "trust-card, boundary-note, sensitive-case-card, confirmation-line",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 3,
      "categoryRank": 5,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "boundary-note",
        "client-briefing",
        "confidential",
        "confidential-shield",
        "confirmation-line",
        "container-eligible",
        "discretion",
        "excellent",
        "formal",
        "good-with-ivory-plate-or-css-filter",
        "icon-13-japansolved-values-discreet-confidential-shield",
        "layered",
        "line",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-privacy-discretion-shield",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "privacy",
        "privacy-discretion",
        "privacy-routing",
        "protection",
        "quiet",
        "recommended-boxed-or-free",
        "secondary-variant",
        "sensitive-case-card",
        "sensitive-cases",
        "sensitive-discreet-routing",
        "shield",
        "thin-to-medium",
        "trust-card",
        "trust-protection",
        "trust-symbol",
        "value-confidentiality-01",
        "value-set"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0032",
      "sequence": 32,
      "filename": "icon-14-a-japansolved-values-professional-structured-authority.svg",
      "handle": "icon-14-a-japansolved-values-professional-structured-authority",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-14-a-japansolved-values-professional-structured-authority.svg?v=1777825382",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-professional-authority-columns",
      "rotationGroup": "authority-structured-01",
      "cleanLabel": "Structured Authority Columns",
      "primaryCategory": "professional-authority",
      "categoryTokens": [
        "professional-authority"
      ],
      "purposeTags": [
        "authority",
        "professional",
        "institutional",
        "formal",
        "trust"
      ],
      "visualTags": [
        "line",
        "columns",
        "formal",
        "institutional",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "credentials-strip",
        "professional-section",
        "faq-row"
      ],
      "rawBestSectionUse": "trust-card, credentials-strip, professional-section, FAQ-row",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 03",
      "notes": "Harvested from screenshot 03; Shopify filename is middle-truncated in screenshot, verify full handle from URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"professional-authority\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"professional-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "authority",
        "authority-signal",
        "authority-structured-01",
        "balanced",
        "black-stroke",
        "client-briefing",
        "columns",
        "container-eligible",
        "credentials-strip",
        "excellent",
        "faq-row",
        "formal",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "icon-14-a-japansolved-values-professional-structured-authority",
        "institutional",
        "line",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-professional-authority-columns",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "premium-trust",
        "primary-default",
        "professional",
        "professional-authority",
        "professional-section",
        "quiet",
        "recommended-boxed-or-free",
        "reserved-access",
        "structured-authority-columns",
        "thin-to-medium",
        "trust",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0033",
      "sequence": 33,
      "filename": "icon-14-b-japansolved-values-professional-structured-authority.svg",
      "handle": "icon-14-b-japansolved-values-professional-structured-authority",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-14-b-japansolved-values-professional-structured-authority.svg?v=1777825387",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-professional-authority-classical-column",
      "rotationGroup": "authority-structured-02",
      "cleanLabel": "Structured Authority Pillar",
      "primaryCategory": "professional-authority",
      "categoryTokens": [
        "professional-authority"
      ],
      "purposeTags": [
        "authority",
        "professional",
        "institutional-trust",
        "formal-structure",
        "credibility"
      ],
      "visualTags": [
        "line",
        "classical-column",
        "formal",
        "institutional",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "credentials-strip",
        "professional-section",
        "faq-row"
      ],
      "rawBestSectionUse": "trust-card, credentials-strip, professional-section, FAQ-row",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"professional-authority\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"professional-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "authority",
        "authority-signal",
        "authority-structured-02",
        "balanced",
        "black-stroke",
        "classical-column",
        "client-briefing",
        "container-eligible",
        "credentials-strip",
        "credibility",
        "excellent",
        "faq-row",
        "formal",
        "formal-structure",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "icon-14-b-japansolved-values-professional-structured-authority",
        "institutional",
        "institutional-trust",
        "line",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-professional-authority-classical-column",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "premium-trust",
        "professional",
        "professional-authority",
        "professional-section",
        "quiet",
        "recommended-boxed-or-free",
        "reserved-access",
        "secondary-variant",
        "structured-authority-pillar",
        "thin-to-medium",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0034",
      "sequence": 34,
      "filename": "icon-14-c-japansolved-values-professional-structured-authority.svg",
      "handle": "icon-14-c-japansolved-values-professional-structured-authority",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-14-c-japansolved-values-professional-structured-authority.svg?v=1777825393",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-professional-authority-temple",
      "rotationGroup": "authority-structured-03",
      "cleanLabel": "Structured Authority Institution",
      "primaryCategory": "professional-authority",
      "categoryTokens": [
        "professional-authority"
      ],
      "purposeTags": [
        "authority",
        "governance",
        "professional",
        "institutional",
        "formal-trust"
      ],
      "visualTags": [
        "line",
        "temple",
        "columns",
        "formal",
        "institutional",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "credentials-strip",
        "professional-section",
        "related-card"
      ],
      "rawBestSectionUse": "trust-card, credentials-strip, professional-section, related-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 3,
      "categoryRank": 4,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"professional-authority\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"professional-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "authority",
        "authority-signal",
        "authority-structured-03",
        "balanced",
        "black-stroke",
        "client-briefing",
        "columns",
        "container-eligible",
        "credentials-strip",
        "excellent",
        "formal",
        "formal-trust",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "governance",
        "icon-14-c-japansolved-values-professional-structured-authority",
        "institutional",
        "line",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-professional-authority-temple",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "premium-trust",
        "professional",
        "professional-authority",
        "professional-section",
        "quiet",
        "recommended-boxed-or-free",
        "related-card",
        "reserved-access",
        "secondary-variant",
        "structured-authority-institution",
        "temple",
        "thin-to-medium",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0035",
      "sequence": 35,
      "filename": "icon-15-japansolved-values-results-driven-target-precision.svg",
      "handle": "icon-15-japansolved-values-results-driven-target-precision",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-15-japansolved-values-results-driven-target-precision.svg?v=1777825398",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-results-outcomes-target",
      "rotationGroup": "target-precision-01",
      "cleanLabel": "Value Driven Target Precision",
      "primaryCategory": "results-outcomes",
      "categoryTokens": [
        "results-outcomes"
      ],
      "purposeTags": [
        "target-precision",
        "results",
        "focus",
        "route-accuracy",
        "value-driven-selection"
      ],
      "visualTags": [
        "line",
        "target",
        "arrow",
        "precision",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "outcome-section",
        "review-card",
        "proof-card"
      ],
      "rawBestSectionUse": "process-step, outcome-section, review-card, proof-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"results-outcomes\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, execution-support, outcome-control, completion\" data-jsi-category=\"results-outcomes\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "arrow",
        "balanced",
        "black-stroke",
        "case-intake",
        "completion",
        "container-risk",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "focus",
        "good-with-ivory-plate-or-css-filter",
        "icon-15-japansolved-values-results-driven-target-precision",
        "line",
        "medium",
        "morphology-circle-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-results-outcomes-target",
        "outcome-control",
        "outcome-section",
        "outline-medium",
        "paid-review",
        "precision",
        "premium-monoline",
        "primary-default",
        "process-step",
        "proof-card",
        "recommended-free-only",
        "results",
        "results-outcomes",
        "review-card",
        "review-intelligence",
        "route-accuracy",
        "suitability-check",
        "target",
        "target-precision",
        "target-precision-01",
        "value-driven-selection",
        "value-driven-target-precision"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0036",
      "sequence": 36,
      "filename": "icon-16-a-japansolved-tiers-standard-engagement-comprehensive-solutions.svg",
      "handle": "icon-16-a-japansolved-tiers-standard-engagement-comprehensive-solutions",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-16-a-japansolved-tiers-standard-engagement-comprehensive-solutions.svg?v=1777825402",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-comprehensive-solutions-compass",
      "rotationGroup": "comprehensive-solutions-01",
      "cleanLabel": "Comprehensive Solutions Compass A",
      "primaryCategory": "comprehensive-solutions",
      "categoryTokens": [
        "comprehensive-solutions"
      ],
      "purposeTags": [
        "comprehensive-solutions",
        "route-mapping",
        "multi-route-support",
        "strategic-direction"
      ],
      "visualTags": [
        "line",
        "compass",
        "directional",
        "filled-accents",
        "black-stroke"
      ],
      "sectionFit": [
        "hub-card",
        "service-card",
        "process-step",
        "related-card"
      ],
      "rawBestSectionUse": "hub-card, service-card, process-step, related-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"comprehensive-solutions\" data-jsi-section=\"hub-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"comprehensive-solutions\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "compass",
        "completion",
        "comprehensive-solutions",
        "comprehensive-solutions-01",
        "comprehensive-solutions-compass-a",
        "container-risk",
        "directional",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "filled-accents",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "hub-card",
        "icon-16-a-japansolved-tiers-standard-engagement-comprehensive-solutions",
        "line",
        "medium",
        "morphology-circle-risk",
        "multi-route-support",
        "numbered-general-icon-set",
        "numbered-general-icon-set-comprehensive-solutions-compass",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "process-step",
        "recommended-free-only",
        "related-card",
        "route-mapping",
        "secondary-variant",
        "service-card",
        "strategic-direction"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "heavy",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0037",
      "sequence": 37,
      "filename": "icon-16-b-japansolved-tiers-standard-engagement-comprehensive-solutions.svg",
      "handle": "icon-16-b-japansolved-tiers-standard-engagement-comprehensive-solutions",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-16-b-japansolved-tiers-standard-engagement-comprehensive-solutions.svg?v=1777825407",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-comprehensive-solutions-compass",
      "rotationGroup": "comprehensive-solutions-02",
      "cleanLabel": "Comprehensive Solutions Compass B",
      "primaryCategory": "comprehensive-solutions",
      "categoryTokens": [
        "comprehensive-solutions"
      ],
      "purposeTags": [
        "comprehensive-solutions",
        "navigation",
        "route-intelligence",
        "options-mapping"
      ],
      "visualTags": [
        "line",
        "compass",
        "directional",
        "heritage",
        "black-stroke"
      ],
      "sectionFit": [
        "hub-card",
        "service-card",
        "process-step",
        "related-card"
      ],
      "rawBestSectionUse": "hub-card, service-card, process-step, related-card",
      "styleFamily": [
        "premium-monoline",
        "japan-cultural-symbol"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 3,
      "categoryRank": 3,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"comprehensive-solutions\" data-jsi-section=\"hub-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence\" data-jsi-category=\"comprehensive-solutions\" data-jsi-style=\"premium-monoline, japan-cultural-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "compass",
        "comprehensive-solutions",
        "comprehensive-solutions-02",
        "comprehensive-solutions-compass-b",
        "container-risk",
        "directional",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "heritage",
        "hub-card",
        "icon-16-b-japansolved-tiers-standard-engagement-comprehensive-solutions",
        "intelligence",
        "japan-cultural-symbol",
        "line",
        "medium",
        "morphology-circle-risk",
        "navigation",
        "numbered-general-icon-set",
        "numbered-general-icon-set-comprehensive-solutions-compass",
        "options-mapping",
        "outline-medium",
        "premium-monoline",
        "process-step",
        "recommended-free-only",
        "related-card",
        "review-intelligence",
        "review-routing",
        "route-intelligence",
        "secondary-variant",
        "service-card"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0038",
      "sequence": 38,
      "filename": "icon-16-c-japansolved-tiers-standard-engagement-comprehensive-solutions.svg",
      "handle": "icon-16-c-japansolved-tiers-standard-engagement-comprehensive-solutions",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-16-c-japansolved-tiers-standard-engagement-comprehensive-solutions.svg?v=1777825407",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-comprehensive-solutions-compass",
      "rotationGroup": "comprehensive-solutions-03",
      "cleanLabel": "Comprehensive Solutions Compass C",
      "primaryCategory": "comprehensive-solutions",
      "categoryTokens": [
        "comprehensive-solutions"
      ],
      "purposeTags": [
        "comprehensive-solutions",
        "orientation",
        "route-mapping",
        "cultural-navigation"
      ],
      "visualTags": [
        "line",
        "compass",
        "star",
        "directional",
        "black-stroke"
      ],
      "sectionFit": [
        "hub-card",
        "service-card",
        "process-step",
        "navigation-section"
      ],
      "rawBestSectionUse": "hub-card, service-card, process-step, navigation-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 4,
      "categoryRank": 4,
      "designFamilyRank": 3,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"comprehensive-solutions\" data-jsi-section=\"hub-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"comprehensive-solutions\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "balanced",
        "black-stroke",
        "compass",
        "comprehensive-solutions",
        "comprehensive-solutions-03",
        "comprehensive-solutions-compass-c",
        "concierge-presence",
        "container-risk",
        "cultural-navigation",
        "directional",
        "double-frame-risk",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "hub-card",
        "icon-16-c-japansolved-tiers-standard-engagement-comprehensive-solutions",
        "line",
        "medium",
        "morphology-circle-risk",
        "navigation-section",
        "numbered-general-icon-set",
        "numbered-general-icon-set-comprehensive-solutions-compass",
        "orientation",
        "outline-medium",
        "premium-monoline",
        "process-step",
        "recommended-free-only",
        "rotation-fallback",
        "route-mapping",
        "service-card",
        "star",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0039",
      "sequence": 39,
      "filename": "icon-16-d-japansolved-tiers-standard-engagement-comprehensive-solutions.svg",
      "handle": "icon-16-d-japansolved-tiers-standard-engagement-comprehensive-solutions",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-16-d-japansolved-tiers-standard-engagement-comprehensive-solutions.svg?v=1777825411",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-comprehensive-solutions-compass",
      "rotationGroup": "comprehensive-solutions-04",
      "cleanLabel": "Comprehensive Solutions Compass D",
      "primaryCategory": "comprehensive-solutions",
      "categoryTokens": [
        "comprehensive-solutions"
      ],
      "purposeTags": [
        "comprehensive-solutions",
        "route-control",
        "direction",
        "decision-support"
      ],
      "visualTags": [
        "line",
        "compass",
        "bold-center",
        "directional",
        "black-stroke"
      ],
      "sectionFit": [
        "hub-card",
        "service-card",
        "process-step",
        "strategy-section"
      ],
      "rawBestSectionUse": "hub-card, service-card, process-step, strategy-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 5,
      "categoryRank": 5,
      "designFamilyRank": 4,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"comprehensive-solutions\" data-jsi-section=\"hub-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion, route-intelligence, coordination, strategy\" data-jsi-category=\"comprehensive-solutions\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "bold-center",
        "compass",
        "completion",
        "comprehensive-solutions",
        "comprehensive-solutions-04",
        "comprehensive-solutions-compass-d",
        "container-risk",
        "coordination",
        "decision-support",
        "direction",
        "directional",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "hub-card",
        "icon-16-d-japansolved-tiers-standard-engagement-comprehensive-solutions",
        "line",
        "medium",
        "morphology-circle-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-comprehensive-solutions-compass",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "process-step",
        "recommended-free-only",
        "rotation-fallback",
        "route-control",
        "route-intelligence",
        "service-card",
        "strategy",
        "strategy-section"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0040",
      "sequence": 40,
      "filename": "icon-16-e-japansolved-tiers-standard-engagement-comprehensive-solutions.svg",
      "handle": "icon-16-e-japansolved-tiers-standard-engagement-comprehensive-solutions",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-16-e-japansolved-tiers-standard-engagement-comprehensive-solutions.svg?v=1777825414",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-comprehensive-solutions-eight-point-star",
      "rotationGroup": "comprehensive-solutions-05",
      "cleanLabel": "Comprehensive Solutions Star",
      "primaryCategory": "comprehensive-solutions",
      "categoryTokens": [
        "comprehensive-solutions"
      ],
      "purposeTags": [
        "comprehensive-solutions",
        "orientation",
        "priority-route",
        "decision-clarity"
      ],
      "visualTags": [
        "line",
        "eight-point-star",
        "compass-star",
        "minimal",
        "black-stroke"
      ],
      "sectionFit": [
        "hub-card",
        "service-card",
        "trust-card",
        "micro-badge"
      ],
      "rawBestSectionUse": "hub-card, service-card, trust-card, micro-badge",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "general-service-support"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "minimal",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 65.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"comprehensive-solutions\" data-jsi-section=\"hub-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"general-service-support\" data-jsi-category=\"comprehensive-solutions\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "black-stroke",
        "compass-star",
        "comprehensive-solutions",
        "comprehensive-solutions-05",
        "comprehensive-solutions-star",
        "container-risk",
        "decision-clarity",
        "double-frame-risk",
        "eight-point-star",
        "excellent",
        "general-japansolved-system",
        "general-service-support",
        "good-with-ivory-plate-or-css-filter",
        "hub-card",
        "icon-16-e-japansolved-tiers-standard-engagement-comprehensive-solutions",
        "line",
        "medium",
        "micro-badge",
        "minimal",
        "morphology-circle",
        "numbered-general-icon-set",
        "numbered-general-icon-set-comprehensive-solutions-eight-point-star",
        "orientation",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "priority-route",
        "recommended-free-only",
        "service-card",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0041",
      "sequence": 41,
      "filename": "icon-16-japansolved-tiers-standard-engagement-comprehensive-solutions.svg",
      "handle": "icon-16-japansolved-tiers-standard-engagement-comprehensive-solutions",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-16-japansolved-tiers-standard-engagement-comprehensive-solutions.svg?v=1777825415",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-service-tier-compass",
      "rotationGroup": "service-tier-comprehensive-01",
      "cleanLabel": "Tier Comprehensive Solutions",
      "primaryCategory": "service-tier",
      "categoryTokens": [
        "service-tier"
      ],
      "purposeTags": [
        "tier",
        "comprehensive-solutions",
        "full-support",
        "premium-route",
        "bundled-pathway"
      ],
      "visualTags": [
        "line",
        "compass",
        "four-point-star",
        "circular-frame",
        "black-stroke"
      ],
      "sectionFit": [
        "pricing-tier",
        "service-tier-card",
        "hub-card",
        "product-ladder"
      ],
      "rawBestSectionUse": "pricing-tier, service-tier-card, hub-card, product-ladder",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 4,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"service-tier\" data-jsi-section=\"pricing-tier\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"service-tier\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "authority-signal",
        "balanced",
        "black-stroke",
        "bundled-pathway",
        "circular-frame",
        "compass",
        "completion",
        "comprehensive-solutions",
        "container-risk",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "four-point-star",
        "full-support",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "hub-card",
        "icon-16-japansolved-tiers-standard-engagement-comprehensive-solutions",
        "line",
        "medium",
        "morphology-circle",
        "numbered-general-icon-set",
        "numbered-general-icon-set-service-tier-compass",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "premium-route",
        "premium-trust",
        "pricing-tier",
        "primary-default",
        "product-ladder",
        "recommended-free-only",
        "reserved-access",
        "sequence-badge",
        "service-tier",
        "service-tier-card",
        "service-tier-comprehensive-01",
        "tier",
        "tier-comprehensive-solutions"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0042",
      "sequence": 42,
      "filename": "icon-17-a-japansolved-tiers-private-access-retainer-priority.svg",
      "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-17-a-japansolved-tiers-private-access-retainer-priority.svg?v=1777825419",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-retainer-priority-key",
      "rotationGroup": "retainer-priority-01",
      "cleanLabel": "Access Retainer Priority Key A",
      "primaryCategory": "retainer-priority",
      "categoryTokens": [
        "retainer-priority"
      ],
      "purposeTags": [
        "retainer",
        "priority-access",
        "key",
        "reserved-access",
        "private-desk"
      ],
      "visualTags": [
        "line",
        "key",
        "simple",
        "circular-bow",
        "black-stroke"
      ],
      "sectionFit": [
        "retainer-card",
        "pricing-tier",
        "private-access-card",
        "cta-support"
      ],
      "rawBestSectionUse": "retainer-card, pricing-tier, private-access-card, CTA-support",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"retainer-priority\" data-jsi-section=\"retainer-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, execution-support, outcome-control, completion\" data-jsi-category=\"retainer-priority\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "access-retainer-priority-key-a",
        "balanced",
        "black-stroke",
        "circular-bow",
        "completion",
        "concierge-presence",
        "container-risk",
        "cta-support",
        "cultural-navigation",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "icon-17-a-japansolved-tiers-private-access-retainer-priority",
        "key",
        "line",
        "medium",
        "morphology-circle",
        "numbered-general-icon-set",
        "numbered-general-icon-set-retainer-priority-key",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "pricing-tier",
        "primary-default",
        "priority-access",
        "private-access-card",
        "private-desk",
        "recommended-free-only",
        "reserved-access",
        "retainer",
        "retainer-card",
        "retainer-priority",
        "retainer-priority-01",
        "sequence-badge",
        "simple",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0043",
      "sequence": 43,
      "filename": "icon-17-b-japansolved-tiers-private-access-retainer-priority.svg",
      "handle": "icon-17-b-japansolved-tiers-private-access-retainer-priority",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-17-b-japansolved-tiers-private-access-retainer-priority.svg?v=1777825421",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-retainer-priority-key",
      "rotationGroup": "retainer-priority-02",
      "cleanLabel": "Access Retainer Priority Key B",
      "primaryCategory": "retainer-priority",
      "categoryTokens": [
        "retainer-priority"
      ],
      "purposeTags": [
        "retainer",
        "priority-access",
        "key",
        "reserved-route",
        "client-priority"
      ],
      "visualTags": [
        "line",
        "key",
        "classic",
        "access-symbol",
        "black-stroke"
      ],
      "sectionFit": [
        "retainer-card",
        "pricing-tier",
        "private-access-card",
        "product-ladder"
      ],
      "rawBestSectionUse": "retainer-card, pricing-tier, private-access-card, product-ladder",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"retainer-priority\" data-jsi-section=\"retainer-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"retainer-priority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "access-retainer-priority-key-b",
        "access-symbol",
        "balanced",
        "black-stroke",
        "classic",
        "client-priority",
        "concierge-presence",
        "container-eligible",
        "cultural-navigation",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-17-b-japansolved-tiers-private-access-retainer-priority",
        "key",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-retainer-priority-key",
        "outline-medium",
        "premium-monoline",
        "pricing-tier",
        "priority-access",
        "private-access-card",
        "product-ladder",
        "recommended-boxed-or-free",
        "reserved-route",
        "retainer",
        "retainer-card",
        "retainer-priority",
        "retainer-priority-02",
        "secondary-variant",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0044",
      "sequence": 44,
      "filename": "icon-18-japansolved-tiers-discreet-confidential-maximum-discretion.svg",
      "handle": "icon-18-japansolved-tiers-discreet-confidential-maximum-discretion",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/icon-18-japansolved-tiers-discreet-confidential-maximum-discretion.svg?v=1777825423",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-privacy-discretion-eye",
      "rotationGroup": "service-tier-discretion-01",
      "cleanLabel": "Tier Maximum Discretion Eye",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "maximum-discretion",
        "confidential-handling",
        "privacy",
        "sensitive-cases",
        "tier"
      ],
      "visualTags": [
        "line",
        "eye",
        "discreet",
        "minimal",
        "black-stroke"
      ],
      "sectionFit": [
        "pricing-tier",
        "sensitive-case-card",
        "trust-card",
        "intake-choice"
      ],
      "rawBestSectionUse": "pricing-tier, sensitive-case-card, trust-card, intake-choice",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "minimal",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 64.0,
      "familyCategoryRank": 1,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 04",
      "notes": "Harvested from screenshot 04; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL; file type SVG. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"pricing-tier\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "black-stroke",
        "client-briefing",
        "confidential-handling",
        "container-eligible",
        "discreet",
        "discretion",
        "excellent",
        "eye",
        "good-with-ivory-plate-or-css-filter",
        "icon-18-japansolved-tiers-discreet-confidential-maximum-discretion",
        "intake-choice",
        "line",
        "maximum-discretion",
        "minimal",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-privacy-discretion-eye",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "pricing-tier",
        "primary-default",
        "privacy",
        "privacy-discretion",
        "privacy-routing",
        "quiet",
        "recommended-boxed-or-free",
        "sensitive-case-card",
        "sensitive-cases",
        "sensitive-discreet-routing",
        "service-tier-discretion-01",
        "thin-to-medium",
        "tier",
        "tier-maximum-discretion-eye",
        "trust-card",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0045",
      "sequence": 45,
      "filename": "Japansolved-Solutions-ICON_DISCREET_SENSITIVE-Secured-Confidential-Barrier-Monoline.svg",
      "handle": "japansolved-solutions-icon-discreet-sensitive-secured-confidential-barrier-monoline",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Japansolved-Solutions-ICON_DISCREET_SENSITIVE-Secured-Confidential-Barrier-Monoline.svg?v=1778049194",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-privacy-discretion-monoline",
      "rotationGroup": "monoline-confidential-barrier-01",
      "cleanLabel": "Confidential Barrier Monoline",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "confidential-barrier",
        "privacy",
        "sensitive-handling",
        "protected-route",
        "restricted-visibility"
      ],
      "visualTags": [
        "monoline",
        "shield",
        "barrier",
        "discreet",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "boundary-note",
        "sensitive-case-card",
        "intake-confirmation"
      ],
      "rawBestSectionUse": "trust-card, boundary-note, sensitive-case-card, intake-confirmation",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 6,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 05",
      "notes": "Harvested from screenshot 05; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "barrier",
        "black-stroke",
        "boundary-note",
        "client-briefing",
        "confidential-barrier",
        "confidential-barrier-monoline",
        "container-eligible",
        "discreet",
        "discretion",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "japansolved-solutions-icon-discreet-sensitive-secured-confidential-barrier-monoline",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-privacy-discretion-monoline",
        "monoline",
        "monoline-confidential-barrier-01",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "privacy",
        "privacy-discretion",
        "privacy-routing",
        "protected-route",
        "quiet",
        "recommended-boxed-or-free",
        "restricted-visibility",
        "secondary-variant",
        "sensitive-case-card",
        "sensitive-discreet-routing",
        "sensitive-handling",
        "shield",
        "thin-to-medium",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0046",
      "sequence": 46,
      "filename": "Japansolved-Solutions-ICON_DISCREET_SENSITIVE-Verified-Protection-Shield-Monoline.svg",
      "handle": "japansolved-solutions-icon-discreet-sensitive-verified-protection-shield-monoline",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Japansolved-Solutions-ICON_DISCREET_SENSITIVE-Verified-Protection-Shield-Monoline.svg?v=1778049194",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-privacy-discretion-monoline",
      "rotationGroup": "monoline-protection-shield-01",
      "cleanLabel": "Protection Shield Monoline",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "protection",
        "shield",
        "safeguarding",
        "trust",
        "secure-handling"
      ],
      "visualTags": [
        "monoline",
        "shield",
        "checkmark",
        "clean",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "confirmation-line",
        "intake-confirmation",
        "faq-row"
      ],
      "rawBestSectionUse": "trust-card, confirmation-line, intake-confirmation, FAQ-row",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 3,
      "categoryRank": 7,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 05",
      "notes": "Harvested from screenshot 05; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "checkmark",
        "clean",
        "client-briefing",
        "confirmation-line",
        "container-eligible",
        "discretion",
        "excellent",
        "faq-row",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "japansolved-solutions-icon-discreet-sensitive-verified-protection-shield-monoline",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-privacy-discretion-monoline",
        "monoline",
        "monoline-protection-shield-01",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "privacy-discretion",
        "privacy-routing",
        "protection",
        "protection-shield-monoline",
        "quiet",
        "recommended-boxed-or-free",
        "safeguarding",
        "secondary-variant",
        "secure-handling",
        "sensitive-discreet-routing",
        "shield",
        "thin-to-medium",
        "trust",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0047",
      "sequence": 47,
      "filename": "Japansolved-Solutions-ICON_ADVISORY_INTELLIGENCE-Precision-Target-Monoline.svg",
      "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Japansolved-Solutions-ICON_ADVISORY_INTELLIGENCE-Precision-Target-Monoline.svg?v=1778049195",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-results-outcomes-monoline",
      "rotationGroup": "monoline-precision-target-01",
      "cleanLabel": "Precision Target Monoline",
      "primaryCategory": "results-outcomes",
      "categoryTokens": [
        "results-outcomes"
      ],
      "purposeTags": [
        "precision",
        "target",
        "outcomes",
        "route-accuracy",
        "decision-clarity"
      ],
      "visualTags": [
        "monoline",
        "target",
        "arrow",
        "precision",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "outcome-section",
        "review-card",
        "proof-card"
      ],
      "rawBestSectionUse": "process-step, outcome-section, review-card, proof-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 05",
      "notes": "Harvested from screenshot 05; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"results-outcomes\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, execution-support, outcome-control, completion\" data-jsi-category=\"results-outcomes\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "arrow",
        "balanced",
        "black-stroke",
        "case-intake",
        "completion",
        "container-eligible",
        "decision-clarity",
        "excellent",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-results-outcomes-monoline",
        "medium",
        "monoline",
        "monoline-precision-target-01",
        "morphology-none",
        "no-double-frame-risk",
        "outcome-control",
        "outcome-section",
        "outcomes",
        "outline-medium",
        "paid-review",
        "precision",
        "precision-target-monoline",
        "premium-monoline",
        "primary-default",
        "process-step",
        "proof-card",
        "recommended-boxed-or-free",
        "results-outcomes",
        "review-card",
        "review-intelligence",
        "route-accuracy",
        "suitability-check",
        "target"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0048",
      "sequence": 48,
      "filename": "Japansolved-Solutions-ICON_DISCREET_SENSITIVE-Private-Observation-Restricted-Monoline.svg",
      "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Japansolved-Solutions-ICON_DISCREET_SENSITIVE-Private-Observation-Restricted-Monoline.svg?v=1778049195",
      "assetType": "svg",
      "assetFamily": "JapanSolved Solutions Monoline Icons",
      "familyKey": "japansolved-solutions-monoline-icons-privacy-discretion-monoline",
      "rotationGroup": "monoline-restricted-access-01",
      "cleanLabel": "Restricted Access Monoline",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "restricted-access",
        "boundary",
        "discretion",
        "eligibility",
        "sensitive-route"
      ],
      "visualTags": [
        "monoline",
        "restricted",
        "crossed-target",
        "discreet",
        "black-stroke"
      ],
      "sectionFit": [
        "boundary-note",
        "suitability-gate",
        "sensitive-case-card",
        "faq-row"
      ],
      "rawBestSectionUse": "boundary-note, suitability-gate, sensitive-case-card, FAQ-row",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 4,
      "categoryRank": 8,
      "designFamilyRank": 3,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 05",
      "notes": "Harvested from screenshot 05; Shopify filename is middle-truncated in screenshot, verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"boundary-note\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, paid-review, case-intake, suitability-check\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "boundary",
        "boundary-note",
        "case-intake",
        "container-eligible",
        "crossed-target",
        "discreet",
        "discretion",
        "eligibility",
        "excellent",
        "faq-row",
        "good-with-ivory-plate-or-css-filter",
        "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
        "japansolved-solutions-monoline-icons",
        "japansolved-solutions-monoline-icons-privacy-discretion-monoline",
        "monoline",
        "monoline-restricted-access-01",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "paid-review",
        "premium-monoline",
        "privacy-discretion",
        "privacy-routing",
        "quiet",
        "recommended-boxed-or-free",
        "restricted",
        "restricted-access",
        "restricted-access-monoline",
        "rotation-fallback",
        "sensitive-case-card",
        "sensitive-route",
        "suitability-check",
        "suitability-gate",
        "thin-to-medium",
        "travel-cultural-access",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0049",
      "sequence": 49,
      "filename": "Icon-11-JapanSolved-Feasibility-Assessment.svg",
      "handle": "icon-11-japansolved-feasibility-assessment",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-11-JapanSolved-Feasibility-Assessment.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-feasibility-assessment-globe",
      "rotationGroup": "feasibility-assessment-01",
      "cleanLabel": "Feasibility Assessment Globe",
      "primaryCategory": "feasibility-assessment",
      "categoryTokens": [
        "feasibility-assessment"
      ],
      "purposeTags": [
        "feasibility",
        "assessment",
        "route-viability",
        "due-diligence",
        "screening"
      ],
      "visualTags": [
        "line",
        "globe",
        "grid",
        "global",
        "black-stroke"
      ],
      "sectionFit": [
        "review-card",
        "intelligence-block",
        "process-step",
        "trust-card"
      ],
      "rawBestSectionUse": "review-card, intelligence-block, process-step, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"feasibility-assessment\" data-jsi-section=\"review-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"feasibility-assessment\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "assessment",
        "balanced",
        "black-stroke",
        "container-eligible",
        "discretion",
        "due-diligence",
        "excellent",
        "feasibility",
        "feasibility-assessment",
        "feasibility-assessment-01",
        "feasibility-assessment-globe",
        "global",
        "globe",
        "good-with-ivory-plate-or-css-filter",
        "grid",
        "icon-11-japansolved-feasibility-assessment",
        "intelligence",
        "intelligence-block",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-feasibility-assessment-globe",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-step",
        "recommended-boxed-or-free",
        "review-card",
        "review-intelligence",
        "review-routing",
        "route-viability",
        "screening",
        "trust-card",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0050",
      "sequence": 50,
      "filename": "Icon-12-JapanSolved-Strategic-Alignment.svg",
      "handle": "icon-12-japansolved-strategic-alignment",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-12-JapanSolved-Strategic-Alignment.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-strategy-alignment-crosshair",
      "rotationGroup": "strategic-alignment-02",
      "cleanLabel": "Strategic Alignment Target",
      "primaryCategory": "strategy-alignment",
      "categoryTokens": [
        "strategy-alignment"
      ],
      "purposeTags": [
        "strategic-alignment",
        "targeting",
        "route-fit",
        "planning",
        "decision-clarity"
      ],
      "visualTags": [
        "line",
        "crosshair",
        "target",
        "precision",
        "black-stroke"
      ],
      "sectionFit": [
        "strategy-section",
        "process-step",
        "review-card",
        "service-card"
      ],
      "rawBestSectionUse": "strategy-section, process-step, review-card, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"strategy-alignment\" data-jsi-section=\"strategy-section\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, execution-support, outcome-control, completion\" data-jsi-category=\"strategy-alignment\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "case-intake",
        "completion",
        "container-eligible",
        "crosshair",
        "decision-clarity",
        "excellent",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "icon-12-japansolved-strategic-alignment",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-strategy-alignment-crosshair",
        "outcome-control",
        "outline-medium",
        "paid-review",
        "planning",
        "precision",
        "premium-monoline",
        "process-step",
        "recommended-boxed-or-free",
        "review-card",
        "review-intelligence",
        "route-fit",
        "secondary-variant",
        "service-card",
        "strategic-alignment",
        "strategic-alignment-02",
        "strategic-alignment-target",
        "strategy-alignment",
        "strategy-section",
        "suitability-check",
        "target",
        "targeting"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0051",
      "sequence": 51,
      "filename": "Icon-08-JapanSolved-EngagementBrief-Stage-Marker-5.svg",
      "handle": "icon-08-japansolved-engagementbrief-stage-marker-5",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-08-JapanSolved-EngagementBrief-Stage-Marker-5.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-engagement-brief-number-badge",
      "rotationGroup": "engagement-brief-stage-05",
      "cleanLabel": "Engagement Brief Stage Marker 5",
      "primaryCategory": "engagement-brief",
      "categoryTokens": [
        "engagement-brief"
      ],
      "purposeTags": [
        "stage-marker",
        "step-five",
        "process-sequence",
        "intake-journey",
        "progress"
      ],
      "visualTags": [
        "line",
        "number-badge",
        "circular",
        "stage-marker",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "stage-marker",
        "intake-sequence",
        "timeline"
      ],
      "rawBestSectionUse": "process-step, stage-marker, intake-sequence, timeline",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 61.0,
      "familyCategoryRank": 3,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"engagement-brief\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing\" data-jsi-category=\"engagement-brief\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "circular",
        "client-briefing",
        "container-risk",
        "double-frame-risk",
        "engagement-brief",
        "engagement-brief-icons",
        "engagement-brief-icons-engagement-brief-number-badge",
        "engagement-brief-stage-05",
        "engagement-brief-stage-marker-5",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-08-japansolved-engagementbrief-stage-marker-5",
        "intake-journey",
        "intake-sequence",
        "line",
        "morphology-circle",
        "native-intake",
        "native-intake-system",
        "number-badge",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "process-sequence",
        "process-step",
        "progress",
        "quiet",
        "recommended-free-only",
        "secondary-variant",
        "sequence-badge",
        "stage-marker",
        "step-five",
        "thin-to-medium",
        "timeline"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0052",
      "sequence": 52,
      "filename": "Icon-02-JapanSolved-EngagementBrief-Structured-Intake.svg",
      "handle": "icon-02-japansolved-engagementbrief-structured-intake",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-02-JapanSolved-EngagementBrief-Structured-Intake.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-intake-request-people",
      "rotationGroup": "engagement-brief-intake-01",
      "cleanLabel": "Engagement Brief Structured Intake",
      "primaryCategory": "intake-request",
      "categoryTokens": [
        "intake-request"
      ],
      "purposeTags": [
        "structured-intake",
        "engagement-brief",
        "client-request",
        "case-file-setup",
        "form"
      ],
      "visualTags": [
        "line",
        "people",
        "onboarding",
        "intake",
        "black-stroke"
      ],
      "sectionFit": [
        "intake",
        "process-step",
        "onboarding-card",
        "request-box"
      ],
      "rawBestSectionUse": "intake, process-step, onboarding-card, request-box",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "sourcing",
        "private-buyer",
        "procurement-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"intake-request\" data-jsi-section=\"intake\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"sourcing, private-buyer, procurement-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"intake-request\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "case-file-setup",
        "client-briefing",
        "client-request",
        "container-eligible",
        "engagement-brief",
        "engagement-brief-icons",
        "engagement-brief-icons-intake-request-people",
        "engagement-brief-intake-01",
        "engagement-brief-structured-intake",
        "excellent",
        "form",
        "good-with-ivory-plate-or-css-filter",
        "icon-02-japansolved-engagementbrief-structured-intake",
        "intake",
        "intake-request",
        "line",
        "morphology-none",
        "native-intake",
        "native-intake-system",
        "no-double-frame-risk",
        "object-cube-package",
        "onboarding",
        "onboarding-card",
        "outline-light",
        "paid-routing",
        "people",
        "premium-monoline",
        "primary-default",
        "private-buyer",
        "process-step",
        "procurement-routing",
        "quiet",
        "recommended-boxed-or-free",
        "request-box",
        "sourcing",
        "structured-intake",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [
          "cube/package object; not a frame, but low-fit in premium boxed UI unless exact"
        ],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "cube/package",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0053",
      "sequence": 53,
      "filename": "Icon-06-JapanSolved-EngagementBrief-Engagement-Preparedness.svg",
      "handle": "icon-06-japansolved-engagementbrief-engagement-preparedness",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-06-JapanSolved-EngagementBrief-Engagement-Preparedness.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-engagement-brief-pencil",
      "rotationGroup": "engagement-preparedness-01",
      "cleanLabel": "Engagement Preparedness Pencil",
      "primaryCategory": "engagement-brief",
      "categoryTokens": [
        "engagement-brief"
      ],
      "purposeTags": [
        "engagement-preparedness",
        "readiness",
        "document-prep",
        "client-preparation",
        "briefing"
      ],
      "visualTags": [
        "line",
        "pencil",
        "preparation",
        "clean",
        "black-stroke"
      ],
      "sectionFit": [
        "intake-prep",
        "process-step",
        "checklist-card",
        "review-card"
      ],
      "rawBestSectionUse": "intake-prep, process-step, checklist-card, review-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"engagement-brief\" data-jsi-section=\"intake-prep\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, native-intake, paid-routing, client-briefing\" data-jsi-category=\"engagement-brief\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "briefing",
        "case-intake",
        "checklist-card",
        "clean",
        "client-briefing",
        "client-preparation",
        "container-eligible",
        "document-prep",
        "engagement-brief",
        "engagement-brief-icons",
        "engagement-brief-icons-engagement-brief-pencil",
        "engagement-preparedness",
        "engagement-preparedness-01",
        "engagement-preparedness-pencil",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-06-japansolved-engagementbrief-engagement-preparedness",
        "intake-prep",
        "line",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-light",
        "paid-review",
        "paid-routing",
        "pencil",
        "premium-monoline",
        "preparation",
        "process-step",
        "quiet",
        "readiness",
        "recommended-boxed-or-free",
        "review-card",
        "review-intelligence",
        "secondary-variant",
        "suitability-check",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0054",
      "sequence": 54,
      "filename": "Icon-05-JapanSolved-EngagementBrief-Professional-Rigor.svg",
      "handle": "icon-05-japansolved-engagementbrief-professional-rigor",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-05-JapanSolved-EngagementBrief-Professional-Rigor.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-professional-authority-scales",
      "rotationGroup": "engagement-professional-rigor-01",
      "cleanLabel": "Engagement Brief Professional Rigor",
      "primaryCategory": "professional-authority",
      "categoryTokens": [
        "professional-authority"
      ],
      "purposeTags": [
        "professional-rigor",
        "standards",
        "review-discipline",
        "fairness",
        "due-care"
      ],
      "visualTags": [
        "line",
        "scales",
        "legal-formal",
        "balanced",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "standards-card",
        "review-card",
        "faq-row"
      ],
      "rawBestSectionUse": "trust-card, standards-card, review-card, FAQ-row",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"professional-authority\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, native-intake, paid-routing, client-briefing\" data-jsi-category=\"professional-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "case-intake",
        "client-briefing",
        "container-eligible",
        "due-care",
        "engagement-brief-icons",
        "engagement-brief-icons-professional-authority-scales",
        "engagement-brief-professional-rigor",
        "engagement-professional-rigor-01",
        "excellent",
        "fairness",
        "faq-row",
        "good-with-ivory-plate-or-css-filter",
        "icon-05-japansolved-engagementbrief-professional-rigor",
        "legal-formal",
        "line",
        "medium",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-medium",
        "paid-review",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "professional-authority",
        "professional-rigor",
        "recommended-boxed-or-free",
        "review-card",
        "review-discipline",
        "review-intelligence",
        "scales",
        "standards",
        "standards-card",
        "suitability-check",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0055",
      "sequence": 55,
      "filename": "Icon-01-JapanSolved-EngagementBrief-Shield-Verification.svg",
      "handle": "icon-01-japansolved-engagementbrief-shield-verification",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-01-JapanSolved-EngagementBrief-Shield-Verification.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-privacy-discretion-shield",
      "rotationGroup": "engagement-shield-verification-01",
      "cleanLabel": "Engagement Brief Shield Verification",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "shield-verification",
        "eligibility-check",
        "safety",
        "trust",
        "suitability"
      ],
      "visualTags": [
        "line",
        "shield",
        "verification",
        "clean",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "intake-confirmation",
        "boundary-note",
        "suitability-gate"
      ],
      "rawBestSectionUse": "trust-card, intake-confirmation, boundary-note, suitability-gate",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 9,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, paid-review, case-intake, suitability-check\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "boundary-note",
        "case-intake",
        "clean",
        "container-eligible",
        "discretion",
        "eligibility-check",
        "engagement-brief-icons",
        "engagement-brief-icons-privacy-discretion-shield",
        "engagement-brief-shield-verification",
        "engagement-shield-verification-01",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-01-japansolved-engagementbrief-shield-verification",
        "intake-confirmation",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "paid-review",
        "premium-monoline",
        "primary-default",
        "privacy-discretion",
        "privacy-routing",
        "quiet",
        "recommended-boxed-or-free",
        "safety",
        "sensitive-discreet-routing",
        "shield",
        "shield-verification",
        "suitability",
        "suitability-check",
        "suitability-gate",
        "thin-to-medium",
        "trust",
        "trust-card",
        "trust-protection",
        "trust-symbol",
        "verification"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0056",
      "sequence": 56,
      "filename": "Icon-07-JapanSolved-EngagementBrief-Case-Workflow.svg",
      "handle": "icon-07-japansolved-engagementbrief-case-workflow",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-07-JapanSolved-EngagementBrief-Case-Workflow.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-case-review-clipboard",
      "rotationGroup": "engagement-case-workflow-01",
      "cleanLabel": "Engagement Brief Case Workflow",
      "primaryCategory": "case-review",
      "categoryTokens": [
        "case-review"
      ],
      "purposeTags": [
        "case-workflow",
        "checklist",
        "engagement-brief",
        "case-file-routing",
        "process-control"
      ],
      "visualTags": [
        "line",
        "clipboard",
        "checklist",
        "workflow",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "review-card",
        "intake",
        "workflow-section"
      ],
      "rawBestSectionUse": "process-step, review-card, intake, workflow-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"case-review\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, native-intake, paid-routing, client-briefing\" data-jsi-category=\"case-review\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "case-file-routing",
        "case-intake",
        "case-review",
        "case-workflow",
        "checklist",
        "client-briefing",
        "clipboard",
        "container-eligible",
        "engagement-brief",
        "engagement-brief-case-workflow",
        "engagement-brief-icons",
        "engagement-brief-icons-case-review-clipboard",
        "engagement-case-workflow-01",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-07-japansolved-engagementbrief-case-workflow",
        "intake",
        "line",
        "medium",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-medium",
        "paid-review",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "process-control",
        "process-step",
        "recommended-boxed-or-free",
        "review-card",
        "review-intelligence",
        "suitability-check",
        "workflow",
        "workflow-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0057",
      "sequence": 57,
      "filename": "Icon-03-JapanSolved-EngagementBrief-Restricted-Advisory.svg",
      "handle": "icon-03-japansolved-engagementbrief-restricted-advisory",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-03-JapanSolved-EngagementBrief-Restricted-Advisory.svg?v=1778216841",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-advisory-intelligence-restricted-target",
      "rotationGroup": "engagement-restricted-advisory-01",
      "cleanLabel": "Engagement Brief Restricted Advisory",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "restricted-advisory",
        "boundaries",
        "screening",
        "advisory-route",
        "protected-advice"
      ],
      "visualTags": [
        "line",
        "restricted-target",
        "crossed-circle",
        "advisory",
        "black-stroke"
      ],
      "sectionFit": [
        "boundary-note",
        "review-card",
        "suitability-gate",
        "sensitive-case-card"
      ],
      "rawBestSectionUse": "boundary-note, review-card, suitability-gate, sensitive-case-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 6,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"boundary-note\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "advisory",
        "advisory-intelligence",
        "advisory-route",
        "balanced",
        "black-stroke",
        "boundaries",
        "boundary-note",
        "container-eligible",
        "crossed-circle",
        "discretion",
        "due-diligence",
        "engagement-brief-icons",
        "engagement-brief-icons-advisory-intelligence-restricted-target",
        "engagement-brief-restricted-advisory",
        "engagement-restricted-advisory-01",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-03-japansolved-engagementbrief-restricted-advisory",
        "intelligence",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "protected-advice",
        "quiet",
        "recommended-boxed-or-free",
        "restricted-advisory",
        "restricted-target",
        "review-card",
        "review-routing",
        "screening",
        "sensitive-case-card",
        "sensitive-discreet-routing",
        "suitability-gate",
        "thin-to-medium",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0058",
      "sequence": 58,
      "filename": "Icon-13-JapanSolved-Local-Representation.svg",
      "handle": "icon-13-japansolved-local-representation",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-13-JapanSolved-Local-Representation.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-logistics-representation-institution",
      "rotationGroup": "local-representation-02",
      "cleanLabel": "Local Representation Institution",
      "primaryCategory": "logistics-representation",
      "categoryTokens": [
        "logistics-representation"
      ],
      "purposeTags": [
        "local-representation",
        "institutional-presence",
        "japan-side-support",
        "formal-handling"
      ],
      "visualTags": [
        "line",
        "institution",
        "columns",
        "formal",
        "black-stroke"
      ],
      "sectionFit": [
        "local-representation-card",
        "trust-card",
        "service-card",
        "hub-card"
      ],
      "rawBestSectionUse": "local-representation-card, trust-card, service-card, hub-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"logistics-representation\" data-jsi-section=\"local-representation-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, native-intake, paid-routing, client-briefing\" data-jsi-category=\"logistics-representation\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "cargo-execution",
        "client-briefing",
        "columns",
        "container-eligible",
        "excellent",
        "formal",
        "formal-handling",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "hub-card",
        "icon-13-japansolved-local-representation",
        "institution",
        "institutional-presence",
        "japan-side-support",
        "line",
        "local-representation",
        "local-representation-02",
        "local-representation-card",
        "local-representation-institution",
        "logistics-local-representation",
        "logistics-representation",
        "medium",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-logistics-representation-institution",
        "outline-medium",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "recommended-boxed-or-free",
        "service-card",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0059",
      "sequence": 59,
      "filename": "Icon-08-JapanSolved-EngagementBrief-Stage-Marker-2.svg",
      "handle": "icon-08-japansolved-engagementbrief-stage-marker-2",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-08-JapanSolved-EngagementBrief-Stage-Marker-2.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-engagement-brief-number-badge",
      "rotationGroup": "engagement-brief-stage-02",
      "cleanLabel": "Engagement Brief Stage Marker 2",
      "primaryCategory": "engagement-brief",
      "categoryTokens": [
        "engagement-brief"
      ],
      "purposeTags": [
        "stage-marker",
        "step-two",
        "process-sequence",
        "intake-journey",
        "progress"
      ],
      "visualTags": [
        "line",
        "number-badge",
        "circular",
        "stage-marker",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "stage-marker",
        "intake-sequence",
        "timeline"
      ],
      "rawBestSectionUse": "process-step, stage-marker, intake-sequence, timeline",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 61.0,
      "familyCategoryRank": 4,
      "categoryRank": 4,
      "designFamilyRank": 2,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"engagement-brief\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing\" data-jsi-category=\"engagement-brief\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "circular",
        "client-briefing",
        "container-risk",
        "double-frame-risk",
        "engagement-brief",
        "engagement-brief-icons",
        "engagement-brief-icons-engagement-brief-number-badge",
        "engagement-brief-stage-02",
        "engagement-brief-stage-marker-2",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-08-japansolved-engagementbrief-stage-marker-2",
        "intake-journey",
        "intake-sequence",
        "line",
        "morphology-circle",
        "native-intake",
        "native-intake-system",
        "number-badge",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "process-sequence",
        "process-step",
        "progress",
        "quiet",
        "recommended-free-only",
        "rotation-fallback",
        "sequence-badge",
        "stage-marker",
        "step-two",
        "thin-to-medium",
        "timeline"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0060",
      "sequence": 60,
      "filename": "Icon-04-JapanSolved-EngagementBrief-Secure-Processing.svg",
      "handle": "icon-04-japansolved-engagementbrief-secure-processing",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-04-JapanSolved-EngagementBrief-Secure-Processing.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-privacy-discretion-lock",
      "rotationGroup": "engagement-secure-processing-01",
      "cleanLabel": "Engagement Brief Secure Processing",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "secure-processing",
        "lock",
        "protected-intake",
        "privacy",
        "controlled-handling"
      ],
      "visualTags": [
        "line",
        "lock",
        "security",
        "clean",
        "black-stroke"
      ],
      "sectionFit": [
        "intake",
        "trust-card",
        "confirmation-line",
        "security-strip"
      ],
      "rawBestSectionUse": "intake, trust-card, confirmation-line, security-strip",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 10,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"intake\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "clean",
        "client-briefing",
        "confirmation-line",
        "container-eligible",
        "controlled-handling",
        "discretion",
        "engagement-brief-icons",
        "engagement-brief-icons-privacy-discretion-lock",
        "engagement-brief-secure-processing",
        "engagement-secure-processing-01",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-04-japansolved-engagementbrief-secure-processing",
        "intake",
        "line",
        "lock",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "privacy",
        "privacy-discretion",
        "privacy-routing",
        "protected-intake",
        "quiet",
        "recommended-boxed-or-free",
        "secondary-variant",
        "secure-processing",
        "security",
        "security-strip",
        "sensitive-discreet-routing",
        "thin-to-medium",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0061",
      "sequence": 61,
      "filename": "Icon-10-JapanSolved-EngagementBrief-Client-Onboarding.svg",
      "handle": "icon-10-japansolved-engagementbrief-client-onboarding",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-10-JapanSolved-EngagementBrief-Client-Onboarding.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-client-onboarding-person",
      "rotationGroup": "engagement-client-onboarding-01",
      "cleanLabel": "Engagement Brief Client Onboarding",
      "primaryCategory": "client-onboarding",
      "categoryTokens": [
        "client-onboarding"
      ],
      "purposeTags": [
        "client-onboarding",
        "profile-setup",
        "intake-start",
        "relationship-entry",
        "briefing"
      ],
      "visualTags": [
        "line",
        "person",
        "onboarding",
        "minimal",
        "black-stroke"
      ],
      "sectionFit": [
        "onboarding-card",
        "intake",
        "process-step",
        "client-route"
      ],
      "rawBestSectionUse": "onboarding-card, intake, process-step, client-route",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "minimal",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 64.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"client-onboarding\" data-jsi-section=\"onboarding-card\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing\" data-jsi-category=\"client-onboarding\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "black-stroke",
        "briefing",
        "client-briefing",
        "client-onboarding",
        "client-route",
        "container-eligible",
        "engagement-brief-client-onboarding",
        "engagement-brief-icons",
        "engagement-brief-icons-client-onboarding-person",
        "engagement-client-onboarding-01",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-10-japansolved-engagementbrief-client-onboarding",
        "intake",
        "intake-start",
        "line",
        "minimal",
        "morphology-none",
        "native-intake",
        "native-intake-system",
        "no-double-frame-risk",
        "onboarding",
        "onboarding-card",
        "outline-light",
        "paid-routing",
        "person",
        "premium-monoline",
        "primary-default",
        "process-step",
        "profile-setup",
        "quiet",
        "recommended-boxed-or-free",
        "relationship-entry",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0062",
      "sequence": 62,
      "filename": "Icon-14-JapanSolved-Execution-Coordination.svg",
      "handle": "icon-14-japansolved-execution-coordination",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-14-JapanSolved-Execution-Coordination.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-execution-support-connected-people",
      "rotationGroup": "execution-coordination-02",
      "cleanLabel": "Execution Coordination Nodes",
      "primaryCategory": "execution-support",
      "categoryTokens": [
        "execution-support"
      ],
      "purposeTags": [
        "execution-coordination",
        "task-routing",
        "team-coordination",
        "handoff",
        "managed-delivery"
      ],
      "visualTags": [
        "line",
        "connected-people",
        "coordination",
        "structural",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "execution-card",
        "service-card",
        "workflow-section"
      ],
      "rawBestSectionUse": "process-step, execution-card, service-card, workflow-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 3,
      "categoryRank": 4,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 06",
      "notes": "Harvested from screenshot 06; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"execution-support\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, execution-support, outcome-control, completion\" data-jsi-category=\"execution-support\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "cargo-execution",
        "completion",
        "connected-people",
        "container-eligible",
        "coordination",
        "excellent",
        "execution-card",
        "execution-coordination",
        "execution-coordination-02",
        "execution-coordination-nodes",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "handoff",
        "handoff-control",
        "icon-14-japansolved-execution-coordination",
        "line",
        "local-representation",
        "logistics-local-representation",
        "managed-delivery",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-execution-support-connected-people",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "process-step",
        "recommended-boxed-or-free",
        "secondary-variant",
        "service-card",
        "structural",
        "task-routing",
        "team-coordination",
        "workflow-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0063",
      "sequence": 63,
      "filename": "Icon-16-JapanSolved-Discreet-Operations.svg",
      "handle": "icon-16-japansolved-discreet-operations",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-16-JapanSolved-Discreet-Operations.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-privacy-discretion-crossed-eye",
      "rotationGroup": "discreet-operations-01",
      "cleanLabel": "Discreet Operations Lens",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "discreet-operations",
        "private-handling",
        "quiet-execution",
        "protected-route",
        "sensitive-cases"
      ],
      "visualTags": [
        "line",
        "crossed-eye",
        "discretion",
        "minimal",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "sensitive-case-card",
        "boundary-note",
        "private-operations-section"
      ],
      "rawBestSectionUse": "trust-card, sensitive-case-card, boundary-note, private-operations-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "minimal",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 64.0,
      "familyCategoryRank": 2,
      "categoryRank": 4,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 07",
      "notes": "Harvested from screenshot 07; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "black-stroke",
        "boundary-note",
        "container-eligible",
        "crossed-eye",
        "discreet-operations",
        "discreet-operations-01",
        "discreet-operations-lens",
        "discretion",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-16-japansolved-discreet-operations",
        "intelligence",
        "line",
        "minimal",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-privacy-discretion-crossed-eye",
        "outline-light",
        "premium-monoline",
        "privacy-discretion",
        "privacy-routing",
        "private-handling",
        "private-operations-section",
        "protected-route",
        "quiet",
        "quiet-execution",
        "recommended-boxed-or-free",
        "review-routing",
        "secondary-variant",
        "sensitive-case-card",
        "sensitive-cases",
        "sensitive-discreet-routing",
        "thin-to-medium",
        "trust-card",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0064",
      "sequence": 64,
      "filename": "Icon-15-JapanSolved-Priority-Access.svg",
      "handle": "icon-15-japansolved-priority-access",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-15-JapanSolved-Priority-Access.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-priority-access-star",
      "rotationGroup": "priority-access-01",
      "cleanLabel": "Priority Access Star",
      "primaryCategory": "priority-access",
      "categoryTokens": [
        "priority-access"
      ],
      "purposeTags": [
        "priority-access",
        "elevated-route",
        "premium-handling",
        "urgent-attention",
        "client-priority"
      ],
      "visualTags": [
        "line",
        "star",
        "badge",
        "premium",
        "black-stroke"
      ],
      "sectionFit": [
        "tier-card",
        "priority-card",
        "cta-support",
        "product-ladder"
      ],
      "rawBestSectionUse": "tier-card, priority-card, CTA-support, product-ladder",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 07",
      "notes": "Harvested from screenshot 07; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"priority-access\" data-jsi-section=\"tier-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, execution-support, outcome-control, completion\" data-jsi-category=\"priority-access\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "badge",
        "balanced",
        "black-stroke",
        "client-priority",
        "completion",
        "concierge-presence",
        "container-risk",
        "cta-support",
        "cultural-navigation",
        "double-frame-risk",
        "elevated-route",
        "excellent",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "icon-15-japansolved-priority-access",
        "line",
        "medium",
        "morphology-circle",
        "numbered-general-icon-set",
        "numbered-general-icon-set-priority-access-star",
        "outcome-control",
        "outline-medium",
        "premium",
        "premium-handling",
        "premium-monoline",
        "primary-default",
        "priority-access",
        "priority-access-01",
        "priority-access-star",
        "priority-card",
        "product-ladder",
        "recommended-free-only",
        "star",
        "tier-card",
        "travel-cultural-access",
        "urgent-attention"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0065",
      "sequence": 65,
      "filename": "Icon-08-JapanSolved-EngagementBrief-Stage-Marker-3.svg",
      "handle": "icon-08-japansolved-engagementbrief-stage-marker-3",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-08-JapanSolved-EngagementBrief-Stage-Marker-3.svg?v=1778216841",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-engagement-brief-number-badge",
      "rotationGroup": "engagement-brief-stage-03",
      "cleanLabel": "Engagement Brief Stage Marker 3",
      "primaryCategory": "engagement-brief",
      "categoryTokens": [
        "engagement-brief"
      ],
      "purposeTags": [
        "stage-marker",
        "step-three",
        "process-sequence",
        "intake-journey",
        "progress"
      ],
      "visualTags": [
        "line",
        "number-badge",
        "circular",
        "stage-marker",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "stage-marker",
        "intake-sequence",
        "timeline"
      ],
      "rawBestSectionUse": "process-step, stage-marker, intake-sequence, timeline",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 61.0,
      "familyCategoryRank": 5,
      "categoryRank": 5,
      "designFamilyRank": 3,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 07",
      "notes": "Harvested from screenshot 07; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"engagement-brief\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing\" data-jsi-category=\"engagement-brief\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "circular",
        "client-briefing",
        "container-risk",
        "double-frame-risk",
        "engagement-brief",
        "engagement-brief-icons",
        "engagement-brief-icons-engagement-brief-number-badge",
        "engagement-brief-stage-03",
        "engagement-brief-stage-marker-3",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-08-japansolved-engagementbrief-stage-marker-3",
        "intake-journey",
        "intake-sequence",
        "line",
        "morphology-circle",
        "native-intake",
        "native-intake-system",
        "number-badge",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "process-sequence",
        "process-step",
        "progress",
        "quiet",
        "recommended-free-only",
        "rotation-fallback",
        "sequence-badge",
        "stage-marker",
        "step-three",
        "thin-to-medium",
        "timeline"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0066",
      "sequence": 66,
      "filename": "Icon-08-JapanSolved-EngagementBrief-Stage-Marker-1.svg",
      "handle": "icon-08-japansolved-engagementbrief-stage-marker-1",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-08-JapanSolved-EngagementBrief-Stage-Marker-1.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-engagement-brief-number-badge",
      "rotationGroup": "engagement-brief-stage-01",
      "cleanLabel": "Engagement Brief Stage Marker 1",
      "primaryCategory": "engagement-brief",
      "categoryTokens": [
        "engagement-brief"
      ],
      "purposeTags": [
        "stage-marker",
        "step-one",
        "process-sequence",
        "intake-start",
        "progress"
      ],
      "visualTags": [
        "line",
        "number-badge",
        "circular",
        "stage-marker",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "stage-marker",
        "intake-sequence",
        "timeline"
      ],
      "rawBestSectionUse": "process-step, stage-marker, intake-sequence, timeline",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 61.0,
      "familyCategoryRank": 6,
      "categoryRank": 6,
      "designFamilyRank": 4,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 07",
      "notes": "Harvested from screenshot 07; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"engagement-brief\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing\" data-jsi-category=\"engagement-brief\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "circular",
        "client-briefing",
        "container-risk",
        "double-frame-risk",
        "engagement-brief",
        "engagement-brief-icons",
        "engagement-brief-icons-engagement-brief-number-badge",
        "engagement-brief-stage-01",
        "engagement-brief-stage-marker-1",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "icon-08-japansolved-engagementbrief-stage-marker-1",
        "intake-sequence",
        "intake-start",
        "line",
        "morphology-circle",
        "native-intake",
        "native-intake-system",
        "number-badge",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "process-sequence",
        "process-step",
        "progress",
        "quiet",
        "recommended-free-only",
        "rotation-fallback",
        "sequence-badge",
        "stage-marker",
        "step-one",
        "thin-to-medium",
        "timeline"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0067",
      "sequence": 67,
      "filename": "Icon-09-JapanSolved-EngagementBrief-Engagement-Terms.svg",
      "handle": "icon-09-japansolved-engagementbrief-engagement-terms",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-09-JapanSolved-EngagementBrief-Engagement-Terms.svg?v=1778216840",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-engagement-brief-handshake",
      "rotationGroup": "engagement-terms-01",
      "cleanLabel": "Engagement Brief Engagement Terms",
      "primaryCategory": "engagement-brief",
      "categoryTokens": [
        "engagement-brief"
      ],
      "purposeTags": [
        "engagement-terms",
        "agreement",
        "handshake",
        "client-terms",
        "paid-intake-gate"
      ],
      "visualTags": [
        "line",
        "handshake",
        "agreement",
        "formal",
        "black-stroke"
      ],
      "sectionFit": [
        "confirmation-line",
        "intake",
        "product-ladder",
        "terms-card"
      ],
      "rawBestSectionUse": "confirmation-line, intake, product-ladder, terms-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 07",
      "notes": "Harvested from screenshot 07; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"engagement-brief\" data-jsi-section=\"confirmation-line\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, native-intake, paid-routing, client-briefing\" data-jsi-category=\"engagement-brief\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "agreement",
        "balanced",
        "black-stroke",
        "client-briefing",
        "client-terms",
        "concierge-presence",
        "confirmation-line",
        "container-eligible",
        "cultural-navigation",
        "engagement-brief",
        "engagement-brief-engagement-terms",
        "engagement-brief-icons",
        "engagement-brief-icons-engagement-brief-handshake",
        "engagement-terms",
        "engagement-terms-01",
        "excellent",
        "formal",
        "good-with-ivory-plate-or-css-filter",
        "handshake",
        "icon-09-japansolved-engagementbrief-engagement-terms",
        "intake",
        "line",
        "medium",
        "morphology-none",
        "native-intake",
        "native-intake-system",
        "no-double-frame-risk",
        "outline-medium",
        "paid-intake-gate",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "product-ladder",
        "recommended-boxed-or-free",
        "terms-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0068",
      "sequence": 68,
      "filename": "Icon-08-JapanSolved-EngagementBrief-Stage-Marker-4.svg",
      "handle": "icon-08-japansolved-engagementbrief-stage-marker-4",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Icon-08-JapanSolved-EngagementBrief-Stage-Marker-4.svg?v=1778216841",
      "assetType": "svg",
      "assetFamily": "Engagement Brief Icons",
      "familyKey": "engagement-brief-icons-engagement-brief-number-badge",
      "rotationGroup": "engagement-brief-stage-04",
      "cleanLabel": "Engagement Brief Stage Marker 4",
      "primaryCategory": "engagement-brief",
      "categoryTokens": [
        "engagement-brief"
      ],
      "purposeTags": [
        "stage-marker",
        "step-four",
        "process-sequence",
        "intake-journey",
        "progress-line"
      ],
      "visualTags": [
        "line",
        "number-badge",
        "circular",
        "stage-marker",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "stage-marker",
        "intake-sequence",
        "timeline"
      ],
      "rawBestSectionUse": "process-step, stage-marker, intake-sequence, timeline",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "needs-url",
      "lightThemeFit": "needs-url",
      "themeTreatmentNote": "missing URL must be supplied before live use",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · user-supplied Shopify CDN URL",
      "errorFlag": "OK",
      "defaultPriorityScore": -34.0,
      "familyCategoryRank": 7,
      "categoryRank": 7,
      "designFamilyRank": 5,
      "variantRole": "needs-url-before-live-use",
      "sourceBatch": "Screenshot 07",
      "notes": "Restored because Screenshot Order 68 was missing from the uploaded workbook; paste the matching Shopify CDN URL before approval. | 2026-07-07: Missing Shopify CDN URL filled from user-supplied dashboard correction.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"engagement-brief\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing\" data-jsi-category=\"engagement-brief\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "circular",
        "client-briefing",
        "container-risk",
        "double-frame-risk",
        "engagement-brief",
        "engagement-brief-icons",
        "engagement-brief-icons-engagement-brief-number-badge",
        "engagement-brief-stage-04",
        "engagement-brief-stage-marker-4",
        "icon-08-japansolved-engagementbrief-stage-marker-4",
        "intake-journey",
        "intake-sequence",
        "line",
        "morphology-circle",
        "native-intake",
        "native-intake-system",
        "needs-url",
        "needs-url-before-live-use",
        "number-badge",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "process-sequence",
        "process-step",
        "progress-line",
        "quiet",
        "recommended-free-only",
        "sequence-badge",
        "stage-marker",
        "step-four",
        "thin-to-medium",
        "timeline"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0069",
      "sequence": 69,
      "filename": "japansolved-king-crown-5.svg",
      "handle": "japansolved-king-crown-5",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-king-crown-5.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Crown / Tier / Reserved Pathway Icons",
      "familyKey": "crown-tier-reserved-pathway-icons-premium-authority-crown",
      "rotationGroup": "premium-crown-05",
      "cleanLabel": "King Crown 5",
      "primaryCategory": "premium-authority",
      "categoryTokens": [
        "premium-authority"
      ],
      "purposeTags": [
        "premium",
        "crown",
        "elite-tier",
        "royal-treatment",
        "top-rank-signal"
      ],
      "visualTags": [
        "line",
        "crown",
        "premium",
        "black-stroke",
        "numbered-variant"
      ],
      "sectionFit": [
        "tier-card",
        "premium-card",
        "service-card",
        "authority-strip"
      ],
      "rawBestSectionUse": "tier-card, premium-card, service-card, authority-strip",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"premium-authority\" data-jsi-section=\"tier-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"authority-signal, premium-trust, reserved-access\" data-jsi-category=\"premium-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "authority-signal",
        "authority-strip",
        "balanced",
        "black-stroke",
        "container-eligible",
        "crown",
        "crown-tier-reserved-pathway-icons",
        "crown-tier-reserved-pathway-icons-premium-authority-crown",
        "elite-tier",
        "excellent",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "japansolved-king-crown-5",
        "king-crown-5",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-variant",
        "outline-medium",
        "premium",
        "premium-authority",
        "premium-card",
        "premium-crown-05",
        "premium-monoline",
        "premium-trust",
        "primary-default",
        "recommended-boxed-or-free",
        "reserved-access",
        "royal-treatment",
        "service-card",
        "tier-card",
        "top-rank-signal"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0070",
      "sequence": 70,
      "filename": "japansolved-king-crown-4.svg",
      "handle": "japansolved-king-crown-4",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-king-crown-4.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Crown / Tier / Reserved Pathway Icons",
      "familyKey": "crown-tier-reserved-pathway-icons-premium-authority-crown",
      "rotationGroup": "premium-crown-04",
      "cleanLabel": "King Crown 4",
      "primaryCategory": "premium-authority",
      "categoryTokens": [
        "premium-authority"
      ],
      "purposeTags": [
        "premium",
        "crown",
        "elite-tier",
        "royal-treatment",
        "elevated-access"
      ],
      "visualTags": [
        "line",
        "crown",
        "premium",
        "black-stroke",
        "numbered-variant"
      ],
      "sectionFit": [
        "tier-card",
        "premium-card",
        "service-card",
        "authority-strip"
      ],
      "rawBestSectionUse": "tier-card, premium-card, service-card, authority-strip",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"premium-authority\" data-jsi-section=\"tier-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"premium-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "authority-signal",
        "authority-strip",
        "balanced",
        "black-stroke",
        "concierge-presence",
        "container-eligible",
        "crown",
        "crown-tier-reserved-pathway-icons",
        "crown-tier-reserved-pathway-icons-premium-authority-crown",
        "cultural-navigation",
        "elevated-access",
        "elite-tier",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "japansolved-king-crown-4",
        "king-crown-4",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-variant",
        "outline-medium",
        "premium",
        "premium-authority",
        "premium-card",
        "premium-crown-04",
        "premium-monoline",
        "premium-trust",
        "recommended-boxed-or-free",
        "reserved-access",
        "royal-treatment",
        "secondary-variant",
        "service-card",
        "tier-card",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0071",
      "sequence": 71,
      "filename": "japansolved-key-inside-circle.svg",
      "handle": "japansolved-key-inside-circle",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-key-inside-circle.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-private-access-key",
      "rotationGroup": "private-access-key-01",
      "cleanLabel": "Key Inside Circle",
      "primaryCategory": "private-access",
      "categoryTokens": [
        "private-access"
      ],
      "purposeTags": [
        "key",
        "private-access",
        "unlock",
        "controlled-entry",
        "eligibility"
      ],
      "visualTags": [
        "line",
        "key",
        "circle",
        "access-symbol",
        "black-stroke"
      ],
      "sectionFit": [
        "private-access-card",
        "trust-card",
        "process-step",
        "intake-choice"
      ],
      "rawBestSectionUse": "private-access-card, trust-card, process-step, intake-choice",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"private-access\" data-jsi-section=\"private-access-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"private-access\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "access-symbol",
        "balanced",
        "black-stroke",
        "circle",
        "concierge-presence",
        "container-risk",
        "controlled-entry",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-private-access-key",
        "cultural-navigation",
        "discretion",
        "double-frame-risk",
        "eligibility",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intake-choice",
        "japansolved-key-inside-circle",
        "key",
        "key-inside-circle",
        "line",
        "medium",
        "morphology-circle",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "private-access",
        "private-access-card",
        "private-access-key-01",
        "process-step",
        "recommended-free-only",
        "travel-cultural-access",
        "trust-card",
        "trust-protection",
        "unlock"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0072",
      "sequence": 72,
      "filename": "js-icon-footer-risk-compliance-analysis-mono-bw-v1.svg",
      "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/js-icon-footer-risk-compliance-analysis-mono-bw-v1.svg?v=1778375523",
      "assetType": "svg",
      "assetFamily": "Footer / Micro Footer Icons",
      "familyKey": "footer-micro-footer-icons-risk-compliance-monoline",
      "rotationGroup": "footer-risk-compliance-01",
      "cleanLabel": "Risk Compliance Analysis Mono",
      "primaryCategory": "risk-compliance",
      "categoryTokens": [
        "risk-compliance"
      ],
      "purposeTags": [
        "risk",
        "compliance",
        "analysis",
        "due-diligence",
        "legal-review"
      ],
      "visualTags": [
        "monoline",
        "circular-seal",
        "compliance",
        "footer-icon",
        "black-stroke"
      ],
      "sectionFit": [
        "footer-card",
        "risk-card",
        "trust-strip",
        "compliance-note"
      ],
      "rawBestSectionUse": "footer-card, risk-card, trust-strip, compliance-note",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"risk-compliance\" data-jsi-section=\"footer-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, paid-review, case-intake, suitability-check\" data-jsi-category=\"risk-compliance\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "analysis",
        "balanced",
        "black-stroke",
        "case-intake",
        "circular-seal",
        "compliance",
        "compliance-note",
        "container-risk",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "footer-card",
        "footer-icon",
        "footer-micro-footer-icons",
        "footer-micro-footer-icons-risk-compliance-monoline",
        "footer-risk-compliance-01",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
        "legal-review",
        "monoline",
        "morphology-circle",
        "outline-light",
        "paid-review",
        "premium-monoline",
        "primary-default",
        "quiet",
        "recommended-free-only",
        "review-intelligence",
        "review-routing",
        "risk",
        "risk-card",
        "risk-compliance",
        "risk-compliance-analysis-mono",
        "sequence-badge",
        "suitability-check",
        "thin-to-medium",
        "trust-strip"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0073",
      "sequence": 73,
      "filename": "js-icon-footer-counterparty-mapping-mono-bw-v1.svg",
      "handle": "js-icon-footer-counterparty-mapping-mono-bw-v1",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/js-icon-footer-counterparty-mapping-mono-bw-v1.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Footer / Micro Footer Icons",
      "familyKey": "footer-micro-footer-icons-counterparty-mapping-monoline",
      "rotationGroup": "footer-counterparty-mapping-01",
      "cleanLabel": "Counterparty Mapping Mono",
      "primaryCategory": "counterparty-mapping",
      "categoryTokens": [
        "counterparty-mapping"
      ],
      "purposeTags": [
        "counterparty-mapping",
        "network",
        "relationship-map",
        "due-diligence",
        "traceability"
      ],
      "visualTags": [
        "monoline",
        "node-network",
        "circular-seal",
        "footer-icon",
        "black-stroke"
      ],
      "sectionFit": [
        "footer-card",
        "intelligence-block",
        "due-diligence-card",
        "trust-strip"
      ],
      "rawBestSectionUse": "footer-card, intelligence-block, due-diligence-card, trust-strip",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"counterparty-mapping\" data-jsi-section=\"footer-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"counterparty-mapping\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "circular-seal",
        "container-risk",
        "counterparty-mapping",
        "counterparty-mapping-mono",
        "discretion",
        "double-frame-risk",
        "due-diligence",
        "due-diligence-card",
        "excellent",
        "footer-card",
        "footer-counterparty-mapping-01",
        "footer-icon",
        "footer-micro-footer-icons",
        "footer-micro-footer-icons-counterparty-mapping-monoline",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "js-icon-footer-counterparty-mapping-mono-bw-v1",
        "monoline",
        "morphology-circle",
        "network",
        "node-network",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "quiet",
        "recommended-free-only",
        "relationship-map",
        "review-intelligence",
        "review-routing",
        "sequence-badge",
        "thin-to-medium",
        "traceability",
        "trust-protection",
        "trust-strip"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0074",
      "sequence": 74,
      "filename": "js-icon-micro-clinic-protocol-review-mono-bw-v1.svg",
      "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/js-icon-micro-clinic-protocol-review-mono-bw-v1.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-medical-due-diligence-monoline",
      "rotationGroup": "micro-clinic-protocol-review-01",
      "cleanLabel": "Clinic Protocol Review Mono",
      "primaryCategory": "medical-due-diligence",
      "categoryTokens": [
        "medical-due-diligence"
      ],
      "purposeTags": [
        "clinic",
        "protocol-review",
        "medical-due-diligence",
        "document-check",
        "suitability"
      ],
      "visualTags": [
        "monoline",
        "document",
        "medical-cross",
        "checkmark",
        "black-stroke"
      ],
      "sectionFit": [
        "medical-card",
        "review-card",
        "trust-card",
        "due-diligence-card"
      ],
      "rawBestSectionUse": "medical-card, review-card, trust-card, due-diligence-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"medical-due-diligence\" data-jsi-section=\"medical-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, paid-review, case-intake, suitability-check\" data-jsi-category=\"medical-due-diligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "case-intake",
        "checkmark",
        "clinic",
        "clinic-protocol-review-mono",
        "container-eligible",
        "document",
        "document-check",
        "due-diligence",
        "due-diligence-card",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "js-icon-micro-clinic-protocol-review-mono-bw-v1",
        "medical-card",
        "medical-cross",
        "medical-due-diligence",
        "micro-clinic-protocol-review-01",
        "monoline",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-medical-due-diligence-monoline",
        "outline-light",
        "paid-review",
        "premium-monoline",
        "primary-default",
        "protocol-review",
        "quiet",
        "recommended-boxed-or-free",
        "review-card",
        "review-intelligence",
        "review-routing",
        "suitability",
        "suitability-check",
        "thin-to-medium",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0075",
      "sequence": 75,
      "filename": "japansolved-king-crown-2.svg",
      "handle": "japansolved-king-crown-2",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-king-crown-2.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Crown / Tier / Reserved Pathway Icons",
      "familyKey": "crown-tier-reserved-pathway-icons-premium-authority-crown",
      "rotationGroup": "premium-crown-02",
      "cleanLabel": "King Crown 2",
      "primaryCategory": "premium-authority",
      "categoryTokens": [
        "premium-authority"
      ],
      "purposeTags": [
        "premium",
        "crown",
        "service-tier",
        "elevated-handling",
        "authority"
      ],
      "visualTags": [
        "line",
        "crown",
        "premium",
        "black-stroke",
        "numbered-variant"
      ],
      "sectionFit": [
        "tier-card",
        "premium-card",
        "service-card",
        "authority-strip"
      ],
      "rawBestSectionUse": "tier-card, premium-card, service-card, authority-strip",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 3,
      "categoryRank": 3,
      "designFamilyRank": 3,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"premium-authority\" data-jsi-section=\"tier-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"authority-signal, premium-trust, reserved-access\" data-jsi-category=\"premium-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "authority",
        "authority-signal",
        "authority-strip",
        "balanced",
        "black-stroke",
        "container-eligible",
        "crown",
        "crown-tier-reserved-pathway-icons",
        "crown-tier-reserved-pathway-icons-premium-authority-crown",
        "elevated-handling",
        "excellent",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "japansolved-king-crown-2",
        "king-crown-2",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-variant",
        "outline-medium",
        "premium",
        "premium-authority",
        "premium-card",
        "premium-crown-02",
        "premium-monoline",
        "premium-trust",
        "recommended-boxed-or-free",
        "reserved-access",
        "secondary-variant",
        "service-card",
        "service-tier",
        "tier-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0076",
      "sequence": 76,
      "filename": "japansolved-nodes-network-molecule.svg",
      "handle": "japansolved-nodes-network-molecule",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-nodes-network-molecule.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-strategy-alignment-nodes",
      "rotationGroup": "network-molecule-01",
      "cleanLabel": "Nodes Network Molecule",
      "primaryCategory": "strategy-alignment",
      "categoryTokens": [
        "strategy-alignment"
      ],
      "purposeTags": [
        "network",
        "coordination",
        "relationship-map",
        "routing",
        "connected-system"
      ],
      "visualTags": [
        "line",
        "nodes",
        "molecule",
        "structural",
        "black-stroke"
      ],
      "sectionFit": [
        "strategy-section",
        "process-step",
        "coordination-card",
        "intelligence-block"
      ],
      "rawBestSectionUse": "strategy-section, process-step, coordination-card, intelligence-block",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 4,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"strategy-alignment\" data-jsi-section=\"strategy-section\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"strategy-alignment\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "connected-system",
        "container-eligible",
        "coordination",
        "coordination-card",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-strategy-alignment-nodes",
        "discretion",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "japansolved-nodes-network-molecule",
        "line",
        "medium",
        "molecule",
        "morphology-none",
        "network",
        "network-molecule-01",
        "no-double-frame-risk",
        "nodes",
        "nodes-network-molecule",
        "outline-medium",
        "premium-monoline",
        "privacy-routing",
        "process-step",
        "recommended-boxed-or-free",
        "relationship-map",
        "review-intelligence",
        "review-routing",
        "routing",
        "secondary-variant",
        "strategy-alignment",
        "strategy-section",
        "structural",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0077",
      "sequence": 77,
      "filename": "japansolved-guidance-support-question-icon.svg",
      "handle": "japansolved-guidance-support-question-icon",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-guidance-support-question-icon.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-guidance-support-question-mark",
      "rotationGroup": "guidance-question-01",
      "cleanLabel": "Guidance Support Question",
      "primaryCategory": "guidance-support",
      "categoryTokens": [
        "guidance-support"
      ],
      "purposeTags": [
        "guidance",
        "support",
        "question",
        "help",
        "client-uncertainty"
      ],
      "visualTags": [
        "line",
        "question-mark",
        "circle",
        "help-symbol",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "help-card",
        "support-card",
        "intake-guidance"
      ],
      "rawBestSectionUse": "FAQ-row, help-card, support-card, intake-guidance",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"guidance-support\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing, execution-support, outcome-control, completion\" data-jsi-category=\"guidance-support\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "circle",
        "client-briefing",
        "client-uncertainty",
        "completion",
        "container-eligible",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-guidance-support-question-mark",
        "excellent",
        "execution-support",
        "faq-row",
        "good-with-ivory-plate-or-css-filter",
        "guidance",
        "guidance-question-01",
        "guidance-support",
        "guidance-support-question",
        "help",
        "help-card",
        "help-symbol",
        "intake-guidance",
        "japansolved-guidance-support-question-icon",
        "line",
        "morphology-none",
        "native-intake",
        "native-intake-system",
        "no-double-frame-risk",
        "outcome-control",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "question",
        "question-mark",
        "quiet",
        "recommended-boxed-or-free",
        "support",
        "support-card",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0078",
      "sequence": 78,
      "filename": "japansolved-king-crown-1.svg",
      "handle": "japansolved-king-crown-1",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-king-crown-1.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Crown / Tier / Reserved Pathway Icons",
      "familyKey": "crown-tier-reserved-pathway-icons-premium-authority-crown",
      "rotationGroup": "premium-crown-01",
      "cleanLabel": "King Crown 1",
      "primaryCategory": "premium-authority",
      "categoryTokens": [
        "premium-authority"
      ],
      "purposeTags": [
        "premium",
        "crown",
        "service-tier",
        "royal-signal",
        "elevated-access"
      ],
      "visualTags": [
        "line",
        "crown",
        "premium",
        "black-stroke",
        "numbered-variant"
      ],
      "sectionFit": [
        "tier-card",
        "premium-card",
        "service-card",
        "authority-strip"
      ],
      "rawBestSectionUse": "tier-card, premium-card, service-card, authority-strip",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 4,
      "categoryRank": 4,
      "designFamilyRank": 4,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"premium-authority\" data-jsi-section=\"tier-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"premium-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "authority-signal",
        "authority-strip",
        "balanced",
        "black-stroke",
        "concierge-presence",
        "container-eligible",
        "crown",
        "crown-tier-reserved-pathway-icons",
        "crown-tier-reserved-pathway-icons-premium-authority-crown",
        "cultural-navigation",
        "elevated-access",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "japansolved-king-crown-1",
        "king-crown-1",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-variant",
        "outline-medium",
        "premium",
        "premium-authority",
        "premium-card",
        "premium-crown-01",
        "premium-monoline",
        "premium-trust",
        "recommended-boxed-or-free",
        "reserved-access",
        "rotation-fallback",
        "royal-signal",
        "service-card",
        "service-tier",
        "tier-card",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0079",
      "sequence": 79,
      "filename": "js-icon-micro-discreet-intelligence-mono-bw-v1.svg",
      "handle": "js-icon-micro-discreet-intelligence-mono-bw-v1",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/js-icon-micro-discreet-intelligence-mono-bw-v1.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-advisory-intelligence-monoline",
      "rotationGroup": "micro-discreet-intelligence-01",
      "cleanLabel": "Discreet Intelligence Mono",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "discreet-intelligence",
        "target",
        "advisory",
        "sensitive-review",
        "quiet-analysis"
      ],
      "visualTags": [
        "monoline",
        "target",
        "circular-seal",
        "micro-icon",
        "black-stroke"
      ],
      "sectionFit": [
        "intelligence-block",
        "trust-card",
        "sensitive-case-card",
        "review-card"
      ],
      "rawBestSectionUse": "intelligence-block, trust-card, sensitive-case-card, review-card",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 7,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"intelligence-block\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "advisory",
        "advisory-intelligence",
        "balanced",
        "black-stroke",
        "circular-seal",
        "container-risk",
        "discreet-intelligence",
        "discreet-intelligence-mono",
        "discretion",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "js-icon-micro-discreet-intelligence-mono-bw-v1",
        "micro-discreet-intelligence-01",
        "micro-icon",
        "monoline",
        "morphology-circle",
        "numbered-general-icon-set",
        "numbered-general-icon-set-advisory-intelligence-monoline",
        "outline-light",
        "premium-monoline",
        "privacy-routing",
        "quiet",
        "quiet-analysis",
        "recommended-free-only",
        "review-card",
        "review-routing",
        "secondary-variant",
        "sensitive-case-card",
        "sensitive-discreet-routing",
        "sensitive-review",
        "sequence-badge",
        "target",
        "thin-to-medium",
        "trust-card",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0080",
      "sequence": 80,
      "filename": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1.svg",
      "handle": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/js-icon-footer-medical-operational-due-diligence-mono-bw-v1.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Footer / Micro Footer Icons",
      "familyKey": "footer-micro-footer-icons-medical-due-diligence-monoline",
      "rotationGroup": "footer-medical-due-diligence-01",
      "cleanLabel": "Medical Due Diligence Mono",
      "primaryCategory": "medical-due-diligence",
      "categoryTokens": [
        "medical-due-diligence"
      ],
      "purposeTags": [
        "medical-due-diligence",
        "clinical-review",
        "health-route",
        "suitability",
        "verification"
      ],
      "visualTags": [
        "monoline",
        "medical-cross",
        "circular-seal",
        "footer-icon",
        "black-stroke"
      ],
      "sectionFit": [
        "footer-card",
        "medical-card",
        "trust-strip",
        "due-diligence-card"
      ],
      "rawBestSectionUse": "footer-card, medical-card, trust-strip, due-diligence-card",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"medical-due-diligence\" data-jsi-section=\"footer-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, paid-review, case-intake, suitability-check\" data-jsi-category=\"medical-due-diligence\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "case-intake",
        "circular-seal",
        "clinical-review",
        "container-risk",
        "double-frame-risk",
        "due-diligence",
        "due-diligence-card",
        "excellent",
        "footer-card",
        "footer-icon",
        "footer-medical-due-diligence-01",
        "footer-micro-footer-icons",
        "footer-micro-footer-icons-medical-due-diligence-monoline",
        "good-with-ivory-plate-or-css-filter",
        "health-route",
        "intelligence",
        "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
        "medical-card",
        "medical-cross",
        "medical-due-diligence",
        "medical-due-diligence-mono",
        "monoline",
        "morphology-circle",
        "outline-light",
        "paid-review",
        "premium-monoline",
        "primary-default",
        "quiet",
        "recommended-free-only",
        "review-intelligence",
        "review-routing",
        "sequence-badge",
        "suitability",
        "suitability-check",
        "thin-to-medium",
        "trust-strip",
        "verification"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0081",
      "sequence": 81,
      "filename": "japansolved-capital-program.svg",
      "handle": "japansolved-capital-program",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-capital-program.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-investments-capital-shield-circle",
      "rotationGroup": "capital-program-01",
      "cleanLabel": "Capital Program",
      "primaryCategory": "investments-capital",
      "categoryTokens": [
        "investments-capital"
      ],
      "purposeTags": [
        "capital-program",
        "investment",
        "finance",
        "structured-program",
        "asset-pathway"
      ],
      "visualTags": [
        "line",
        "shield-circle",
        "institutional",
        "finance",
        "black-stroke"
      ],
      "sectionFit": [
        "investment-card",
        "program-card",
        "product-ladder",
        "trust-card"
      ],
      "rawBestSectionUse": "investment-card, program-card, product-ladder, trust-card",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "asset-intelligence",
        "capital-review",
        "risk-screening"
      ],
      "pageWingFit": [
        "asset-capital-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 08",
      "notes": "Harvested from screenshot 08; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"investments-capital\" data-jsi-section=\"investment-card\" data-jsi-page-wing=\"asset-capital-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, asset-intelligence, capital-review, risk-screening\" data-jsi-category=\"investments-capital\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "asset-capital-intelligence",
        "asset-intelligence",
        "asset-pathway",
        "balanced",
        "black-stroke",
        "capital-program",
        "capital-program-01",
        "capital-review",
        "container-eligible",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-investments-capital-shield-circle",
        "discretion",
        "excellent",
        "finance",
        "good-with-ivory-plate-or-css-filter",
        "institutional",
        "investment",
        "investment-card",
        "investments-capital",
        "japansolved-capital-program",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "privacy-routing",
        "product-ladder",
        "program-card",
        "recommended-boxed-or-free",
        "risk-screening",
        "secondary-variant",
        "shield-circle",
        "structured-program",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0082",
      "sequence": 82,
      "filename": "js-icon-micro-decision-clarity-mono-bw-v1.svg",
      "handle": "js-icon-micro-decision-clarity-mono-bw-v1",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/js-icon-micro-decision-clarity-mono-bw-v1.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-advisory-intelligence-monoline",
      "rotationGroup": "micro-decision-clarity-01",
      "cleanLabel": "Decision Clarity Mono",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "decision-clarity",
        "advisory",
        "route-choice",
        "judgment",
        "strategic-selection"
      ],
      "visualTags": [
        "monoline",
        "compass",
        "decision-mark",
        "micro-icon",
        "black-stroke"
      ],
      "sectionFit": [
        "intelligence-block",
        "process-step",
        "trust-card",
        "decision-card"
      ],
      "rawBestSectionUse": "intelligence-block, process-step, trust-card, decision-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 3,
      "categoryRank": 8,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 09",
      "notes": "Harvested from screenshot 09; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"intelligence-block\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "advisory",
        "advisory-intelligence",
        "balanced",
        "black-stroke",
        "compass",
        "container-risk",
        "decision-card",
        "decision-clarity",
        "decision-clarity-mono",
        "decision-mark",
        "discretion",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "js-icon-micro-decision-clarity-mono-bw-v1",
        "judgment",
        "micro-decision-clarity-01",
        "micro-icon",
        "monoline",
        "morphology-circle-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-advisory-intelligence-monoline",
        "outline-light",
        "premium-monoline",
        "privacy-routing",
        "process-step",
        "quiet",
        "recommended-free-only",
        "review-intelligence",
        "review-routing",
        "route-choice",
        "secondary-variant",
        "strategic-selection",
        "thin-to-medium",
        "trust-card",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0083",
      "sequence": 83,
      "filename": "js-icon-footer-decision-ready-intelligence-mono-bw-v1.svg",
      "handle": "js-icon-footer-decision-ready-intelligence-mono-bw-v1",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/js-icon-footer-decision-ready-intelligence-mono-bw-v1.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Footer / Micro Footer Icons",
      "familyKey": "footer-micro-footer-icons-advisory-intelligence-monoline",
      "rotationGroup": "footer-decision-intelligence-01",
      "cleanLabel": "Decision Intelligence Mono",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "decision-intelligence",
        "analysis",
        "strategic-advisory",
        "route-intelligence",
        "evaluation"
      ],
      "visualTags": [
        "monoline",
        "faceted-gem",
        "footer-icon",
        "institutional",
        "black-stroke"
      ],
      "sectionFit": [
        "footer-card",
        "intelligence-block",
        "trust-strip",
        "advisory-card"
      ],
      "rawBestSectionUse": "footer-card, intelligence-block, trust-strip, advisory-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 9,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 09",
      "notes": "Harvested from screenshot 09; Shopify filename is middle-truncated in screenshot; verify full handle from CDN URL. | CDN URL supplied the full, non-truncated handle.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"footer-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "advisory-card",
        "advisory-intelligence",
        "analysis",
        "balanced",
        "black-stroke",
        "container-eligible",
        "decision-intelligence",
        "decision-intelligence-mono",
        "discretion",
        "due-diligence",
        "evaluation",
        "excellent",
        "faceted-gem",
        "footer-card",
        "footer-decision-intelligence-01",
        "footer-icon",
        "footer-micro-footer-icons",
        "footer-micro-footer-icons-advisory-intelligence-monoline",
        "good-with-ivory-plate-or-css-filter",
        "institutional",
        "intelligence",
        "intelligence-block",
        "js-icon-footer-decision-ready-intelligence-mono-bw-v1",
        "monoline",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "quiet",
        "recommended-boxed-or-free",
        "review-intelligence",
        "review-routing",
        "route-intelligence",
        "strategic-advisory",
        "thin-to-medium",
        "trust-protection",
        "trust-strip"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0084",
      "sequence": 84,
      "filename": "japansolved-shield-inside-circle-check-2.svg",
      "handle": "japansolved-shield-inside-circle-check-2",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-shield-inside-circle-check-2.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-privacy-discretion-shield",
      "rotationGroup": "shield-circle-check-02",
      "cleanLabel": "Shield Inside Circle Check 2",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "verification",
        "protection",
        "confirmed-route",
        "client-safety",
        "trust"
      ],
      "visualTags": [
        "line",
        "shield",
        "checkmark",
        "circle",
        "black-stroke",
        "variant"
      ],
      "sectionFit": [
        "trust-card",
        "confirmation-line",
        "intake-confirmation",
        "boundary-note"
      ],
      "rawBestSectionUse": "trust-card, confirmation-line, intake-confirmation, boundary-note",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 11,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 09",
      "notes": "Harvested from screenshot 09; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "boundary-note",
        "checkmark",
        "circle",
        "client-briefing",
        "client-safety",
        "confirmation-line",
        "confirmed-route",
        "container-risk",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-privacy-discretion-shield",
        "discretion",
        "double-frame-risk",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "japansolved-shield-inside-circle-check-2",
        "line",
        "morphology-circle",
        "native-intake",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "privacy-discretion",
        "privacy-routing",
        "protection",
        "quiet",
        "recommended-free-only",
        "secondary-variant",
        "sensitive-discreet-routing",
        "shield",
        "shield-circle-check-02",
        "shield-inside-circle-check-2",
        "thin-to-medium",
        "trust",
        "trust-card",
        "trust-protection",
        "trust-symbol",
        "variant",
        "verification"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0085",
      "sequence": 85,
      "filename": "japansolved-think-thank-institute.svg",
      "handle": "japansolved-think-thank-institute",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-think-thank-institute.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-institutional-authority-globe",
      "rotationGroup": "think-thank-institute-01",
      "cleanLabel": "Think Thank Institute Globe",
      "primaryCategory": "institutional-authority",
      "categoryTokens": [
        "institutional-authority"
      ],
      "purposeTags": [
        "think-tank",
        "institute",
        "global-context",
        "advisory",
        "research"
      ],
      "visualTags": [
        "line",
        "globe",
        "institutional",
        "grid",
        "black-stroke"
      ],
      "sectionFit": [
        "authority-card",
        "intelligence-block",
        "hub-card",
        "research-section"
      ],
      "rawBestSectionUse": "authority-card, intelligence-block, hub-card, research-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 09",
      "notes": "Harvested from screenshot 09; Shopify file type SVG. Filename appears as 'think-thank' in screenshot; verify spelling from CDN URL if needed.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"institutional-authority\" data-jsi-section=\"authority-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"institutional-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "advisory",
        "authority-card",
        "balanced",
        "black-stroke",
        "container-eligible",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-institutional-authority-globe",
        "discretion",
        "due-diligence",
        "excellent",
        "global-context",
        "globe",
        "good-with-ivory-plate-or-css-filter",
        "grid",
        "hub-card",
        "institute",
        "institutional",
        "institutional-authority",
        "intelligence",
        "intelligence-block",
        "japansolved-think-thank-institute",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "recommended-boxed-or-free",
        "research",
        "research-section",
        "review-intelligence",
        "review-routing",
        "think-tank",
        "think-thank-institute-01",
        "think-thank-institute-globe",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0086",
      "sequence": 86,
      "filename": "japansolved-king-crown-3.svg",
      "handle": "japansolved-king-crown-3",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-king-crown-3.svg?v=1778375523",
      "assetType": "svg",
      "assetFamily": "Crown / Tier / Reserved Pathway Icons",
      "familyKey": "crown-tier-reserved-pathway-icons-premium-authority-crown",
      "rotationGroup": "premium-crown-03",
      "cleanLabel": "King Crown 3",
      "primaryCategory": "premium-authority",
      "categoryTokens": [
        "premium-authority"
      ],
      "purposeTags": [
        "premium",
        "crown",
        "service-tier",
        "royal-signal",
        "elevated-access"
      ],
      "visualTags": [
        "line",
        "crown",
        "premium",
        "black-stroke",
        "numbered-variant"
      ],
      "sectionFit": [
        "tier-card",
        "premium-card",
        "service-card",
        "authority-strip"
      ],
      "rawBestSectionUse": "tier-card, premium-card, service-card, authority-strip",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 5,
      "categoryRank": 5,
      "designFamilyRank": 5,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 09",
      "notes": "Harvested from screenshot 09; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"premium-authority\" data-jsi-section=\"tier-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"premium-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "authority-signal",
        "authority-strip",
        "balanced",
        "black-stroke",
        "concierge-presence",
        "container-eligible",
        "crown",
        "crown-tier-reserved-pathway-icons",
        "crown-tier-reserved-pathway-icons-premium-authority-crown",
        "cultural-navigation",
        "elevated-access",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "japansolved-king-crown-3",
        "king-crown-3",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-variant",
        "outline-medium",
        "premium",
        "premium-authority",
        "premium-card",
        "premium-crown-03",
        "premium-monoline",
        "premium-trust",
        "recommended-boxed-or-free",
        "reserved-access",
        "rotation-fallback",
        "royal-signal",
        "service-card",
        "service-tier",
        "tier-card",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0087",
      "sequence": 87,
      "filename": "japansolved-shield-inside-circle-check-1.svg",
      "handle": "japansolved-shield-inside-circle-check-1",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-shield-inside-circle-check-1.svg?v=1778375523",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-privacy-discretion-shield",
      "rotationGroup": "shield-circle-check-01",
      "cleanLabel": "Shield Inside Circle Check 1",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "verification",
        "protection",
        "confirmed-route",
        "client-safety",
        "trust"
      ],
      "visualTags": [
        "line",
        "shield",
        "checkmark",
        "circle",
        "black-stroke",
        "variant"
      ],
      "sectionFit": [
        "trust-card",
        "confirmation-line",
        "intake-confirmation",
        "boundary-note"
      ],
      "rawBestSectionUse": "trust-card, confirmation-line, intake-confirmation, boundary-note",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 3,
      "categoryRank": 12,
      "designFamilyRank": 3,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 09",
      "notes": "Harvested from screenshot 09; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "boundary-note",
        "checkmark",
        "circle",
        "client-briefing",
        "client-safety",
        "confirmation-line",
        "confirmed-route",
        "container-risk",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-privacy-discretion-shield",
        "discretion",
        "double-frame-risk",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "japansolved-shield-inside-circle-check-1",
        "line",
        "morphology-circle",
        "native-intake",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "privacy-discretion",
        "privacy-routing",
        "protection",
        "quiet",
        "recommended-free-only",
        "secondary-variant",
        "sensitive-discreet-routing",
        "shield",
        "shield-circle-check-01",
        "shield-inside-circle-check-1",
        "thin-to-medium",
        "trust",
        "trust-card",
        "trust-protection",
        "trust-symbol",
        "variant",
        "verification"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0088",
      "sequence": 88,
      "filename": "japansolved-reserved-pathway-crown-icon.svg",
      "handle": "japansolved-reserved-pathway-crown-icon",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-reserved-pathway-crown-icon.svg?v=1778375522",
      "assetType": "svg",
      "assetFamily": "Crown / Tier / Reserved Pathway Icons",
      "familyKey": "crown-tier-reserved-pathway-icons-premium-authority-crown",
      "rotationGroup": "reserved-pathway-crown-01",
      "cleanLabel": "Reserved Pathway Crown",
      "primaryCategory": "premium-authority",
      "categoryTokens": [
        "premium-authority"
      ],
      "purposeTags": [
        "reserved-pathway",
        "premium-access",
        "priority-route",
        "curated-tier",
        "exclusivity"
      ],
      "visualTags": [
        "line",
        "crown",
        "premium",
        "black-stroke",
        "reserved-signal"
      ],
      "sectionFit": [
        "tier-card",
        "reserved-pathway-card",
        "premium-card",
        "access-section"
      ],
      "rawBestSectionUse": "tier-card, reserved-pathway-card, premium-card, access-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 6,
      "categoryRank": 6,
      "designFamilyRank": 6,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 09",
      "notes": "Harvested from screenshot 09; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"premium-authority\" data-jsi-section=\"tier-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"premium-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "access-section",
        "authority-signal",
        "balanced",
        "black-stroke",
        "concierge-presence",
        "container-eligible",
        "crown",
        "crown-tier-reserved-pathway-icons",
        "crown-tier-reserved-pathway-icons-premium-authority-crown",
        "cultural-navigation",
        "curated-tier",
        "excellent",
        "exclusivity",
        "good-with-ivory-plate-or-css-filter",
        "japansolved-reserved-pathway-crown-icon",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium",
        "premium-access",
        "premium-authority",
        "premium-card",
        "premium-monoline",
        "premium-trust",
        "priority-route",
        "recommended-boxed-or-free",
        "reserved-access",
        "reserved-pathway",
        "reserved-pathway-card",
        "reserved-pathway-crown",
        "reserved-pathway-crown-01",
        "reserved-signal",
        "rotation-fallback",
        "tier-card",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0089",
      "sequence": 89,
      "filename": "4-js-icon-operational-capability.svg",
      "handle": "4-js-icon-operational-capability",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/4-js-icon-operational-capability.svg?v=1778896192",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-execution-support-briefcase",
      "rotationGroup": "operational-capability-01",
      "cleanLabel": "Operational Capability Briefcase",
      "primaryCategory": "execution-support",
      "categoryTokens": [
        "execution-support"
      ],
      "purposeTags": [
        "operational-capability",
        "execution",
        "business-readiness",
        "capacity",
        "service-delivery"
      ],
      "visualTags": [
        "line",
        "briefcase",
        "checkmark",
        "operational",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "capability-card",
        "service-card",
        "trust-card"
      ],
      "rawBestSectionUse": "process-step, capability-card, service-card, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "market-entry",
        "business-routing",
        "strategy-alignment"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 4,
      "categoryRank": 5,
      "designFamilyRank": 1,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"execution-support\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, market-entry, business-routing, strategy-alignment\" data-jsi-category=\"execution-support\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "4-js-icon-operational-capability",
        "balanced",
        "black-stroke",
        "briefcase",
        "business-readiness",
        "business-routing",
        "capability-card",
        "capacity",
        "cargo-execution",
        "checkmark",
        "container-eligible",
        "excellent",
        "execution",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "line",
        "local-representation",
        "logistics-local-representation",
        "market-entry",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-execution-support-briefcase",
        "operational",
        "operational-capability",
        "operational-capability-01",
        "operational-capability-briefcase",
        "outline-medium",
        "premium-monoline",
        "process-step",
        "recommended-boxed-or-free",
        "rotation-fallback",
        "service-card",
        "service-delivery",
        "strategy-alignment",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0091",
      "sequence": 91,
      "filename": "10-js-icon-execute.svg",
      "handle": "10-js-icon-execute",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/10-js-icon-execute.svg?v=1778896192",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-execution-support-arrow",
      "rotationGroup": "execute-arrow-10",
      "cleanLabel": "Execute Arrow",
      "primaryCategory": "execution-support",
      "categoryTokens": [
        "execution-support"
      ],
      "purposeTags": [
        "execute",
        "forward-movement",
        "completion",
        "action",
        "next-step"
      ],
      "visualTags": [
        "line",
        "arrow",
        "direction",
        "minimal",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "cta-support",
        "execution-card",
        "route-note"
      ],
      "rawBestSectionUse": "process-step, CTA-support, execution-card, route-note",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "minimal",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 65.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"execution-support\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"execution-support\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "10-js-icon-execute",
        "access-coordination",
        "action",
        "arrow",
        "black-stroke",
        "cargo-execution",
        "completion",
        "concierge-presence",
        "container-eligible",
        "cta-support",
        "cultural-navigation",
        "direction",
        "excellent",
        "execute",
        "execute-arrow",
        "execute-arrow-10",
        "execution-card",
        "execution-support",
        "forward-movement",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "line",
        "local-representation",
        "medium",
        "minimal",
        "morphology-none",
        "next-step",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-execution-support-arrow",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "route-note",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0092",
      "sequence": 92,
      "filename": "12-js-icon-business.svg",
      "handle": "12-js-icon-business",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/12-js-icon-business.svg?v=1778896192",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-business-market-entry-briefcase",
      "rotationGroup": "business-briefcase-12",
      "cleanLabel": "Business Briefcase",
      "primaryCategory": "business-market-entry",
      "categoryTokens": [
        "business-market-entry"
      ],
      "purposeTags": [
        "business",
        "corporate",
        "market-entry",
        "client-operations",
        "institutional-work"
      ],
      "visualTags": [
        "line",
        "briefcase",
        "business",
        "formal",
        "black-stroke"
      ],
      "sectionFit": [
        "business-section",
        "service-card",
        "product-ladder",
        "hub-card"
      ],
      "rawBestSectionUse": "business-section, service-card, product-ladder, hub-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "market-entry",
        "business-routing",
        "strategy-alignment",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "business-market-entry"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"business-market-entry\" data-jsi-section=\"business-section\" data-jsi-page-wing=\"business-market-entry\" data-jsi-pillars=\"market-entry, business-routing, strategy-alignment, native-intake, paid-routing, client-briefing\" data-jsi-category=\"business-market-entry\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "12-js-icon-business",
        "balanced",
        "black-stroke",
        "briefcase",
        "business",
        "business-briefcase",
        "business-briefcase-12",
        "business-market-entry",
        "business-routing",
        "business-section",
        "client-briefing",
        "client-operations",
        "container-eligible",
        "corporate",
        "excellent",
        "formal",
        "good-with-ivory-plate-or-css-filter",
        "hub-card",
        "institutional-work",
        "line",
        "market-entry",
        "medium",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-business-market-entry-briefcase",
        "outline-medium",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "product-ladder",
        "recommended-boxed-or-free",
        "service-card",
        "strategy-alignment"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0094",
      "sequence": 94,
      "filename": "15-js-icon-institutions.svg",
      "handle": "15-js-icon-institutions",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/15-js-icon-institutions.svg?v=1778896193",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-institutional-authority-institution",
      "rotationGroup": "institutions-15",
      "cleanLabel": "Institutions Building",
      "primaryCategory": "institutional-authority",
      "categoryTokens": [
        "institutional-authority"
      ],
      "purposeTags": [
        "institutions",
        "authority",
        "official-route",
        "governance",
        "representation"
      ],
      "visualTags": [
        "line",
        "institution",
        "columns",
        "formal",
        "black-stroke"
      ],
      "sectionFit": [
        "authority-card",
        "compliance-section",
        "local-representation-card",
        "trust-card"
      ],
      "rawBestSectionUse": "authority-card, compliance-section, local-representation-card, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"institutional-authority\" data-jsi-section=\"authority-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"institutional-authority\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "15-js-icon-institutions",
        "authority",
        "authority-card",
        "authority-signal",
        "balanced",
        "black-stroke",
        "client-briefing",
        "columns",
        "compliance-section",
        "container-eligible",
        "excellent",
        "formal",
        "good-with-ivory-plate-or-css-filter",
        "governance",
        "institution",
        "institutional-authority",
        "institutions",
        "institutions-15",
        "institutions-building",
        "line",
        "local-representation-card",
        "logistics-local-representation",
        "medium",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-institutional-authority-institution",
        "official-route",
        "outline-medium",
        "paid-routing",
        "premium-monoline",
        "premium-trust",
        "primary-default",
        "recommended-boxed-or-free",
        "representation",
        "reserved-access",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0095",
      "sequence": 95,
      "filename": "7-js-icon-assess.svg",
      "handle": "7-js-icon-assess",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/7-js-icon-assess.svg?v=1778896193",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-case-review-clipboard",
      "rotationGroup": "assess-checklist-07",
      "cleanLabel": "Assess Checklist",
      "primaryCategory": "case-review",
      "categoryTokens": [
        "case-review"
      ],
      "purposeTags": [
        "assessment",
        "checklist",
        "suitability",
        "case-review",
        "verification"
      ],
      "visualTags": [
        "line",
        "clipboard",
        "checklist",
        "review",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "review-card",
        "intake-header",
        "confirmation-line"
      ],
      "rawBestSectionUse": "process-step, review-card, intake-header, confirmation-line",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 4,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"case-review\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, native-intake, paid-routing, client-briefing\" data-jsi-category=\"case-review\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "7-js-icon-assess",
        "assess-checklist",
        "assess-checklist-07",
        "assessment",
        "balanced",
        "black-stroke",
        "case-intake",
        "case-review",
        "checklist",
        "client-briefing",
        "clipboard",
        "confirmation-line",
        "container-eligible",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intake-header",
        "line",
        "medium",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-case-review-clipboard",
        "outline-medium",
        "paid-review",
        "paid-routing",
        "premium-monoline",
        "process-step",
        "recommended-boxed-or-free",
        "review",
        "review-card",
        "review-intelligence",
        "secondary-variant",
        "suitability",
        "suitability-check",
        "verification"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0096",
      "sequence": 96,
      "filename": "01-js-icon-discretion-01.svg",
      "handle": "01-js-icon-discretion-01",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/01-js-icon-discretion-01.svg?v=1778922487",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-privacy-discretion-shield",
      "rotationGroup": "discretion-shield-lock-01",
      "cleanLabel": "Discretion Shield Lock",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "discretion",
        "privacy",
        "security",
        "sensitive-handling",
        "protected-case"
      ],
      "visualTags": [
        "line",
        "shield",
        "lock",
        "protection",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "boundary-note",
        "intake-confirmation",
        "sensitive-case-card"
      ],
      "rawBestSectionUse": "trust-card, boundary-note, intake-confirmation, sensitive-case-card",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 4,
      "categoryRank": 13,
      "designFamilyRank": 2,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "01-js-icon-discretion-01",
        "balanced",
        "black-stroke",
        "boundary-note",
        "client-briefing",
        "container-eligible",
        "discretion",
        "discretion-shield-lock",
        "discretion-shield-lock-01",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "line",
        "lock",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-privacy-discretion-shield",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "privacy",
        "privacy-discretion",
        "privacy-routing",
        "protected-case",
        "protection",
        "quiet",
        "recommended-boxed-or-free",
        "rotation-fallback",
        "security",
        "sensitive-case-card",
        "sensitive-discreet-routing",
        "sensitive-handling",
        "shield",
        "thin-to-medium",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0097",
      "sequence": 97,
      "filename": "06-js-icon-analyze-06.svg",
      "handle": "06-js-icon-analyze-06",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/06-js-icon-analyze-06.svg?v=1778922489",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-advisory-intelligence-document",
      "rotationGroup": "analyze-document-06",
      "cleanLabel": "Analyze Document Lens",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "analysis",
        "review",
        "document-check",
        "due-diligence",
        "intelligence"
      ],
      "visualTags": [
        "line",
        "document",
        "magnifier",
        "analytical",
        "black-stroke"
      ],
      "sectionFit": [
        "intelligence-block",
        "review-card",
        "process-step",
        "document-section"
      ],
      "rawBestSectionUse": "intelligence-block, review-card, process-step, document-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"intelligence-block\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "06-js-icon-analyze-06",
        "advisory-intelligence",
        "analysis",
        "analytical",
        "analyze-document-06",
        "analyze-document-lens",
        "balanced",
        "black-stroke",
        "container-eligible",
        "discretion",
        "document",
        "document-check",
        "document-section",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "line",
        "magnifier",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-advisory-intelligence-document",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-step",
        "recommended-boxed-or-free",
        "review",
        "review-card",
        "review-intelligence",
        "review-routing",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0098",
      "sequence": 98,
      "filename": "11-js-icon-individuals-11.svg",
      "handle": "11-js-icon-individuals-11",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/11-js-icon-individuals-11.svg?v=1778922488",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-client-people-people",
      "rotationGroup": "individuals-group-11",
      "cleanLabel": "Individuals Group",
      "primaryCategory": "client-people",
      "categoryTokens": [
        "client-people"
      ],
      "purposeTags": [
        "individuals",
        "people",
        "clients",
        "coordination",
        "human-support"
      ],
      "visualTags": [
        "line",
        "people",
        "group",
        "human",
        "black-stroke"
      ],
      "sectionFit": [
        "client-card",
        "support-card",
        "process-step",
        "companion-section"
      ],
      "rawBestSectionUse": "client-card, support-card, process-step, companion-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"client-people\" data-jsi-section=\"client-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion, route-intelligence, coordination, strategy\" data-jsi-category=\"client-people\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "11-js-icon-individuals-11",
        "balanced",
        "black-stroke",
        "client-card",
        "client-people",
        "clients",
        "companion-section",
        "completion",
        "container-eligible",
        "coordination",
        "excellent",
        "execution-support",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "group",
        "human",
        "human-support",
        "individuals",
        "individuals-group",
        "individuals-group-11",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-client-people-people",
        "outcome-control",
        "outline-light",
        "people",
        "premium-monoline",
        "primary-default",
        "process-step",
        "quiet",
        "recommended-boxed-or-free",
        "route-intelligence",
        "strategy",
        "support-card",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0099",
      "sequence": 99,
      "filename": "17-js-icon-layered-philosophy-17.svg",
      "handle": "17-js-icon-layered-philosophy-17",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/17-js-icon-layered-philosophy-17.svg?v=1778922488",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-advisory-intelligence-compass",
      "rotationGroup": "layered-philosophy-17",
      "cleanLabel": "Layered Philosophy Compass 17",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "philosophy",
        "strategic-framing",
        "route-logic",
        "layered-thinking",
        "judgment"
      ],
      "visualTags": [
        "line",
        "compass",
        "layered",
        "circular",
        "black-stroke",
        "numbered"
      ],
      "sectionFit": [
        "intelligence-block",
        "framework-card",
        "philosophy-section",
        "process-step"
      ],
      "rawBestSectionUse": "intelligence-block, framework-card, philosophy-section, process-step",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 6,
      "categoryRank": 12,
      "designFamilyRank": 3,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"intelligence-block\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "17-js-icon-layered-philosophy-17",
        "advisory-intelligence",
        "balanced",
        "black-stroke",
        "circular",
        "compass",
        "container-risk",
        "discretion",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "framework-card",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "judgment",
        "layered",
        "layered-philosophy-17",
        "layered-philosophy-compass-17",
        "layered-thinking",
        "line",
        "morphology-circle",
        "numbered",
        "numbered-general-icon-set",
        "numbered-general-icon-set-advisory-intelligence-compass",
        "outline-light",
        "philosophy",
        "philosophy-section",
        "premium-monoline",
        "privacy-routing",
        "process-step",
        "quiet",
        "recommended-free-only",
        "review-intelligence",
        "review-routing",
        "rotation-fallback",
        "route-logic",
        "sequence-badge",
        "strategic-framing",
        "thin-to-medium",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0100",
      "sequence": 100,
      "filename": "13-js-icon-collectors-13.svg",
      "handle": "13-js-icon-collectors-13",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/13-js-icon-collectors-13.svg?v=1778922488",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-luxury-collectibles-diamond",
      "rotationGroup": "collectors-diamond-13",
      "cleanLabel": "Collectors Diamond",
      "primaryCategory": "luxury-collectibles",
      "categoryTokens": [
        "luxury-collectibles"
      ],
      "purposeTags": [
        "collectors",
        "luxury-objects",
        "provenance",
        "acquisition",
        "high-value-goods"
      ],
      "visualTags": [
        "line",
        "diamond",
        "luxury",
        "collector",
        "black-stroke"
      ],
      "sectionFit": [
        "collector-card",
        "luxury-card",
        "product-ladder",
        "provenance-section"
      ],
      "rawBestSectionUse": "collector-card, luxury-card, product-ladder, provenance-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "sourcing",
        "private-buyer",
        "procurement-routing"
      ],
      "pageWingFit": [
        "sourcing-procurement-export"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"luxury-collectibles\" data-jsi-section=\"collector-card\" data-jsi-page-wing=\"sourcing-procurement-export\" data-jsi-pillars=\"sourcing, private-buyer, procurement-routing\" data-jsi-category=\"luxury-collectibles\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "13-js-icon-collectors-13",
        "acquisition",
        "balanced",
        "black-stroke",
        "collector",
        "collector-card",
        "collectors",
        "collectors-diamond",
        "collectors-diamond-13",
        "container-eligible",
        "diamond",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "high-value-goods",
        "line",
        "luxury",
        "luxury-card",
        "luxury-collectibles",
        "luxury-objects",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-luxury-collectibles-diamond",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "private-buyer",
        "procurement-routing",
        "product-ladder",
        "provenance",
        "provenance-section",
        "recommended-boxed-or-free",
        "sourcing",
        "sourcing-procurement-export"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0101",
      "sequence": 101,
      "filename": "14-js-icon-investors-14.svg",
      "handle": "14-js-icon-investors-14",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/14-js-icon-investors-14.svg?v=1778922488",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-investments-capital-building",
      "rotationGroup": "investors-building-14",
      "cleanLabel": "Investors Building",
      "primaryCategory": "investments-capital",
      "categoryTokens": [
        "investments-capital"
      ],
      "purposeTags": [
        "investors",
        "capital",
        "asset-strategy",
        "investment",
        "market-intelligence"
      ],
      "visualTags": [
        "line",
        "building",
        "capital",
        "institutional",
        "black-stroke"
      ],
      "sectionFit": [
        "investment-card",
        "authority-card",
        "business-section",
        "product-ladder"
      ],
      "rawBestSectionUse": "investment-card, authority-card, business-section, product-ladder",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "market-entry",
        "business-routing",
        "strategy-alignment"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 4,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"investments-capital\" data-jsi-section=\"investment-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, market-entry, business-routing, strategy-alignment\" data-jsi-category=\"investments-capital\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "14-js-icon-investors-14",
        "asset-strategy",
        "authority-card",
        "balanced",
        "black-stroke",
        "building",
        "business-routing",
        "business-section",
        "capital",
        "container-eligible",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "institutional",
        "intelligence",
        "investment",
        "investment-card",
        "investments-capital",
        "investors",
        "investors-building",
        "investors-building-14",
        "line",
        "market-entry",
        "market-intelligence",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-investments-capital-building",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "product-ladder",
        "recommended-boxed-or-free",
        "review-intelligence",
        "review-routing",
        "strategy-alignment"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0102",
      "sequence": 102,
      "filename": "02-js-icon-strategy-02.svg",
      "handle": "02-js-icon-strategy-02",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/02-js-icon-strategy-02.svg?v=1778922488",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-strategy-alignment-target",
      "rotationGroup": "strategy-target-02",
      "cleanLabel": "Strategy Target",
      "primaryCategory": "strategy-alignment",
      "categoryTokens": [
        "strategy-alignment"
      ],
      "purposeTags": [
        "strategy",
        "target",
        "planning",
        "route-alignment",
        "advisory-direction"
      ],
      "visualTags": [
        "line",
        "target",
        "bullseye",
        "strategic",
        "black-stroke"
      ],
      "sectionFit": [
        "strategy-card",
        "process-step",
        "intelligence-block",
        "route-note"
      ],
      "rawBestSectionUse": "strategy-card, process-step, intelligence-block, route-note",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 3,
      "categoryRank": 5,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 10",
      "notes": "Harvested from screenshot 10; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"strategy-alignment\" data-jsi-section=\"strategy-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"strategy-alignment\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "02-js-icon-strategy-02",
        "advisory-direction",
        "balanced",
        "black-stroke",
        "bullseye",
        "container-risk",
        "discretion",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "line",
        "medium",
        "morphology-circle-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-strategy-alignment-target",
        "outline-medium",
        "planning",
        "premium-monoline",
        "privacy-routing",
        "process-step",
        "recommended-free-only",
        "review-intelligence",
        "review-routing",
        "route-alignment",
        "route-note",
        "secondary-variant",
        "strategic",
        "strategy",
        "strategy-alignment",
        "strategy-card",
        "strategy-target",
        "strategy-target-02",
        "target",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0103",
      "sequence": 103,
      "filename": "03a-js-icon-japan-intelligence-03a.svg",
      "handle": "03a-js-icon-japan-intelligence-03a",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/03a-js-icon-japan-intelligence-03a.svg?v=1778922488",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-japan-intelligence-globe",
      "rotationGroup": "japan-intelligence-03a",
      "cleanLabel": "Japan Intelligence Globe Shield",
      "primaryCategory": "japan-intelligence",
      "categoryTokens": [
        "japan-intelligence"
      ],
      "purposeTags": [
        "japan-intelligence",
        "due-diligence",
        "market-understanding",
        "protection",
        "advisory"
      ],
      "visualTags": [
        "line",
        "globe",
        "shield",
        "japan-route",
        "black-stroke"
      ],
      "sectionFit": [
        "intelligence-block",
        "trust-card",
        "japan-route-section",
        "process-step"
      ],
      "rawBestSectionUse": "intelligence-block, trust-card, Japan-route-section, process-step",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 11",
      "notes": "Harvested from screenshot 11; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"japan-intelligence\" data-jsi-section=\"intelligence-block\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"japan-intelligence\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "03a-js-icon-japan-intelligence-03a",
        "advisory",
        "balanced",
        "black-stroke",
        "container-eligible",
        "discretion",
        "due-diligence",
        "excellent",
        "globe",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "japan-intelligence",
        "japan-intelligence-03a",
        "japan-intelligence-globe-shield",
        "japan-route",
        "japan-route-section",
        "line",
        "market-understanding",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-japan-intelligence-globe",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-step",
        "protection",
        "recommended-boxed-or-free",
        "review-intelligence",
        "review-routing",
        "shield",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0104",
      "sequence": 104,
      "filename": "03b-js-icon-japan-intelligence-03b.svg",
      "handle": "03b-js-icon-japan-intelligence-03b",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/03b-js-icon-japan-intelligence-03b.svg?v=1778922488",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-japan-intelligence-globe",
      "rotationGroup": "japan-intelligence-03b",
      "cleanLabel": "Japan Intelligence Globe Pin",
      "primaryCategory": "japan-intelligence",
      "categoryTokens": [
        "japan-intelligence"
      ],
      "purposeTags": [
        "japan-intelligence",
        "local-insight",
        "location-verification",
        "route-mapping",
        "advisory"
      ],
      "visualTags": [
        "line",
        "globe",
        "location-pin",
        "japan-route",
        "black-stroke"
      ],
      "sectionFit": [
        "intelligence-block",
        "route-note",
        "local-representation-card",
        "process-step"
      ],
      "rawBestSectionUse": "intelligence-block, route-note, local-representation-card, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 11",
      "notes": "Harvested from screenshot 11; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"japan-intelligence\" data-jsi-section=\"intelligence-block\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"japan-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "03b-js-icon-japan-intelligence-03b",
        "advisory",
        "balanced",
        "black-stroke",
        "container-eligible",
        "discretion",
        "due-diligence",
        "excellent",
        "globe",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "japan-intelligence",
        "japan-intelligence-03b",
        "japan-intelligence-globe-pin",
        "japan-route",
        "line",
        "local-insight",
        "local-representation-card",
        "location-pin",
        "location-verification",
        "logistics-local-representation",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-japan-intelligence-globe",
        "outline-medium",
        "premium-monoline",
        "privacy-routing",
        "process-step",
        "recommended-boxed-or-free",
        "review-routing",
        "route-mapping",
        "route-note",
        "secondary-variant",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0105",
      "sequence": 105,
      "filename": "08-js-icon-structure-08.svg",
      "handle": "08-js-icon-structure-08",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/08-js-icon-structure-08.svg?v=1778922488",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-systems-structure-hierarchy",
      "rotationGroup": "structure-hierarchy-08",
      "cleanLabel": "Structure Hierarchy",
      "primaryCategory": "systems-structure",
      "categoryTokens": [
        "systems-structure"
      ],
      "purposeTags": [
        "structure",
        "workflow",
        "hierarchy",
        "systems",
        "organization"
      ],
      "visualTags": [
        "line",
        "hierarchy",
        "connected-boxes",
        "process",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "framework-card",
        "workflow-section",
        "systems-card"
      ],
      "rawBestSectionUse": "process-step, framework-card, workflow-section, systems-card",
      "styleFamily": [
        "premium-monoline",
        "operations-symbol"
      ],
      "solutionPillars": [
        "sourcing",
        "private-buyer",
        "procurement-routing"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 11",
      "notes": "Harvested from screenshot 11; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"systems-structure\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"sourcing, private-buyer, procurement-routing\" data-jsi-category=\"systems-structure\" data-jsi-style=\"premium-monoline, operations-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "08-js-icon-structure-08",
        "balanced",
        "black-stroke",
        "connected-boxes",
        "container-risk",
        "double-frame-risk",
        "excellent",
        "framework-card",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "hierarchy",
        "line",
        "morphology-rounded-square",
        "numbered-general-icon-set",
        "numbered-general-icon-set-systems-structure-hierarchy",
        "object-cube-package",
        "operations-symbol",
        "organization",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "private-buyer",
        "process",
        "process-step",
        "procurement-routing",
        "quiet",
        "recommended-free-only",
        "sourcing",
        "structure",
        "structure-hierarchy",
        "structure-hierarchy-08",
        "systems",
        "systems-card",
        "systems-structure",
        "thin-to-medium",
        "workflow",
        "workflow-section"
      ],
      "morphology": {
        "intrinsicFrame": "rounded-square",
        "intrinsicFrameEvidence": [
          "frame/square keyword",
          "cube/package object; not a frame, but low-fit in premium boxed UI unless exact"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "cube/package",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0106",
      "sequence": 106,
      "filename": "05-js-icon-integrity-05.svg",
      "handle": "05-js-icon-integrity-05",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/05-js-icon-integrity-05.svg?v=1778922488",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-trust-verification-checkmark",
      "rotationGroup": "integrity-check-05",
      "cleanLabel": "Integrity Check Circle",
      "primaryCategory": "trust-verification",
      "categoryTokens": [
        "trust-verification"
      ],
      "purposeTags": [
        "integrity",
        "verification",
        "confirmation",
        "approval",
        "clean-completion"
      ],
      "visualTags": [
        "line",
        "checkmark",
        "circle",
        "minimal",
        "black-stroke"
      ],
      "sectionFit": [
        "trust-card",
        "intake-confirmation",
        "process-step",
        "faq-row"
      ],
      "rawBestSectionUse": "trust-card, intake-confirmation, process-step, FAQ-row",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "minimal",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 64.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 11",
      "notes": "Harvested from screenshot 11; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"trust-verification\" data-jsi-section=\"trust-card\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing, execution-support, outcome-control, completion\" data-jsi-category=\"trust-verification\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "05-js-icon-integrity-05",
        "approval",
        "black-stroke",
        "checkmark",
        "circle",
        "clean-completion",
        "client-briefing",
        "completion",
        "confirmation",
        "container-risk",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "faq-row",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "integrity",
        "integrity-check-05",
        "integrity-check-circle",
        "line",
        "minimal",
        "morphology-circle",
        "native-intake",
        "native-intake-system",
        "numbered-general-icon-set",
        "numbered-general-icon-set-trust-verification-checkmark",
        "outcome-control",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "process-step",
        "quiet",
        "recommended-free-only",
        "thin-to-medium",
        "trust-card",
        "trust-verification",
        "verification"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0107",
      "sequence": 107,
      "filename": "09-js-icon-coordinate-09.svg",
      "handle": "09-js-icon-coordinate-09",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/09-js-icon-coordinate-09.svg?v=1778922488",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-coordination-execution-nodes",
      "rotationGroup": "coordinate-network-09",
      "cleanLabel": "Coordinate Network Nodes",
      "primaryCategory": "coordination-execution",
      "categoryTokens": [
        "coordination-execution"
      ],
      "purposeTags": [
        "coordination",
        "network",
        "routing",
        "stakeholders",
        "orchestration"
      ],
      "visualTags": [
        "line",
        "nodes",
        "network",
        "connected",
        "black-stroke"
      ],
      "sectionFit": [
        "coordination-card",
        "process-step",
        "local-representation-card",
        "execution-section"
      ],
      "rawBestSectionUse": "coordination-card, process-step, local-representation-card, execution-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 11",
      "notes": "Harvested from screenshot 11; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"coordination-execution\" data-jsi-section=\"coordination-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"execution-support, outcome-control, completion, route-intelligence, coordination, strategy\" data-jsi-category=\"coordination-execution\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "09-js-icon-coordinate-09",
        "balanced",
        "black-stroke",
        "completion",
        "connected",
        "container-eligible",
        "coordinate-network-09",
        "coordinate-network-nodes",
        "coordination",
        "coordination-card",
        "coordination-execution",
        "excellent",
        "execution-section",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "local-representation-card",
        "logistics-local-representation",
        "medium",
        "morphology-none",
        "network",
        "no-double-frame-risk",
        "nodes",
        "numbered-general-icon-set",
        "numbered-general-icon-set-coordination-execution-nodes",
        "orchestration",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "route-intelligence",
        "routing",
        "stakeholders",
        "strategy"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0108",
      "sequence": 108,
      "filename": "14-js-how-it-works-vnext-icon-execution-14.svg",
      "handle": "14-js-how-it-works-vnext-icon-execution-14",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/14-js-how-it-works-vnext-icon-execution-14.svg?v=1778971250",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-execution-support-target",
      "rotationGroup": "how-it-works-execution-14",
      "cleanLabel": "How It Works Execution Target",
      "primaryCategory": "execution-support",
      "categoryTokens": [
        "execution-support"
      ],
      "purposeTags": [
        "execution",
        "how-it-works",
        "implementation",
        "target",
        "completion"
      ],
      "visualTags": [
        "line",
        "target",
        "arrow",
        "process",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "process-step",
        "execution-section",
        "cta-support"
      ],
      "rawBestSectionUse": "how-it-works-step, process-step, execution-section, CTA-support",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 6,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 12",
      "notes": "Harvested from screenshot 12; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"execution-support\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"execution-support\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "14-js-how-it-works-vnext-icon-execution-14",
        "arrow",
        "balanced",
        "black-stroke",
        "completion",
        "container-eligible",
        "cta-support",
        "excellent",
        "execution",
        "execution-section",
        "execution-support",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works",
        "how-it-works-execution-14",
        "how-it-works-execution-target",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-execution-support-target",
        "implementation",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process",
        "process-step",
        "recommended-boxed-or-free",
        "target"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0109",
      "sequence": 109,
      "filename": "03-js-how-it-works-vnext-icon-wisdom-led-assessment-03.svg",
      "handle": "03-js-how-it-works-vnext-icon-wisdom-led-assessment-03",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/03-js-how-it-works-vnext-icon-wisdom-led-assessment-03.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-advisory-intelligence-compass",
      "rotationGroup": "how-it-works-assessment-03",
      "cleanLabel": "How It Works Wisdom-Led Assessment",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "wisdom-led-assessment",
        "case-review",
        "advisory",
        "diagnosis",
        "intelligence"
      ],
      "visualTags": [
        "line",
        "compass",
        "assessment",
        "guidance",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "review-card",
        "advisory-block",
        "process-step"
      ],
      "rawBestSectionUse": "how-it-works-step, review-card, advisory-block, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 4,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 12",
      "notes": "Harvested from screenshot 12; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "03-js-how-it-works-vnext-icon-wisdom-led-assessment-03",
        "advisory",
        "advisory-block",
        "advisory-intelligence",
        "assessment",
        "balanced",
        "black-stroke",
        "case-review",
        "compass",
        "container-risk",
        "diagnosis",
        "discretion",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "guidance",
        "how-it-works-assessment-03",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-advisory-intelligence-compass",
        "how-it-works-wisdom-led-assessment",
        "intelligence",
        "line",
        "medium",
        "morphology-circle-risk",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-step",
        "recommended-free-only",
        "review-card",
        "review-intelligence",
        "review-routing",
        "trust-protection",
        "wisdom-led-assessment"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0110",
      "sequence": 110,
      "filename": "22-js-how-it-works-vnext-icon-serious-execution-22.svg",
      "handle": "22-js-how-it-works-vnext-icon-serious-execution-22",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/22-js-how-it-works-vnext-icon-serious-execution-22.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-execution-support-pen",
      "rotationGroup": "how-it-works-serious-execution-22",
      "cleanLabel": "How It Works Serious Execution",
      "primaryCategory": "execution-support",
      "categoryTokens": [
        "execution-support"
      ],
      "purposeTags": [
        "serious-execution",
        "implementation",
        "delivery",
        "operational-follow-through",
        "commitment"
      ],
      "visualTags": [
        "line",
        "pen",
        "signature",
        "execution-mark",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "process-step",
        "execution-section",
        "service-card"
      ],
      "rawBestSectionUse": "how-it-works-step, process-step, execution-section, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 7,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"execution-support\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, execution-support, outcome-control, completion\" data-jsi-category=\"execution-support\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "22-js-how-it-works-vnext-icon-serious-execution-22",
        "balanced",
        "black-stroke",
        "cargo-execution",
        "commitment",
        "completion",
        "container-eligible",
        "delivery",
        "excellent",
        "execution-mark",
        "execution-section",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "how-it-works-serious-execution",
        "how-it-works-serious-execution-22",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-execution-support-pen",
        "implementation",
        "line",
        "local-representation",
        "logistics-local-representation",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "operational-follow-through",
        "outcome-control",
        "outline-medium",
        "pen",
        "premium-monoline",
        "process-step",
        "recommended-boxed-or-free",
        "secondary-variant",
        "serious-execution",
        "service-card",
        "signature"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0111",
      "sequence": 111,
      "filename": "20-js-how-it-works-vnext-icon-scope-discipline-20.svg",
      "handle": "20-js-how-it-works-vnext-icon-scope-discipline-20",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/20-js-how-it-works-vnext-icon-scope-discipline-20.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-scope-discipline-measured-frame",
      "rotationGroup": "how-it-works-scope-discipline-20",
      "cleanLabel": "How It Works Scope Discipline",
      "primaryCategory": "scope-discipline",
      "categoryTokens": [
        "scope-discipline"
      ],
      "purposeTags": [
        "scope-control",
        "boundaries",
        "discipline",
        "containment",
        "service-definition"
      ],
      "visualTags": [
        "line",
        "measured-frame",
        "scope-box",
        "structured",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "boundary-note",
        "service-scope-card",
        "faq-row"
      ],
      "rawBestSectionUse": "how-it-works-step, boundary-note, service-scope-card, FAQ-row",
      "styleFamily": [
        "premium-monoline",
        "operations-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "sourcing",
        "private-buyer",
        "procurement-routing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"scope-discipline\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, sourcing, private-buyer, procurement-routing\" data-jsi-category=\"scope-discipline\" data-jsi-style=\"premium-monoline, operations-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "20-js-how-it-works-vnext-icon-scope-discipline-20",
        "balanced",
        "black-stroke",
        "boundaries",
        "boundary-note",
        "container-risk",
        "containment",
        "discipline",
        "discretion",
        "double-frame-risk",
        "excellent",
        "faq-row",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-scope-discipline",
        "how-it-works-scope-discipline-20",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-scope-discipline-measured-frame",
        "line",
        "measured-frame",
        "morphology-rounded-square",
        "object-cube-package",
        "operations-symbol",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "private-buyer",
        "procurement-routing",
        "quiet",
        "recommended-free-only",
        "scope-box",
        "scope-control",
        "scope-discipline",
        "sensitive-discreet-routing",
        "service-definition",
        "service-scope-card",
        "sourcing",
        "structured",
        "thin-to-medium",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "rounded-square",
        "intrinsicFrameEvidence": [
          "frame/square keyword",
          "cube/package object; not a frame, but low-fit in premium boxed UI unless exact"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "cube/package",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0112",
      "sequence": 112,
      "filename": "02-js-how-it-works-vnext-icon-case-acceptance-review-02.svg",
      "handle": "02-js-how-it-works-vnext-icon-case-acceptance-review-02",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/02-js-how-it-works-vnext-icon-case-acceptance-review-02.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-case-review-clipboard",
      "rotationGroup": "how-it-works-acceptance-review-02",
      "cleanLabel": "How It Works Acceptance Review",
      "primaryCategory": "case-review",
      "categoryTokens": [
        "case-review"
      ],
      "purposeTags": [
        "acceptance-review",
        "suitability",
        "paid-review",
        "intake-triage",
        "approval-path"
      ],
      "visualTags": [
        "line",
        "clipboard",
        "check",
        "review",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "intake-confirmation",
        "review-card",
        "product-ladder"
      ],
      "rawBestSectionUse": "how-it-works-step, intake-confirmation, review-card, product-ladder",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 5,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL. | Original C handle did not match URL filename; polished handle uses URL as source of truth.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"case-review\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, native-intake, paid-routing, client-briefing\" data-jsi-category=\"case-review\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "02-js-how-it-works-vnext-icon-case-acceptance-review-02",
        "acceptance-review",
        "approval-path",
        "balanced",
        "black-stroke",
        "case-intake",
        "case-review",
        "check",
        "client-briefing",
        "clipboard",
        "container-eligible",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-acceptance-review",
        "how-it-works-acceptance-review-02",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-case-review-clipboard",
        "intake-confirmation",
        "intake-triage",
        "line",
        "medium",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-medium",
        "paid-review",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "product-ladder",
        "recommended-boxed-or-free",
        "review",
        "review-card",
        "review-intelligence",
        "suitability",
        "suitability-check"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0113",
      "sequence": 113,
      "filename": "19-js-how-it-works-vnext-icon-commitment-layers-19.svg",
      "handle": "19-js-how-it-works-vnext-icon-commitment-layers-19",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/19-js-how-it-works-vnext-icon-commitment-layers-19.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-commitment-structure-stacked-layers",
      "rotationGroup": "how-it-works-commitment-layers-19",
      "cleanLabel": "How It Works Commitment Layers",
      "primaryCategory": "commitment-structure",
      "categoryTokens": [
        "commitment-structure"
      ],
      "purposeTags": [
        "commitment-layers",
        "phased-work",
        "structured-engagement",
        "layered-process"
      ],
      "visualTags": [
        "line",
        "stacked-layers",
        "framework",
        "structured",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "process-step",
        "product-ladder",
        "framework-card"
      ],
      "rawBestSectionUse": "how-it-works-step, process-step, product-ladder, framework-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "general-service-support"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"commitment-structure\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"general-service-support\" data-jsi-category=\"commitment-structure\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "19-js-how-it-works-vnext-icon-commitment-layers-19",
        "balanced",
        "black-stroke",
        "commitment-layers",
        "commitment-structure",
        "container-risk",
        "double-frame-risk",
        "excellent",
        "framework",
        "framework-card",
        "general-japansolved-system",
        "general-service-support",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-commitment-layers",
        "how-it-works-commitment-layers-19",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-commitment-structure-stacked-layers",
        "layered-process",
        "line",
        "medium",
        "morphology-rounded-square",
        "outline-medium",
        "phased-work",
        "premium-monoline",
        "primary-default",
        "process-step",
        "product-ladder",
        "recommended-free-only",
        "stacked-layers",
        "structured",
        "structured-engagement"
      ],
      "morphology": {
        "intrinsicFrame": "rounded-square",
        "intrinsicFrameEvidence": [
          "frame/square keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0114",
      "sequence": 114,
      "filename": "01-js-how-it-works-vnext-icon-private-intake-01.svg",
      "handle": "01-js-how-it-works-vnext-icon-private-intake-01",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/01-js-how-it-works-vnext-icon-private-intake-01.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-native-intake-institution",
      "rotationGroup": "how-it-works-private-intake-01",
      "cleanLabel": "How It Works Private Intake",
      "primaryCategory": "native-intake",
      "categoryTokens": [
        "native-intake"
      ],
      "purposeTags": [
        "private-intake",
        "request-submission",
        "case-file",
        "confidential-request",
        "onboarding"
      ],
      "visualTags": [
        "line",
        "institution",
        "intake-gate",
        "formal",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "intake-section",
        "trust-card",
        "cta-support"
      ],
      "rawBestSectionUse": "how-it-works-step, intake-section, trust-card, CTA-support",
      "styleFamily": [
        "premium-monoline",
        "japan-cultural-symbol"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"native-intake\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, native-intake, paid-routing, client-briefing\" data-jsi-category=\"native-intake\" data-jsi-style=\"premium-monoline, japan-cultural-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "01-js-how-it-works-vnext-icon-private-intake-01",
        "access-coordination",
        "balanced",
        "black-stroke",
        "case-file",
        "client-briefing",
        "concierge-presence",
        "confidential-request",
        "container-eligible",
        "cta-support",
        "cultural-navigation",
        "excellent",
        "formal",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-private-intake",
        "how-it-works-private-intake-01",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-native-intake-institution",
        "institution",
        "intake-gate",
        "intake-section",
        "japan-cultural-symbol",
        "line",
        "medium",
        "morphology-none",
        "native-intake",
        "native-intake-system",
        "no-double-frame-risk",
        "onboarding",
        "outline-medium",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "private-intake",
        "recommended-boxed-or-free",
        "request-submission",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0115",
      "sequence": 115,
      "filename": "15-js-how-it-works-vnext-icon-ongoing-stewardship-15.svg",
      "handle": "15-js-how-it-works-vnext-icon-ongoing-stewardship-15",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/15-js-how-it-works-vnext-icon-ongoing-stewardship-15.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-stewardship-support-flower",
      "rotationGroup": "how-it-works-ongoing-stewardship-15",
      "cleanLabel": "How It Works Ongoing Stewardship",
      "primaryCategory": "stewardship-support",
      "categoryTokens": [
        "stewardship-support"
      ],
      "purposeTags": [
        "ongoing-stewardship",
        "continuity",
        "care",
        "oversight",
        "relationship-management"
      ],
      "visualTags": [
        "line",
        "flower",
        "orbit",
        "continuity",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "retainer-card",
        "trust-card",
        "service-card"
      ],
      "rawBestSectionUse": "how-it-works-step, retainer-card, trust-card, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"stewardship-support\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"stewardship-support\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "15-js-how-it-works-vnext-icon-ongoing-stewardship-15",
        "balanced",
        "black-stroke",
        "care",
        "completion",
        "container-risk",
        "continuity",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "flower",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-ongoing-stewardship",
        "how-it-works-ongoing-stewardship-15",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-stewardship-support-flower",
        "line",
        "morphology-circle",
        "ongoing-stewardship",
        "orbit",
        "outcome-control",
        "outline-light",
        "oversight",
        "premium-monoline",
        "primary-default",
        "quiet",
        "recommended-free-only",
        "relationship-management",
        "retainer-card",
        "service-card",
        "stewardship-support",
        "thin-to-medium",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0116",
      "sequence": 116,
      "filename": "11-js-how-it-works-vnext-icon-final-invoice-11.svg",
      "handle": "11-js-how-it-works-vnext-icon-final-invoice-11",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/11-js-how-it-works-vnext-icon-final-invoice-11.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-payment-terms-invoice",
      "rotationGroup": "how-it-works-final-invoice-11",
      "cleanLabel": "How It Works Final Invoice",
      "primaryCategory": "payment-terms",
      "categoryTokens": [
        "payment-terms"
      ],
      "purposeTags": [
        "final-invoice",
        "payment",
        "billing",
        "completion",
        "commercial-closeout"
      ],
      "visualTags": [
        "line",
        "invoice",
        "money-marker",
        "payment-document",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "payment-note",
        "product-card",
        "process-step"
      ],
      "rawBestSectionUse": "how-it-works-step, payment-note, product-card, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"payment-terms\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing, execution-support, outcome-control, completion\" data-jsi-category=\"payment-terms\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "11-js-how-it-works-vnext-icon-final-invoice-11",
        "balanced",
        "billing",
        "black-stroke",
        "client-briefing",
        "commercial-closeout",
        "completion",
        "container-eligible",
        "excellent",
        "execution-support",
        "final-invoice",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-final-invoice",
        "how-it-works-final-invoice-11",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-payment-terms-invoice",
        "invoice",
        "line",
        "medium",
        "money-marker",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outcome-control",
        "outline-medium",
        "paid-routing",
        "payment",
        "payment-document",
        "payment-note",
        "payment-terms",
        "premium-monoline",
        "primary-default",
        "process-step",
        "product-card",
        "recommended-boxed-or-free"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0117",
      "sequence": 117,
      "filename": "23-js-how-it-works-vnext-icon-experienced-judgment-23.svg",
      "handle": "23-js-how-it-works-vnext-icon-experienced-judgment-23",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/23-js-how-it-works-vnext-icon-experienced-judgment-23.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-advisory-intelligence-document",
      "rotationGroup": "how-it-works-experienced-judgment-23",
      "cleanLabel": "How It Works Experienced Judgment",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "experienced-judgment",
        "expert-review",
        "discernment",
        "due-diligence",
        "evaluation"
      ],
      "visualTags": [
        "line",
        "document",
        "magnifier",
        "judgment",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "advisory-block",
        "review-card",
        "intelligence-block"
      ],
      "rawBestSectionUse": "how-it-works-step, advisory-block, review-card, intelligence-block",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 5,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "23-js-how-it-works-vnext-icon-experienced-judgment-23",
        "advisory-block",
        "advisory-intelligence",
        "balanced",
        "black-stroke",
        "container-eligible",
        "discernment",
        "discretion",
        "document",
        "due-diligence",
        "evaluation",
        "excellent",
        "experienced-judgment",
        "expert-review",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-experienced-judgment",
        "how-it-works-experienced-judgment-23",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-advisory-intelligence-document",
        "intelligence",
        "intelligence-block",
        "judgment",
        "line",
        "magnifier",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "privacy-routing",
        "recommended-boxed-or-free",
        "review-card",
        "review-intelligence",
        "review-routing",
        "secondary-variant",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0118",
      "sequence": 118,
      "filename": "21-js-how-it-works-vnext-icon-structured-clarity-21.svg",
      "handle": "21-js-how-it-works-vnext-icon-structured-clarity-21",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/21-js-how-it-works-vnext-icon-structured-clarity-21.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-strategy-alignment-compass",
      "rotationGroup": "how-it-works-structured-clarity-21",
      "cleanLabel": "How It Works Structured Clarity",
      "primaryCategory": "strategy-alignment",
      "categoryTokens": [
        "strategy-alignment"
      ],
      "purposeTags": [
        "structured-clarity",
        "route-clarity",
        "direction",
        "orientation",
        "plan-intelligence"
      ],
      "visualTags": [
        "line",
        "compass",
        "clarity",
        "navigation",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "route-note",
        "strategy-card",
        "process-step"
      ],
      "rawBestSectionUse": "how-it-works-step, route-note, strategy-card, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 6,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"strategy-alignment\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, route-intelligence, coordination, strategy\" data-jsi-category=\"strategy-alignment\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "21-js-how-it-works-vnext-icon-structured-clarity-21",
        "balanced",
        "black-stroke",
        "clarity",
        "compass",
        "container-risk",
        "coordination",
        "direction",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-step",
        "how-it-works-structured-clarity",
        "how-it-works-structured-clarity-21",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-strategy-alignment-compass",
        "intelligence",
        "line",
        "medium",
        "morphology-circle-risk",
        "navigation",
        "orientation",
        "outline-medium",
        "plan-intelligence",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-free-only",
        "review-intelligence",
        "review-routing",
        "route-clarity",
        "route-intelligence",
        "route-note",
        "strategy",
        "strategy-alignment",
        "strategy-card",
        "structured-clarity"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0119",
      "sequence": 119,
      "filename": "24-js-how-it-works-vnext-icon-human-layered-intelligence-24.svg",
      "handle": "24-js-how-it-works-vnext-icon-human-layered-intelligence-24",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/24-js-how-it-works-vnext-icon-human-layered-intelligence-24.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-advisory-intelligence-head-profile",
      "rotationGroup": "how-it-works-layered-intelligence-24",
      "cleanLabel": "How It Works Layered Intelligence",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "layered-intelligence",
        "research-depth",
        "pattern-reading",
        "strategic-insight"
      ],
      "visualTags": [
        "line",
        "head-profile",
        "fingerprint",
        "cognition",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "intelligence-block",
        "advisory-card",
        "trust-card"
      ],
      "rawBestSectionUse": "how-it-works-step, intelligence-block, advisory-card, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-statement",
      "visualDensity": "dense-statement",
      "lineWeight": "medium-bold",
      "intensity": "statement",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 61.0,
      "familyCategoryRank": 3,
      "categoryRank": 14,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL. | Original C handle did not match URL filename; polished handle uses URL as source of truth.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_statement\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "24-js-how-it-works-vnext-icon-human-layered-intelligence-24",
        "advisory-card",
        "advisory-intelligence",
        "black-stroke",
        "cognition",
        "container-eligible",
        "dense-statement",
        "discretion",
        "due-diligence",
        "excellent",
        "fingerprint",
        "good-with-ivory-plate-or-css-filter",
        "head-profile",
        "how-it-works-layered-intelligence",
        "how-it-works-layered-intelligence-24",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-advisory-intelligence-head-profile",
        "intelligence",
        "intelligence-block",
        "layered-intelligence",
        "line",
        "medium-bold",
        "morphology-none",
        "no-double-frame-risk",
        "outline-statement",
        "pattern-reading",
        "premium-monoline",
        "privacy-routing",
        "recommended-boxed-or-free",
        "research-depth",
        "review-intelligence",
        "review-routing",
        "secondary-variant",
        "statement",
        "strategic-insight",
        "trust-card",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0120",
      "sequence": 120,
      "filename": "17-js-how-it-works-vnext-icon-referral-direction-17.svg",
      "handle": "17-js-how-it-works-vnext-icon-referral-direction-17",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/17-js-how-it-works-vnext-icon-referral-direction-17.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-routing-referral-signpost",
      "rotationGroup": "how-it-works-referral-direction-17",
      "cleanLabel": "How It Works Referral Direction",
      "primaryCategory": "routing-referral",
      "categoryTokens": [
        "routing-referral"
      ],
      "purposeTags": [
        "referral-direction",
        "route-selection",
        "next-step",
        "handoff",
        "guidance"
      ],
      "visualTags": [
        "line",
        "signpost",
        "direction-marker",
        "route",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "route-note",
        "related-card",
        "process-step"
      ],
      "rawBestSectionUse": "how-it-works-step, route-note, related-card, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "general-service-support"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"routing-referral\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"general-service-support\" data-jsi-category=\"routing-referral\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "17-js-how-it-works-vnext-icon-referral-direction-17",
        "balanced",
        "black-stroke",
        "container-eligible",
        "direction-marker",
        "excellent",
        "general-japansolved-system",
        "general-service-support",
        "good-with-ivory-plate-or-css-filter",
        "guidance",
        "handoff",
        "how-it-works-referral-direction",
        "how-it-works-referral-direction-17",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-routing-referral-signpost",
        "line",
        "morphology-none",
        "next-step",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "process-step",
        "quiet",
        "recommended-boxed-or-free",
        "referral-direction",
        "related-card",
        "route",
        "route-note",
        "route-selection",
        "routing-referral",
        "signpost",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0121",
      "sequence": 121,
      "filename": "05-js-how-it-works-vnext-icon-directional-response-05.svg",
      "handle": "05-js-how-it-works-vnext-icon-directional-response-05",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/05-js-how-it-works-vnext-icon-directional-response-05.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-route-response-branching-arrows",
      "rotationGroup": "how-it-works-directional-response-05",
      "cleanLabel": "How It Works Directional Response",
      "primaryCategory": "route-response",
      "categoryTokens": [
        "route-response"
      ],
      "purposeTags": [
        "directional-response",
        "routing",
        "response-path",
        "triage-direction",
        "options"
      ],
      "visualTags": [
        "line",
        "branching-arrows",
        "direction",
        "routing",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "route-note",
        "cta-support",
        "process-step"
      ],
      "rawBestSectionUse": "how-it-works-step, route-note, CTA-support, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"route-response\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"route-response\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "05-js-how-it-works-vnext-icon-directional-response-05",
        "balanced",
        "black-stroke",
        "branching-arrows",
        "completion",
        "container-eligible",
        "cta-support",
        "direction",
        "directional-response",
        "excellent",
        "execution-support",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-directional-response",
        "how-it-works-directional-response-05",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-route-response-branching-arrows",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "options",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "response-path",
        "route-note",
        "route-response",
        "routing",
        "triage-direction"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0122",
      "sequence": 122,
      "filename": "16-js-how-it-works-vnext-icon-confidentiality-16.svg",
      "handle": "16-js-how-it-works-vnext-icon-confidentiality-16",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/16-js-how-it-works-vnext-icon-confidentiality-16.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-privacy-discretion-shield",
      "rotationGroup": "how-it-works-confidentiality-16",
      "cleanLabel": "How It Works Confidentiality",
      "primaryCategory": "privacy-discretion",
      "categoryTokens": [
        "privacy-discretion"
      ],
      "purposeTags": [
        "confidentiality",
        "protection",
        "sensitive-handling",
        "privacy",
        "secure-request"
      ],
      "visualTags": [
        "line",
        "shield",
        "lock",
        "protection",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "trust-card",
        "boundary-note",
        "intake-confirmation"
      ],
      "rawBestSectionUse": "how-it-works-step, trust-card, boundary-note, intake-confirmation",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 14,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-discretion\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"privacy-discretion\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "16-js-how-it-works-vnext-icon-confidentiality-16",
        "balanced",
        "black-stroke",
        "boundary-note",
        "client-briefing",
        "confidentiality",
        "container-eligible",
        "discretion",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-confidentiality",
        "how-it-works-confidentiality-16",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-privacy-discretion-shield",
        "intake-confirmation",
        "line",
        "lock",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "privacy",
        "privacy-discretion",
        "privacy-routing",
        "protection",
        "quiet",
        "recommended-boxed-or-free",
        "secure-request",
        "sensitive-discreet-routing",
        "sensitive-handling",
        "shield",
        "thin-to-medium",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0123",
      "sequence": 123,
      "filename": "06-js-how-it-works-vnext-icon-accepted-in-principle-06.svg",
      "handle": "06-js-how-it-works-vnext-icon-accepted-in-principle-06",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/06-js-how-it-works-vnext-icon-accepted-in-principle-06.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-acceptance-status-seal",
      "rotationGroup": "how-it-works-accepted-in-principle-06",
      "cleanLabel": "How It Works Accepted In Principle",
      "primaryCategory": "acceptance-status",
      "categoryTokens": [
        "acceptance-status"
      ],
      "purposeTags": [
        "accepted-in-principle",
        "preliminary-approval",
        "confirmation",
        "suitability",
        "greenlight"
      ],
      "visualTags": [
        "line",
        "seal",
        "check",
        "approval-badge",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "intake-confirmation",
        "review-card",
        "product-ladder"
      ],
      "rawBestSectionUse": "how-it-works-step, intake-confirmation, review-card, product-ladder",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 13",
      "notes": "Harvested from screenshot 13; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"acceptance-status\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, native-intake, paid-routing, client-briefing\" data-jsi-category=\"acceptance-status\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "06-js-how-it-works-vnext-icon-accepted-in-principle-06",
        "acceptance-status",
        "accepted-in-principle",
        "approval-badge",
        "balanced",
        "black-stroke",
        "case-intake",
        "check",
        "client-briefing",
        "confirmation",
        "container-risk",
        "double-frame-risk",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "greenlight",
        "how-it-works-accepted-in-principle",
        "how-it-works-accepted-in-principle-06",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-acceptance-status-seal",
        "intake-confirmation",
        "line",
        "medium",
        "morphology-circle",
        "native-intake",
        "outline-medium",
        "paid-review",
        "paid-routing",
        "preliminary-approval",
        "premium-monoline",
        "primary-default",
        "product-ladder",
        "recommended-free-only",
        "review-card",
        "review-intelligence",
        "seal",
        "suitability",
        "suitability-check"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0124",
      "sequence": 124,
      "filename": "12-js-how-it-works-vnext-icon-settlement-12.svg",
      "handle": "12-js-how-it-works-vnext-icon-settlement-12",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/12-js-how-it-works-vnext-icon-settlement-12.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-payment-settlement-document",
      "rotationGroup": "how-it-works-settlement-12",
      "cleanLabel": "How It Works Settlement",
      "primaryCategory": "payment-settlement",
      "categoryTokens": [
        "payment-settlement"
      ],
      "purposeTags": [
        "settlement",
        "payment-completion",
        "invoice-closure",
        "secure-processing",
        "case-resolution"
      ],
      "visualTags": [
        "line",
        "document",
        "coin",
        "lock",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "payment-note",
        "intake-confirmation",
        "process-step"
      ],
      "rawBestSectionUse": "how-it-works-step, payment-note, intake-confirmation, process-step",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 14",
      "notes": "Harvested from screenshot 14; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"payment-settlement\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"payment-settlement\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "12-js-how-it-works-vnext-icon-settlement-12",
        "balanced",
        "black-stroke",
        "case-resolution",
        "client-briefing",
        "coin",
        "container-risk",
        "discretion",
        "document",
        "double-frame-risk",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-settlement",
        "how-it-works-settlement-12",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-payment-settlement-document",
        "intake-confirmation",
        "invoice-closure",
        "line",
        "lock",
        "medium",
        "morphology-circle",
        "native-intake",
        "native-intake-system",
        "outline-medium",
        "paid-routing",
        "payment-completion",
        "payment-note",
        "payment-settlement",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-step",
        "recommended-free-only",
        "secure-processing",
        "settlement",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0125",
      "sequence": 125,
      "filename": "13-js-how-it-works-vnext-icon-activation-13.svg",
      "handle": "13-js-how-it-works-vnext-icon-activation-13",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/13-js-how-it-works-vnext-icon-activation-13.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-activation-access-torii-gate",
      "rotationGroup": "how-it-works-activation-13",
      "cleanLabel": "How It Works Activation",
      "primaryCategory": "activation-access",
      "categoryTokens": [
        "activation-access"
      ],
      "purposeTags": [
        "activation",
        "gateway",
        "access-start",
        "request-opened",
        "case-launch"
      ],
      "visualTags": [
        "line",
        "torii-gate",
        "activation",
        "heritage",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "cta-support",
        "service-card",
        "process-step"
      ],
      "rawBestSectionUse": "how-it-works-step, CTA-support, service-card, process-step",
      "styleFamily": [
        "premium-monoline",
        "japan-cultural-symbol"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 14",
      "notes": "Harvested from screenshot 14; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"activation-access\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, native-intake, paid-routing, client-briefing\" data-jsi-category=\"activation-access\" data-jsi-style=\"premium-monoline, japan-cultural-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "13-js-how-it-works-vnext-icon-activation-13",
        "access-coordination",
        "access-start",
        "activation",
        "activation-access",
        "balanced",
        "black-stroke",
        "case-launch",
        "client-briefing",
        "concierge-presence",
        "container-eligible",
        "cta-support",
        "cultural-navigation",
        "excellent",
        "gateway",
        "good-with-ivory-plate-or-css-filter",
        "heritage",
        "how-it-works-activation",
        "how-it-works-activation-13",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-activation-access-torii-gate",
        "japan-cultural-symbol",
        "line",
        "medium",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-medium",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "request-opened",
        "service-card",
        "torii-gate",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0126",
      "sequence": 126,
      "filename": "07-js-how-it-works-vnext-icon-declined-redirected-07.svg",
      "handle": "07-js-how-it-works-vnext-icon-declined-redirected-07",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/07-js-how-it-works-vnext-icon-declined-redirected-07.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-routing-referral-signpost",
      "rotationGroup": "how-it-works-declined-redirected-07",
      "cleanLabel": "How It Works Declined Redirected",
      "primaryCategory": "routing-referral",
      "categoryTokens": [
        "routing-referral"
      ],
      "purposeTags": [
        "declined-redirected",
        "unsuitable-request",
        "referral-path",
        "route-correction",
        "boundary-handling"
      ],
      "visualTags": [
        "line",
        "signpost",
        "redirection",
        "decision-path",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "boundary-note",
        "route-note",
        "faq-row"
      ],
      "rawBestSectionUse": "how-it-works-step, boundary-note, route-note, FAQ-row",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 14",
      "notes": "Harvested from screenshot 14; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"routing-referral\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"routing-referral\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "07-js-how-it-works-vnext-icon-declined-redirected-07",
        "balanced",
        "black-stroke",
        "boundary-handling",
        "boundary-note",
        "client-briefing",
        "container-eligible",
        "decision-path",
        "declined-redirected",
        "discretion",
        "excellent",
        "faq-row",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-declined-redirected",
        "how-it-works-declined-redirected-07",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-routing-referral-signpost",
        "line",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "privacy-routing",
        "quiet",
        "recommended-boxed-or-free",
        "redirection",
        "referral-path",
        "route-correction",
        "route-note",
        "routing-referral",
        "secondary-variant",
        "sensitive-discreet-routing",
        "signpost",
        "thin-to-medium",
        "trust-protection",
        "unsuitable-request"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0127",
      "sequence": 127,
      "filename": "18-js-how-it-works-vnext-icon-no-unpaid-strategy-18.svg",
      "handle": "18-js-how-it-works-vnext-icon-no-unpaid-strategy-18",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/18-js-how-it-works-vnext-icon-no-unpaid-strategy-18.svg?v=1778971251",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-paid-intake-boundary-shield",
      "rotationGroup": "how-it-works-no-unpaid-strategy-18",
      "cleanLabel": "How It Works No Unpaid Strategy",
      "primaryCategory": "paid-intake-boundary",
      "categoryTokens": [
        "paid-intake-boundary"
      ],
      "purposeTags": [
        "no-unpaid-strategy",
        "paid-review-boundary",
        "scope-protection",
        "value-gate",
        "advisory-boundary"
      ],
      "visualTags": [
        "line",
        "shield",
        "cognition",
        "boundary",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "payment-note",
        "boundary-note",
        "intake-confirmation"
      ],
      "rawBestSectionUse": "how-it-works-step, payment-note, boundary-note, intake-confirmation",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-statement",
      "visualDensity": "dense-statement",
      "lineWeight": "medium-bold",
      "intensity": "statement",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 61.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 14",
      "notes": "Harvested from screenshot 14; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"paid-intake-boundary\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"paid-intake-boundary\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_statement\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "18-js-how-it-works-vnext-icon-no-unpaid-strategy-18",
        "advisory-boundary",
        "black-stroke",
        "boundary",
        "boundary-note",
        "cognition",
        "container-eligible",
        "dense-statement",
        "discretion",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-no-unpaid-strategy",
        "how-it-works-no-unpaid-strategy-18",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-paid-intake-boundary-shield",
        "intake-confirmation",
        "intelligence",
        "line",
        "medium-bold",
        "morphology-none",
        "no-double-frame-risk",
        "no-unpaid-strategy",
        "outline-statement",
        "paid-intake-boundary",
        "paid-review-boundary",
        "payment-note",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "recommended-boxed-or-free",
        "review-routing",
        "scope-protection",
        "sensitive-discreet-routing",
        "shield",
        "statement",
        "trust-protection",
        "trust-symbol",
        "value-gate"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0128",
      "sequence": 128,
      "filename": "08-js-how-it-works-vnext-icon-quotation-estimates-08.svg",
      "handle": "08-js-how-it-works-vnext-icon-quotation-estimates-08",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/08-js-how-it-works-vnext-icon-quotation-estimates-08.svg?v=1778971252",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-quotation-estimate-document",
      "rotationGroup": "how-it-works-quotation-estimates-08",
      "cleanLabel": "How It Works Quotation Estimates",
      "primaryCategory": "quotation-estimate",
      "categoryTokens": [
        "quotation-estimate"
      ],
      "purposeTags": [
        "quotation",
        "estimates",
        "pricing",
        "fee-preview",
        "cost-framing"
      ],
      "visualTags": [
        "line",
        "document",
        "money",
        "estimate",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "product-ladder",
        "payment-note",
        "faq-row"
      ],
      "rawBestSectionUse": "how-it-works-step, product-ladder, payment-note, FAQ-row",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 14",
      "notes": "Harvested from screenshot 14; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"quotation-estimate\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, native-intake, paid-routing, client-briefing\" data-jsi-category=\"quotation-estimate\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "08-js-how-it-works-vnext-icon-quotation-estimates-08",
        "balanced",
        "black-stroke",
        "case-intake",
        "client-briefing",
        "container-eligible",
        "cost-framing",
        "document",
        "estimate",
        "estimates",
        "excellent",
        "faq-row",
        "fee-preview",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-quotation-estimates",
        "how-it-works-quotation-estimates-08",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-quotation-estimate-document",
        "line",
        "medium",
        "money",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-medium",
        "paid-review",
        "paid-routing",
        "payment-note",
        "premium-monoline",
        "pricing",
        "primary-default",
        "product-ladder",
        "quotation",
        "quotation-estimate",
        "recommended-boxed-or-free",
        "review-intelligence",
        "suitability-check"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0129",
      "sequence": 129,
      "filename": "09-js-how-it-works-vnext-icon-scope-prepared-09.svg",
      "handle": "09-js-how-it-works-vnext-icon-scope-prepared-09",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/09-js-how-it-works-vnext-icon-scope-prepared-09.svg?v=1778971252",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-scope-preparation-ruler",
      "rotationGroup": "how-it-works-scope-prepared-09",
      "cleanLabel": "How It Works Scope Prepared",
      "primaryCategory": "scope-preparation",
      "categoryTokens": [
        "scope-preparation"
      ],
      "purposeTags": [
        "scope-prepared",
        "requirements-mapped",
        "document-preparation",
        "service-boundary",
        "project-readiness"
      ],
      "visualTags": [
        "line",
        "ruler",
        "clipboard",
        "scope-frame",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "process-step",
        "intake-confirmation",
        "service-card"
      ],
      "rawBestSectionUse": "how-it-works-step, process-step, intake-confirmation, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 14",
      "notes": "Harvested from screenshot 14; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"scope-preparation\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"scope-preparation\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "09-js-how-it-works-vnext-icon-scope-prepared-09",
        "balanced",
        "black-stroke",
        "client-briefing",
        "clipboard",
        "container-risk",
        "discretion",
        "document-preparation",
        "double-frame-risk",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-scope-prepared",
        "how-it-works-scope-prepared-09",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-scope-preparation-ruler",
        "intake-confirmation",
        "line",
        "medium",
        "morphology-rounded-square",
        "native-intake",
        "outline-medium",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-step",
        "project-readiness",
        "recommended-free-only",
        "requirements-mapped",
        "ruler",
        "scope-frame",
        "scope-preparation",
        "scope-prepared",
        "sensitive-discreet-routing",
        "service-boundary",
        "service-card",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "rounded-square",
        "intrinsicFrameEvidence": [
          "frame/square keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0130",
      "sequence": 130,
      "filename": "10-js-how-it-works-vnext-icon-mutual-confirmation-10.svg",
      "handle": "10-js-how-it-works-vnext-icon-mutual-confirmation-10",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/10-js-how-it-works-vnext-icon-mutual-confirmation-10.svg?v=1778971252",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-confirmation-alignment-handshake",
      "rotationGroup": "how-it-works-mutual-confirmation-10",
      "cleanLabel": "How It Works Mutual Confirmation",
      "primaryCategory": "confirmation-alignment",
      "categoryTokens": [
        "confirmation-alignment"
      ],
      "purposeTags": [
        "mutual-confirmation",
        "agreement",
        "engagement-terms",
        "handoff",
        "alignment"
      ],
      "visualTags": [
        "line",
        "handshake",
        "agreement",
        "confirmation",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "intake-confirmation",
        "engagement-terms",
        "process-step"
      ],
      "rawBestSectionUse": "how-it-works-step, intake-confirmation, engagement-terms, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 14",
      "notes": "Harvested from screenshot 14; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"confirmation-alignment\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing, route-intelligence, coordination, strategy\" data-jsi-category=\"confirmation-alignment\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "10-js-how-it-works-vnext-icon-mutual-confirmation-10",
        "agreement",
        "alignment",
        "balanced",
        "black-stroke",
        "client-briefing",
        "confirmation",
        "confirmation-alignment",
        "container-eligible",
        "coordination",
        "engagement-terms",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "handoff",
        "handshake",
        "how-it-works-mutual-confirmation",
        "how-it-works-mutual-confirmation-10",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-confirmation-alignment-handshake",
        "intake-confirmation",
        "line",
        "medium",
        "morphology-none",
        "mutual-confirmation",
        "native-intake",
        "native-intake-system",
        "no-double-frame-risk",
        "outline-medium",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "route-intelligence",
        "strategy"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0131",
      "sequence": 131,
      "filename": "04-js-how-it-works-vnext-icon-metacognitive-review-04.svg",
      "handle": "04-js-how-it-works-vnext-icon-metacognitive-review-04",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/04-js-how-it-works-vnext-icon-metacognitive-review-04.svg?v=1778974224",
      "assetType": "svg",
      "assetFamily": "How It Works vNext Icons",
      "familyKey": "how-it-works-vnext-icons-advisory-intelligence-brain",
      "rotationGroup": "how-it-works-metacognitive-review-04",
      "cleanLabel": "How It Works Metacognitive Review",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "metacognitive-review",
        "reflective-judgment",
        "deep-assessment",
        "intelligence-review",
        "suitability-thinking"
      ],
      "visualTags": [
        "line",
        "brain",
        "shield",
        "review",
        "black-stroke"
      ],
      "sectionFit": [
        "how-it-works-step",
        "advisory-card",
        "intelligence-block",
        "review-card"
      ],
      "rawBestSectionUse": "how-it-works-step, advisory-card, intelligence-block, review-card",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-statement",
      "visualDensity": "dense-statement",
      "lineWeight": "medium-bold",
      "intensity": "statement",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 61.0,
      "familyCategoryRank": 4,
      "categoryRank": 15,
      "designFamilyRank": 1,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 14",
      "notes": "Harvested from screenshot 14; Shopify file type SVG; full handle inferred from visible truncated Shopify filename, verify against CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"how-it-works-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_statement\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "04-js-how-it-works-vnext-icon-metacognitive-review-04",
        "advisory-card",
        "advisory-intelligence",
        "black-stroke",
        "brain",
        "container-eligible",
        "deep-assessment",
        "dense-statement",
        "discretion",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-metacognitive-review",
        "how-it-works-metacognitive-review-04",
        "how-it-works-step",
        "how-it-works-vnext-icons",
        "how-it-works-vnext-icons-advisory-intelligence-brain",
        "intelligence",
        "intelligence-block",
        "intelligence-review",
        "line",
        "medium-bold",
        "metacognitive-review",
        "morphology-none",
        "no-double-frame-risk",
        "outline-statement",
        "premium-monoline",
        "privacy-routing",
        "recommended-boxed-or-free",
        "reflective-judgment",
        "review",
        "review-card",
        "review-intelligence",
        "review-routing",
        "rotation-fallback",
        "shield",
        "statement",
        "suitability-thinking",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0132",
      "sequence": 132,
      "filename": "16c-js-icon-creatives-transparent.svg",
      "handle": "16c-js-icon-creatives-transparent",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/16c-js-icon-creatives-transparent.svg?v=1779116650",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-creative-assets-pencil",
      "rotationGroup": "creative-assets-pencil-16c",
      "cleanLabel": "Creatives Transparent Pencil",
      "primaryCategory": "creative-assets",
      "categoryTokens": [
        "creative-assets"
      ],
      "purposeTags": [
        "creative-assets",
        "writing",
        "design",
        "content",
        "transparent-variant"
      ],
      "visualTags": [
        "line",
        "pencil",
        "transparent",
        "creative",
        "black-stroke"
      ],
      "sectionFit": [
        "content-card",
        "creative-section",
        "process-step",
        "service-card"
      ],
      "rawBestSectionUse": "content-card, creative-section, process-step, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "asset-intelligence",
        "capital-review",
        "risk-screening"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 14",
      "notes": "Harvested from screenshot 14; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"creative-assets\" data-jsi-section=\"content-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"asset-intelligence, capital-review, risk-screening\" data-jsi-category=\"creative-assets\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "16c-js-icon-creatives-transparent",
        "asset-intelligence",
        "balanced",
        "black-stroke",
        "capital-review",
        "container-eligible",
        "content",
        "content-card",
        "creative",
        "creative-assets",
        "creative-assets-pencil-16c",
        "creative-section",
        "creatives-transparent-pencil",
        "design",
        "excellent",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-creative-assets-pencil",
        "outline-light",
        "pencil",
        "premium-monoline",
        "primary-default",
        "process-step",
        "quiet",
        "recommended-boxed-or-free",
        "risk-screening",
        "service-card",
        "thin-to-medium",
        "transparent",
        "transparent-variant",
        "writing"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0133",
      "sequence": 133,
      "filename": "16a-js-icon-creatives.svg",
      "handle": "16a-js-icon-creatives",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/16a-js-icon-creatives.svg?v=1779116658",
      "assetType": "svg",
      "assetFamily": "Numbered General Icon Set",
      "familyKey": "numbered-general-icon-set-creative-assets-pencil",
      "rotationGroup": "creative-assets-pencil-16a",
      "cleanLabel": "Creatives Pencil",
      "primaryCategory": "creative-assets",
      "categoryTokens": [
        "creative-assets"
      ],
      "purposeTags": [
        "creative-assets",
        "writing",
        "design",
        "content",
        "ideation"
      ],
      "visualTags": [
        "line",
        "pencil",
        "creative",
        "black-stroke"
      ],
      "sectionFit": [
        "content-card",
        "creative-section",
        "process-step",
        "service-card"
      ],
      "rawBestSectionUse": "content-card, creative-section, process-step, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "asset-intelligence",
        "capital-review",
        "risk-screening"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 14",
      "notes": "Harvested from screenshot 14; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"creative-assets\" data-jsi-section=\"content-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"asset-intelligence, capital-review, risk-screening\" data-jsi-category=\"creative-assets\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "16a-js-icon-creatives",
        "asset-intelligence",
        "balanced",
        "black-stroke",
        "capital-review",
        "container-eligible",
        "content",
        "content-card",
        "creative",
        "creative-assets",
        "creative-assets-pencil-16a",
        "creative-section",
        "creatives-pencil",
        "design",
        "excellent",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "ideation",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "numbered-general-icon-set",
        "numbered-general-icon-set-creative-assets-pencil",
        "outline-light",
        "pencil",
        "premium-monoline",
        "process-step",
        "quiet",
        "recommended-boxed-or-free",
        "risk-screening",
        "secondary-variant",
        "service-card",
        "thin-to-medium",
        "writing"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0134",
      "sequence": 134,
      "filename": "horse.svg",
      "handle": "horse",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/horse.svg?v=1779243314",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-strategy-movement-chess-knight",
      "rotationGroup": "strategy-movement-horse-01",
      "cleanLabel": "Horse Knight",
      "primaryCategory": "strategy-movement",
      "categoryTokens": [
        "strategy-movement"
      ],
      "purposeTags": [
        "strategy",
        "tactical-movement",
        "high-judgment",
        "positioning",
        "acquisition-route"
      ],
      "visualTags": [
        "line",
        "chess-knight",
        "circular-frame",
        "black-stroke"
      ],
      "sectionFit": [
        "strategy-card",
        "process-step",
        "advisory-card",
        "premium-tier"
      ],
      "rawBestSectionUse": "strategy-card, process-step, advisory-card, premium-tier",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "sourcing-procurement-export"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"strategy-movement\" data-jsi-section=\"strategy-card\" data-jsi-page-wing=\"sourcing-procurement-export\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, intelligence, review-routing, due-diligence\" data-jsi-category=\"strategy-movement\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "acquisition-route",
        "advisory-card",
        "balanced",
        "black-stroke",
        "cargo-execution",
        "chess-knight",
        "circular-frame",
        "container-risk",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-strategy-movement-chess-knight",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "high-judgment",
        "horse",
        "horse-knight",
        "intelligence",
        "line",
        "local-representation",
        "medium",
        "morphology-circle",
        "outline-medium",
        "positioning",
        "premium-monoline",
        "premium-tier",
        "primary-default",
        "process-step",
        "recommended-free-only",
        "review-routing",
        "sequence-badge",
        "sourcing-procurement-export",
        "strategy",
        "strategy-card",
        "strategy-movement",
        "strategy-movement-horse-01",
        "tactical-movement"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0135",
      "sequence": 135,
      "filename": "handshake.svg",
      "handle": "handshake",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/handshake.svg?v=1779243314",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-confirmation-alignment-handshake",
      "rotationGroup": "confirmation-handshake-01",
      "cleanLabel": "Handshake Agreement",
      "primaryCategory": "confirmation-alignment",
      "categoryTokens": [
        "confirmation-alignment"
      ],
      "purposeTags": [
        "agreement",
        "mutual-confirmation",
        "partnership",
        "handoff",
        "engagement-terms"
      ],
      "visualTags": [
        "line",
        "handshake",
        "compact",
        "black-stroke"
      ],
      "sectionFit": [
        "intake-confirmation",
        "engagement-terms",
        "process-step",
        "trust-card"
      ],
      "rawBestSectionUse": "intake-confirmation, engagement-terms, process-step, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "minimal",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 61.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"confirmation-alignment\" data-jsi-section=\"intake-confirmation\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing, route-intelligence, coordination, strategy\" data-jsi-category=\"confirmation-alignment\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "agreement",
        "black-stroke",
        "client-briefing",
        "compact",
        "confirmation-alignment",
        "confirmation-handshake-01",
        "container-eligible",
        "coordination",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-confirmation-alignment-handshake",
        "engagement-terms",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "handoff",
        "handshake",
        "handshake-agreement",
        "intake-confirmation",
        "line",
        "medium",
        "minimal",
        "morphology-none",
        "mutual-confirmation",
        "native-intake",
        "native-intake-system",
        "no-double-frame-risk",
        "outline-medium",
        "paid-routing",
        "partnership",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "route-intelligence",
        "strategy",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0136",
      "sequence": 136,
      "filename": "cross-hair.svg",
      "handle": "cross-hair",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/cross-hair.svg?v=1779243315",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-target-precision-crosshair",
      "rotationGroup": "target-precision-crosshair-01",
      "cleanLabel": "Cross Hair Target",
      "primaryCategory": "target-precision",
      "categoryTokens": [
        "target-precision"
      ],
      "purposeTags": [
        "targeting",
        "precision",
        "scope-focus",
        "execution-aim",
        "route-lock"
      ],
      "visualTags": [
        "line",
        "crosshair",
        "target",
        "black-stroke"
      ],
      "sectionFit": [
        "process-step",
        "strategy-card",
        "intelligence-block",
        "service-card"
      ],
      "rawBestSectionUse": "process-step, strategy-card, intelligence-block, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"target-precision\" data-jsi-section=\"process-step\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"target-precision\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "balanced",
        "black-stroke",
        "container-risk",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-target-precision-crosshair",
        "cross-hair",
        "cross-hair-target",
        "crosshair",
        "discretion",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "execution-aim",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "line",
        "medium",
        "morphology-circle-risk",
        "outline-medium",
        "precision",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-step",
        "recommended-free-only",
        "review-intelligence",
        "review-routing",
        "route-lock",
        "scope-focus",
        "service-card",
        "strategy-card",
        "target",
        "target-precision",
        "target-precision-crosshair-01",
        "targeting",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0137",
      "sequence": 137,
      "filename": "airplane-jet-01.svg",
      "handle": "airplane-jet-01",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/airplane-jet-01.svg?v=1779243314",
      "assetType": "svg",
      "assetFamily": "Travel / Access Icons",
      "familyKey": "travel-access-icons-travel-movement-airplane",
      "rotationGroup": "travel-airplane-jet-01",
      "cleanLabel": "Airplane Jet 01",
      "primaryCategory": "travel-movement",
      "categoryTokens": [
        "travel-movement"
      ],
      "purposeTags": [
        "travel",
        "flight",
        "arrival",
        "itinerary-movement",
        "overseas-client"
      ],
      "visualTags": [
        "line",
        "airplane",
        "circular-frame",
        "diagonal-movement",
        "black-stroke"
      ],
      "sectionFit": [
        "travel-card",
        "route-note",
        "logistics-card",
        "related-card"
      ],
      "rawBestSectionUse": "travel-card, route-note, logistics-card, related-card",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"travel-movement\" data-jsi-section=\"travel-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"travel-movement\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "airplane",
        "airplane-jet-01",
        "arrival",
        "balanced",
        "black-stroke",
        "cargo-execution",
        "circular-frame",
        "concierge-presence",
        "container-risk",
        "cultural-navigation",
        "diagonal-movement",
        "double-frame-risk",
        "excellent",
        "flight",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "itinerary-movement",
        "line",
        "local-representation",
        "logistics-card",
        "logistics-local-representation",
        "medium",
        "morphology-circle",
        "outline-medium",
        "overseas-client",
        "premium-monoline",
        "primary-default",
        "recommended-free-only",
        "related-card",
        "route-note",
        "sequence-badge",
        "travel",
        "travel-access-icons",
        "travel-access-icons-travel-movement-airplane",
        "travel-airplane-jet-01",
        "travel-card",
        "travel-movement"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0138",
      "sequence": 138,
      "filename": "airplane-jet-08.svg",
      "handle": "airplane-jet-08",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/airplane-jet-08.svg?v=1779243314",
      "assetType": "svg",
      "assetFamily": "Travel / Access Icons",
      "familyKey": "travel-access-icons-travel-movement-airplane",
      "rotationGroup": "travel-airplane-jet-08",
      "cleanLabel": "Airplane Jet 08",
      "primaryCategory": "travel-movement",
      "categoryTokens": [
        "travel-movement"
      ],
      "purposeTags": [
        "travel",
        "flight-route",
        "logistics-movement",
        "international-access",
        "itinerary"
      ],
      "visualTags": [
        "line",
        "airplane",
        "small-jet",
        "movement-trail",
        "black-stroke"
      ],
      "sectionFit": [
        "travel-card",
        "process-step",
        "logistics-card",
        "route-note"
      ],
      "rawBestSectionUse": "travel-card, process-step, logistics-card, route-note",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 4,
      "categoryRank": 4,
      "designFamilyRank": 3,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"travel-movement\" data-jsi-section=\"travel-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"travel-movement\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "airplane",
        "airplane-jet-08",
        "balanced",
        "black-stroke",
        "cargo-execution",
        "concierge-presence",
        "container-eligible",
        "cultural-navigation",
        "excellent",
        "flight-route",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "international-access",
        "itinerary",
        "line",
        "local-representation",
        "logistics-card",
        "logistics-local-representation",
        "logistics-movement",
        "morphology-none",
        "movement-trail",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "process-step",
        "quiet",
        "recommended-boxed-or-free",
        "rotation-fallback",
        "route-note",
        "small-jet",
        "thin-to-medium",
        "travel",
        "travel-access-icons",
        "travel-access-icons-travel-movement-airplane",
        "travel-airplane-jet-08",
        "travel-card",
        "travel-movement"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0139",
      "sequence": 139,
      "filename": "airplane-jet-07.svg",
      "handle": "airplane-jet-07",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/airplane-jet-07.svg?v=1779243314",
      "assetType": "svg",
      "assetFamily": "Travel / Access Icons",
      "familyKey": "travel-access-icons-travel-movement-top-down-airplane",
      "rotationGroup": "travel-airplane-jet-07",
      "cleanLabel": "Airplane Jet 07",
      "primaryCategory": "travel-movement",
      "categoryTokens": [
        "travel-movement"
      ],
      "purposeTags": [
        "travel",
        "flight",
        "direct-route",
        "arrival-planning",
        "international-movement"
      ],
      "visualTags": [
        "line",
        "top-down-airplane",
        "vertical-route",
        "black-stroke"
      ],
      "sectionFit": [
        "travel-card",
        "route-note",
        "itinerary-section",
        "related-card"
      ],
      "rawBestSectionUse": "travel-card, route-note, itinerary-section, related-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"travel-movement\" data-jsi-section=\"travel-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"travel-movement\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "airplane-jet-07",
        "arrival-planning",
        "balanced",
        "black-stroke",
        "cargo-execution",
        "concierge-presence",
        "container-eligible",
        "cultural-navigation",
        "direct-route",
        "excellent",
        "flight",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "international-movement",
        "itinerary-section",
        "line",
        "local-representation",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "recommended-boxed-or-free",
        "related-card",
        "route-note",
        "secondary-variant",
        "top-down-airplane",
        "travel",
        "travel-access-icons",
        "travel-access-icons-travel-movement-top-down-airplane",
        "travel-airplane-jet-07",
        "travel-card",
        "travel-cultural-access",
        "travel-movement",
        "vertical-route"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0140",
      "sequence": 140,
      "filename": "sakura.svg",
      "handle": "sakura",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/sakura.svg?v=1779243315",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-japan-cultural-access-sakura",
      "rotationGroup": "japan-cultural-sakura-01",
      "cleanLabel": "Sakura Flower",
      "primaryCategory": "japan-cultural-access",
      "categoryTokens": [
        "japan-cultural-access"
      ],
      "purposeTags": [
        "japan-culture",
        "seasonal-access",
        "soft-hospitality",
        "cultural-experience",
        "spring"
      ],
      "visualTags": [
        "line",
        "sakura",
        "floral",
        "heritage",
        "black-stroke"
      ],
      "sectionFit": [
        "cultural-card",
        "seasonal-section",
        "related-card",
        "trust-card"
      ],
      "rawBestSectionUse": "cultural-card, seasonal-section, related-card, trust-card",
      "styleFamily": [
        "premium-monoline",
        "japan-cultural-symbol"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"japan-cultural-access\" data-jsi-section=\"cultural-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"japan-cultural-access\" data-jsi-style=\"premium-monoline, japan-cultural-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "balanced",
        "black-stroke",
        "concierge-presence",
        "container-eligible",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-japan-cultural-access-sakura",
        "cultural-card",
        "cultural-experience",
        "cultural-navigation",
        "excellent",
        "floral",
        "good-with-ivory-plate-or-css-filter",
        "heritage",
        "japan-cultural-access",
        "japan-cultural-sakura-01",
        "japan-cultural-symbol",
        "japan-culture",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "quiet",
        "recommended-boxed-or-free",
        "related-card",
        "sakura",
        "sakura-flower",
        "seasonal-access",
        "seasonal-section",
        "soft-hospitality",
        "spring",
        "thin-to-medium",
        "travel-cultural-access",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0141",
      "sequence": 141,
      "filename": "magnifying_glass.svg",
      "handle": "magnifying-glass",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/magnifying_glass.svg?v=1779243315",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-advisory-intelligence-magnifier",
      "rotationGroup": "advisory-magnifying-glass-01",
      "cleanLabel": "Magnifying Glass",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "search",
        "review",
        "analysis",
        "due-diligence",
        "investigation"
      ],
      "visualTags": [
        "line",
        "magnifier",
        "simple",
        "black-stroke"
      ],
      "sectionFit": [
        "review-card",
        "intelligence-block",
        "process-step",
        "faq-row"
      ],
      "rawBestSectionUse": "review-card, intelligence-block, process-step, FAQ-row",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 13,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"review-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "advisory-intelligence",
        "advisory-magnifying-glass-01",
        "analysis",
        "balanced",
        "black-stroke",
        "container-eligible",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-advisory-intelligence-magnifier",
        "discretion",
        "due-diligence",
        "excellent",
        "faq-row",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-block",
        "investigation",
        "line",
        "magnifier",
        "magnifying-glass",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "privacy-routing",
        "process-step",
        "quiet",
        "recommended-boxed-or-free",
        "review",
        "review-card",
        "review-intelligence",
        "review-routing",
        "search",
        "secondary-variant",
        "simple",
        "thin-to-medium",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0142",
      "sequence": 142,
      "filename": "analysis.svg",
      "handle": "analysis",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/analysis.svg?v=1779243315",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-analysis-strategy-chart",
      "rotationGroup": "analysis-growth-chart-01",
      "cleanLabel": "Analysis Growth Chart",
      "primaryCategory": "analysis-strategy",
      "categoryTokens": [
        "analysis-strategy"
      ],
      "purposeTags": [
        "analysis",
        "growth",
        "planning",
        "performance",
        "market-signal",
        "advisory"
      ],
      "visualTags": [
        "line",
        "chart",
        "upward-arrow",
        "business",
        "black-stroke"
      ],
      "sectionFit": [
        "business-section",
        "intelligence-block",
        "process-step",
        "service-card"
      ],
      "rawBestSectionUse": "business-section, intelligence-block, process-step, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"analysis-strategy\" data-jsi-section=\"business-section\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"analysis-strategy\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "advisory",
        "analysis",
        "analysis-growth-chart",
        "analysis-growth-chart-01",
        "analysis-strategy",
        "balanced",
        "black-stroke",
        "business",
        "business-section",
        "chart",
        "container-eligible",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-analysis-strategy-chart",
        "discretion",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "growth",
        "intelligence",
        "intelligence-block",
        "line",
        "market-signal",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "performance",
        "planning",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-step",
        "recommended-boxed-or-free",
        "review-intelligence",
        "review-routing",
        "service-card",
        "trust-protection",
        "upward-arrow"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0143",
      "sequence": 143,
      "filename": "headphone.svg",
      "handle": "headphone",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/headphone.svg?v=1779243315",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-client-support-headset",
      "rotationGroup": "client-support-headphone-01",
      "cleanLabel": "Headphone Support",
      "primaryCategory": "client-support",
      "categoryTokens": [
        "client-support"
      ],
      "purposeTags": [
        "support",
        "client-communication",
        "listening",
        "concierge-desk",
        "help"
      ],
      "visualTags": [
        "line",
        "headset",
        "person",
        "support",
        "black-stroke"
      ],
      "sectionFit": [
        "support-card",
        "intake-help",
        "cta-support",
        "contact-section"
      ],
      "rawBestSectionUse": "support-card, intake-help, CTA-support, contact-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"client-support\" data-jsi-section=\"support-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, native-intake, paid-routing, client-briefing\" data-jsi-category=\"client-support\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "balanced",
        "black-stroke",
        "client-briefing",
        "client-communication",
        "client-support",
        "client-support-headphone-01",
        "concierge-desk",
        "concierge-presence",
        "contact-section",
        "container-eligible",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-client-support-headset",
        "cta-support",
        "cultural-navigation",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "headphone",
        "headphone-support",
        "headset",
        "help",
        "intake-help",
        "line",
        "listening",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-light",
        "paid-routing",
        "person",
        "premium-monoline",
        "primary-default",
        "quiet",
        "recommended-boxed-or-free",
        "support",
        "support-card",
        "thin-to-medium",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0145",
      "sequence": 145,
      "filename": "airplane-jet-03.svg",
      "handle": "airplane-jet-03",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/airplane-jet-03.svg?v=1779243315",
      "assetType": "svg",
      "assetFamily": "Travel / Access Icons",
      "familyKey": "travel-access-icons-travel-movement-airplane",
      "rotationGroup": "travel-airplane-jet-03",
      "cleanLabel": "Airplane Jet 03",
      "primaryCategory": "travel-movement",
      "categoryTokens": [
        "travel-movement"
      ],
      "purposeTags": [
        "travel",
        "flight",
        "international-access",
        "trip-planning",
        "route"
      ],
      "visualTags": [
        "line",
        "airplane",
        "circular-frame",
        "black-stroke"
      ],
      "sectionFit": [
        "travel-card",
        "process-step",
        "related-card",
        "route-note"
      ],
      "rawBestSectionUse": "travel-card, process-step, related-card, route-note",
      "styleFamily": [
        "premium-monoline",
        "sequence-badge"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 3,
      "categoryRank": 3,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"travel-movement\" data-jsi-section=\"travel-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"travel-movement\" data-jsi-style=\"premium-monoline, sequence-badge\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "airplane",
        "airplane-jet-03",
        "balanced",
        "black-stroke",
        "cargo-execution",
        "circular-frame",
        "concierge-presence",
        "container-risk",
        "cultural-navigation",
        "double-frame-risk",
        "excellent",
        "flight",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "international-access",
        "line",
        "local-representation",
        "medium",
        "morphology-circle",
        "outline-medium",
        "premium-monoline",
        "process-step",
        "recommended-free-only",
        "related-card",
        "route",
        "route-note",
        "secondary-variant",
        "sequence-badge",
        "travel",
        "travel-access-icons",
        "travel-access-icons-travel-movement-airplane",
        "travel-airplane-jet-03",
        "travel-card",
        "travel-cultural-access",
        "travel-movement",
        "trip-planning"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0146",
      "sequence": 146,
      "filename": "sensu.svg",
      "handle": "sensu",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/sensu.svg?v=1779243315",
      "assetType": "svg",
      "assetFamily": "Core JapanSolved Service Icons",
      "familyKey": "core-japansolved-service-icons-japan-cultural-access-folding-fan",
      "rotationGroup": "japan-cultural-sensu-01",
      "cleanLabel": "Sensu Fan",
      "primaryCategory": "japan-cultural-access",
      "categoryTokens": [
        "japan-cultural-access"
      ],
      "purposeTags": [
        "japan-culture",
        "heritage",
        "hospitality",
        "elegance",
        "cultural-access"
      ],
      "visualTags": [
        "line",
        "folding-fan",
        "radiating-ribs",
        "heritage",
        "black-stroke"
      ],
      "sectionFit": [
        "cultural-card",
        "hospitality-section",
        "related-card",
        "trust-card"
      ],
      "rawBestSectionUse": "cultural-card, hospitality-section, related-card, trust-card",
      "styleFamily": [
        "premium-monoline",
        "japan-cultural-symbol"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 15",
      "notes": "Harvested from screenshot 15; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"japan-cultural-access\" data-jsi-section=\"cultural-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"japan-cultural-access\" data-jsi-style=\"premium-monoline, japan-cultural-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "access-coordination",
        "balanced",
        "black-stroke",
        "concierge-presence",
        "container-eligible",
        "core-japansolved-service-icons",
        "core-japansolved-service-icons-japan-cultural-access-folding-fan",
        "cultural-access",
        "cultural-card",
        "cultural-navigation",
        "elegance",
        "excellent",
        "folding-fan",
        "good-with-ivory-plate-or-css-filter",
        "heritage",
        "hospitality",
        "hospitality-section",
        "japan-cultural-access",
        "japan-cultural-sensu-01",
        "japan-cultural-symbol",
        "japan-culture",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "quiet",
        "radiating-ribs",
        "recommended-boxed-or-free",
        "related-card",
        "secondary-variant",
        "sensu",
        "sensu-fan",
        "thin-to-medium",
        "travel-cultural-access",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0147",
      "sequence": 147,
      "filename": "12-js-case-library-vnext-icon-starting-in-japan-12.svg",
      "handle": "12-js-case-library-vnext-icon-starting-in-japan-12",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/12-js-case-library-vnext-icon-starting-in-japan-12.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-japan-entry-setup-flag",
      "rotationGroup": "case-library-starting-japan-12",
      "cleanLabel": "Starting in Japan Flag",
      "primaryCategory": "japan-entry-setup",
      "categoryTokens": [
        "japan-entry-setup"
      ],
      "purposeTags": [
        "starting-in-japan",
        "first-steps",
        "entry-route",
        "relocation-setup",
        "orientation"
      ],
      "visualTags": [
        "line",
        "flag",
        "waypoint",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "route-note",
        "process-step",
        "relocation-section"
      ],
      "rawBestSectionUse": "case-library-card, route-note, process-step, relocation-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "relocation-support",
        "local-setup",
        "property-routing"
      ],
      "pageWingFit": [
        "property-relocation"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"japan-entry-setup\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"property-relocation\" data-jsi-pillars=\"relocation-support, local-setup, property-routing\" data-jsi-category=\"japan-entry-setup\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "12-js-case-library-vnext-icon-starting-in-japan-12",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-starting-japan-12",
        "case-library-vnext-icons",
        "case-library-vnext-icons-japan-entry-setup-flag",
        "container-eligible",
        "entry-route",
        "excellent",
        "first-steps",
        "flag",
        "good-with-ivory-plate-or-css-filter",
        "japan-entry-setup",
        "line",
        "local-setup",
        "morphology-none",
        "no-double-frame-risk",
        "orientation",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "process-step",
        "property-relocation",
        "property-routing",
        "quiet",
        "recommended-boxed-or-free",
        "relocation-section",
        "relocation-setup",
        "relocation-support",
        "route-note",
        "starting-in-japan",
        "starting-in-japan-flag",
        "thin-to-medium",
        "waypoint"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0148",
      "sequence": 148,
      "filename": "15-js-case-library-vnext-icon-moving-settling-15.svg",
      "handle": "15-js-case-library-vnext-icon-moving-settling-15",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/15-js-case-library-vnext-icon-moving-settling-15.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-relocation-settlement-house",
      "rotationGroup": "case-library-moving-settling-15",
      "cleanLabel": "Moving Settling House",
      "primaryCategory": "relocation-settlement",
      "categoryTokens": [
        "relocation-settlement"
      ],
      "purposeTags": [
        "moving",
        "settling",
        "housing",
        "relocation",
        "local-setup"
      ],
      "visualTags": [
        "line",
        "house",
        "residential",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "relocation-section",
        "process-step",
        "service-card"
      ],
      "rawBestSectionUse": "case-library-card, relocation-section, process-step, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "relocation-support",
        "local-setup",
        "property-routing"
      ],
      "pageWingFit": [
        "property-relocation"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"relocation-settlement\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"property-relocation\" data-jsi-pillars=\"relocation-support, local-setup, property-routing\" data-jsi-category=\"relocation-settlement\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "15-js-case-library-vnext-icon-moving-settling-15",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-moving-settling-15",
        "case-library-vnext-icons",
        "case-library-vnext-icons-relocation-settlement-house",
        "container-eligible",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "house",
        "housing",
        "line",
        "local-setup",
        "morphology-none",
        "moving",
        "moving-settling-house",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "process-step",
        "property-relocation",
        "property-routing",
        "quiet",
        "recommended-boxed-or-free",
        "relocation",
        "relocation-section",
        "relocation-settlement",
        "relocation-support",
        "residential",
        "service-card",
        "settling",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0149",
      "sequence": 149,
      "filename": "13-js-case-library-vnext-icon-managing-from-overseas-13.svg",
      "handle": "13-js-case-library-vnext-icon-managing-from-overseas-13",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/13-js-case-library-vnext-icon-managing-from-overseas-13.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-overseas-management-globe",
      "rotationGroup": "case-library-managing-overseas-13",
      "cleanLabel": "Managing from Overseas Globe",
      "primaryCategory": "overseas-management",
      "categoryTokens": [
        "overseas-management"
      ],
      "purposeTags": [
        "overseas-management",
        "remote-coordination",
        "japan-side-representation",
        "international-client"
      ],
      "visualTags": [
        "line",
        "globe",
        "map-pin",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "representation-section",
        "trust-card",
        "process-step"
      ],
      "rawBestSectionUse": "case-library-card, representation-section, trust-card, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"overseas-management\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"route-intelligence, coordination, strategy\" data-jsi-category=\"overseas-management\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "13-js-case-library-vnext-icon-managing-from-overseas-13",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-managing-overseas-13",
        "case-library-vnext-icons",
        "case-library-vnext-icons-overseas-management-globe",
        "container-eligible",
        "coordination",
        "excellent",
        "globe",
        "good-with-ivory-plate-or-css-filter",
        "international-client",
        "japan-side-representation",
        "line",
        "logistics-local-representation",
        "managing-from-overseas-globe",
        "map-pin",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "overseas-management",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "remote-coordination",
        "representation-section",
        "route-intelligence",
        "strategy",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0150",
      "sequence": 150,
      "filename": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22.svg",
      "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/22-js-case-library-vnext-icon-sourcing-acquisition-cases-22.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-acquisition-cases-box",
      "rotationGroup": "case-library-acquisition-cases-22",
      "cleanLabel": "Acquisition Cases Box",
      "primaryCategory": "acquisition-cases",
      "categoryTokens": [
        "acquisition-cases"
      ],
      "purposeTags": [
        "acquisition",
        "sourcing-cases",
        "object-intake",
        "procurement",
        "asset-retrieval"
      ],
      "visualTags": [
        "line",
        "box",
        "acquisition",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "sourcing-section",
        "related-card",
        "process-step"
      ],
      "rawBestSectionUse": "case-library-card, sourcing-section, related-card, process-step",
      "styleFamily": [
        "premium-monoline",
        "operations-symbol"
      ],
      "solutionPillars": [
        "asset-intelligence",
        "capital-review",
        "risk-screening",
        "sourcing",
        "private-buyer",
        "procurement-routing"
      ],
      "pageWingFit": [
        "sourcing-procurement-export"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL. | Original C handle did not match URL filename; polished handle uses URL as source of truth.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"acquisition-cases\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"sourcing-procurement-export\" data-jsi-pillars=\"asset-intelligence, capital-review, risk-screening, sourcing, private-buyer, procurement-routing\" data-jsi-category=\"acquisition-cases\" data-jsi-style=\"premium-monoline, operations-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
        "acquisition",
        "acquisition-cases",
        "acquisition-cases-box",
        "asset-intelligence",
        "asset-retrieval",
        "balanced",
        "black-stroke",
        "box",
        "capital-review",
        "case-library-acquisition-cases-22",
        "case-library-card",
        "case-library-vnext-icons",
        "case-library-vnext-icons-acquisition-cases-box",
        "container-eligible",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "object-cube-package",
        "object-intake",
        "operations-symbol",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "private-buyer",
        "process-step",
        "procurement",
        "procurement-routing",
        "recommended-boxed-or-free",
        "related-card",
        "risk-screening",
        "sourcing",
        "sourcing-cases",
        "sourcing-procurement-export",
        "sourcing-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [
          "cube/package object; not a frame, but low-fit in premium boxed UI unless exact"
        ],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "cube/package",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0151",
      "sequence": 151,
      "filename": "21-js-case-library-vnext-icon-property-relocation-cases-21.svg",
      "handle": "21-js-case-library-vnext-icon-property-relocation-cases-21",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/21-js-case-library-vnext-icon-property-relocation-cases-21.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-property-relocation-building",
      "rotationGroup": "case-library-property-relocation-21",
      "cleanLabel": "Property Relocation Cases",
      "primaryCategory": "property-relocation",
      "categoryTokens": [
        "property-relocation"
      ],
      "purposeTags": [
        "property",
        "relocation-cases",
        "housing",
        "settlement",
        "local-coordination"
      ],
      "visualTags": [
        "line",
        "building",
        "house",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "property-section",
        "relocation-section",
        "service-card"
      ],
      "rawBestSectionUse": "case-library-card, property-section, relocation-section, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "relocation-support",
        "local-setup",
        "property-routing",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "property-relocation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"property-relocation\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"property-relocation\" data-jsi-pillars=\"relocation-support, local-setup, property-routing, route-intelligence, coordination, strategy\" data-jsi-category=\"property-relocation\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "21-js-case-library-vnext-icon-property-relocation-cases-21",
        "balanced",
        "black-stroke",
        "building",
        "case-library-card",
        "case-library-property-relocation-21",
        "case-library-vnext-icons",
        "case-library-vnext-icons-property-relocation-building",
        "container-eligible",
        "coordination",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "house",
        "housing",
        "line",
        "local-coordination",
        "local-setup",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "property",
        "property-relocation",
        "property-relocation-cases",
        "property-routing",
        "property-section",
        "recommended-boxed-or-free",
        "relocation-cases",
        "relocation-section",
        "relocation-support",
        "route-intelligence",
        "service-card",
        "settlement",
        "strategy"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0152",
      "sequence": 152,
      "filename": "23-js-case-library-vnext-icon-local-execution-cases-23.svg",
      "handle": "23-js-case-library-vnext-icon-local-execution-cases-23",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/23-js-case-library-vnext-icon-local-execution-cases-23.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-local-execution-compass",
      "rotationGroup": "case-library-local-execution-23",
      "cleanLabel": "Local Execution Cases Compass",
      "primaryCategory": "local-execution",
      "categoryTokens": [
        "local-execution"
      ],
      "purposeTags": [
        "local-execution",
        "japan-side-coordination",
        "fieldwork",
        "execution-route"
      ],
      "visualTags": [
        "line",
        "compass",
        "directional",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "execution-section",
        "process-step",
        "trust-card"
      ],
      "rawBestSectionUse": "case-library-card, execution-section, process-step, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"local-execution\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion, route-intelligence, coordination, strategy\" data-jsi-category=\"local-execution\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "23-js-case-library-vnext-icon-local-execution-cases-23",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-local-execution-23",
        "case-library-vnext-icons",
        "case-library-vnext-icons-local-execution-compass",
        "compass",
        "completion",
        "container-risk",
        "coordination",
        "directional",
        "double-frame-risk",
        "excellent",
        "execution-route",
        "execution-section",
        "execution-support",
        "fieldwork",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "japan-side-coordination",
        "line",
        "local-execution",
        "local-execution-cases-compass",
        "medium",
        "morphology-circle-risk",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-free-only",
        "route-intelligence",
        "strategy",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0153",
      "sequence": 153,
      "filename": "16-js-case-library-vnext-icon-accessing-japan-privately-16.svg",
      "handle": "16-js-case-library-vnext-icon-accessing-japan-privately-16",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/16-js-case-library-vnext-icon-accessing-japan-privately-16.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-private-japan-access-keyhole",
      "rotationGroup": "case-library-private-japan-16",
      "cleanLabel": "Visiting Japan Privately Keyhole",
      "primaryCategory": "private-japan-access",
      "categoryTokens": [
        "private-japan-access"
      ],
      "purposeTags": [
        "private-visit",
        "discretion",
        "sensitive-travel",
        "confidential-access",
        "privacy"
      ],
      "visualTags": [
        "line",
        "keyhole",
        "privacy",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "privacy-section",
        "trust-card",
        "sensitive-route-note"
      ],
      "rawBestSectionUse": "case-library-card, privacy-section, trust-card, sensitive-route-note",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL. | Original C handle did not match URL filename; polished handle uses URL as source of truth.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"private-japan-access\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"private-japan-access\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "16-js-case-library-vnext-icon-accessing-japan-privately-16",
        "access-coordination",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-private-japan-16",
        "case-library-vnext-icons",
        "case-library-vnext-icons-private-japan-access-keyhole",
        "concierge-presence",
        "confidential-access",
        "container-eligible",
        "cultural-navigation",
        "discretion",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "keyhole",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "privacy",
        "privacy-routing",
        "privacy-section",
        "private-japan-access",
        "private-visit",
        "quiet",
        "recommended-boxed-or-free",
        "sensitive-route-note",
        "sensitive-travel",
        "thin-to-medium",
        "travel-cultural-access",
        "trust-card",
        "trust-protection",
        "trust-symbol",
        "visiting-japan-privately-keyhole"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0154",
      "sequence": 154,
      "filename": "14-js-case-library-vnext-icon-sourcing-rare-assets-14.svg",
      "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/14-js-case-library-vnext-icon-sourcing-rare-assets-14.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-rare-asset-sourcing-gem",
      "rotationGroup": "case-library-sourcing-rare-assets-14",
      "cleanLabel": "Sourcing Rare Assets Gem Box",
      "primaryCategory": "rare-asset-sourcing",
      "categoryTokens": [
        "rare-asset-sourcing"
      ],
      "purposeTags": [
        "rare-assets",
        "collectors",
        "sourcing",
        "luxury-objects",
        "acquisition"
      ],
      "visualTags": [
        "line",
        "gem",
        "box",
        "collectible",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "collector-section",
        "sourcing-section",
        "product-ladder"
      ],
      "rawBestSectionUse": "case-library-card, collector-section, sourcing-section, product-ladder",
      "styleFamily": [
        "premium-monoline",
        "operations-symbol"
      ],
      "solutionPillars": [
        "asset-intelligence",
        "capital-review",
        "risk-screening",
        "sourcing",
        "private-buyer",
        "procurement-routing"
      ],
      "pageWingFit": [
        "sourcing-procurement-export"
      ],
      "fillLevel": "outline-statement",
      "visualDensity": "dense-statement",
      "lineWeight": "medium-bold",
      "intensity": "statement",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 61.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"rare-asset-sourcing\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"sourcing-procurement-export\" data-jsi-pillars=\"asset-intelligence, capital-review, risk-screening, sourcing, private-buyer, procurement-routing\" data-jsi-category=\"rare-asset-sourcing\" data-jsi-style=\"premium-monoline, operations-symbol\" data-jsi-fill=\"outline_statement\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
        "acquisition",
        "asset-intelligence",
        "black-stroke",
        "box",
        "capital-review",
        "case-library-card",
        "case-library-sourcing-rare-assets-14",
        "case-library-vnext-icons",
        "case-library-vnext-icons-rare-asset-sourcing-gem",
        "collectible",
        "collector-section",
        "collectors",
        "container-eligible",
        "dense-statement",
        "excellent",
        "gem",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "luxury-objects",
        "medium-bold",
        "morphology-none",
        "no-double-frame-risk",
        "object-cube-package",
        "operations-symbol",
        "outline-statement",
        "premium-monoline",
        "primary-default",
        "private-buyer",
        "procurement-routing",
        "product-ladder",
        "rare-asset-sourcing",
        "rare-assets",
        "recommended-boxed-or-free",
        "risk-screening",
        "sourcing",
        "sourcing-procurement-export",
        "sourcing-rare-assets-gem-box",
        "sourcing-section",
        "statement"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [
          "cube/package object; not a frame, but low-fit in premium boxed UI unless exact"
        ],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "cube/package",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0155",
      "sequence": 155,
      "filename": "29b-js-case-library-vnext-icon-execution-gap-29b.svg",
      "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/29b-js-case-library-vnext-icon-execution-gap-29b.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-execution-gap-compass",
      "rotationGroup": "case-library-execution-gap-29b",
      "cleanLabel": "Execution Gap Compass",
      "primaryCategory": "execution-gap",
      "categoryTokens": [
        "execution-gap"
      ],
      "purposeTags": [
        "execution-gap",
        "missing-japan-side-action",
        "route-failure",
        "coordination-gap"
      ],
      "visualTags": [
        "line",
        "compass",
        "gap-marker",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "pain-point-section",
        "process-step",
        "advisory-card"
      ],
      "rawBestSectionUse": "case-library-card, pain-point-section, process-step, advisory-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"execution-gap\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, execution-support, outcome-control, completion\" data-jsi-category=\"execution-gap\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "29b-js-case-library-vnext-icon-execution-gap-29b",
        "advisory-card",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-execution-gap-29b",
        "case-library-vnext-icons",
        "case-library-vnext-icons-execution-gap-compass",
        "compass",
        "completion",
        "container-risk",
        "coordination-gap",
        "double-frame-risk",
        "due-diligence",
        "excellent",
        "execution-gap",
        "execution-gap-compass",
        "execution-support",
        "gap-marker",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "line",
        "medium",
        "missing-japan-side-action",
        "morphology-circle-risk",
        "outcome-control",
        "outline-medium",
        "pain-point-section",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-free-only",
        "review-intelligence",
        "review-routing",
        "route-failure"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0156",
      "sequence": 156,
      "filename": "17-js-case-library-vnext-icon-clarifying-risk-17.svg",
      "handle": "17-js-case-library-vnext-icon-clarifying-risk-17",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/17-js-case-library-vnext-icon-clarifying-risk-17.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-risk-clarification-magnifier",
      "rotationGroup": "case-library-clarifying-risk-17",
      "cleanLabel": "Clarifying Risk Magnifier",
      "primaryCategory": "risk-clarification",
      "categoryTokens": [
        "risk-clarification"
      ],
      "purposeTags": [
        "risk-clarification",
        "due-diligence",
        "review",
        "uncertainty",
        "suitability"
      ],
      "visualTags": [
        "line",
        "magnifier",
        "check",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "risk-section",
        "trust-card",
        "faq-row"
      ],
      "rawBestSectionUse": "case-library-card, risk-section, trust-card, FAQ-row",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"risk-clarification\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, paid-review, case-intake, suitability-check\" data-jsi-category=\"risk-clarification\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "17-js-case-library-vnext-icon-clarifying-risk-17",
        "balanced",
        "black-stroke",
        "case-intake",
        "case-library-card",
        "case-library-clarifying-risk-17",
        "case-library-vnext-icons",
        "case-library-vnext-icons-risk-clarification-magnifier",
        "check",
        "clarifying-risk-magnifier",
        "container-eligible",
        "due-diligence",
        "excellent",
        "faq-row",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "line",
        "magnifier",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "paid-review",
        "premium-monoline",
        "primary-default",
        "recommended-boxed-or-free",
        "review",
        "review-intelligence",
        "review-routing",
        "risk-clarification",
        "risk-section",
        "suitability",
        "suitability-check",
        "trust-card",
        "uncertainty"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0157",
      "sequence": 157,
      "filename": "30a-js-case-library-vnext-icon-verification-gap-30a.svg",
      "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/30a-js-case-library-vnext-icon-verification-gap-30a.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-verification-gap-document",
      "rotationGroup": "case-library-verification-gap-30a",
      "cleanLabel": "Verification Gap Document",
      "primaryCategory": "verification-gap",
      "categoryTokens": [
        "verification-gap"
      ],
      "purposeTags": [
        "verification-gap",
        "document-review",
        "proof-check",
        "due-diligence",
        "audit"
      ],
      "visualTags": [
        "line",
        "document",
        "magnifier",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "verification-section",
        "process-step",
        "trust-card"
      ],
      "rawBestSectionUse": "case-library-card, verification-section, process-step, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 16",
      "notes": "Harvested from screenshot 16; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"verification-gap\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, paid-review, case-intake, suitability-check\" data-jsi-category=\"verification-gap\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "30a-js-case-library-vnext-icon-verification-gap-30a",
        "audit",
        "balanced",
        "black-stroke",
        "case-intake",
        "case-library-card",
        "case-library-verification-gap-30a",
        "case-library-vnext-icons",
        "case-library-vnext-icons-verification-gap-document",
        "container-eligible",
        "document",
        "document-review",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "line",
        "magnifier",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "paid-review",
        "premium-monoline",
        "primary-default",
        "process-step",
        "proof-check",
        "recommended-boxed-or-free",
        "review-intelligence",
        "review-routing",
        "suitability-check",
        "trust-card",
        "verification-gap",
        "verification-gap-document",
        "verification-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0158",
      "sequence": 158,
      "filename": "24b-js-case-library-vnext-icon-travel-access-cases-24b.svg",
      "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/24b-js-case-library-vnext-icon-travel-access-cases-24b.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-travel-access-cases-travel",
      "rotationGroup": "case-library-travel-access-24b",
      "cleanLabel": "Travel Access Cases 24b",
      "primaryCategory": "travel-access-cases",
      "categoryTokens": [
        "travel-access-cases"
      ],
      "purposeTags": [
        "travel-access",
        "private-travel",
        "route-planning",
        "japan-visit",
        "mobility",
        "access-cases"
      ],
      "visualTags": [
        "line",
        "travel",
        "vehicle",
        "movement",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "travel-section",
        "access-section",
        "related-card"
      ],
      "rawBestSectionUse": "case-library-card, travel-section, access-section, related-card",
      "styleFamily": [
        "premium-monoline",
        "operations-symbol"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 17",
      "notes": "Harvested from screenshot 17; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"travel-access-cases\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"travel-access-cases\" data-jsi-style=\"premium-monoline, operations-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "24b-js-case-library-vnext-icon-travel-access-cases-24b",
        "access-cases",
        "access-coordination",
        "access-section",
        "balanced",
        "black-stroke",
        "cargo-execution",
        "case-library-card",
        "case-library-travel-access-24b",
        "case-library-vnext-icons",
        "case-library-vnext-icons-travel-access-cases-travel",
        "concierge-presence",
        "container-eligible",
        "cultural-navigation",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "japan-visit",
        "line",
        "local-representation",
        "medium",
        "mobility",
        "morphology-none",
        "movement",
        "no-double-frame-risk",
        "operations-symbol",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "private-travel",
        "recommended-boxed-or-free",
        "related-card",
        "route-planning",
        "travel",
        "travel-access",
        "travel-access-cases",
        "travel-access-cases-24b",
        "travel-cultural-access",
        "travel-section",
        "vehicle"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0159",
      "sequence": 159,
      "filename": "19b-js-case-library-vnext-icon-business-entry-cases-19b.svg",
      "handle": "19b-js-case-library-vnext-icon-business-entry-cases-19b",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/19b-js-case-library-vnext-icon-business-entry-cases-19b.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-business-entry-cases-briefcase",
      "rotationGroup": "case-library-business-entry-19b",
      "cleanLabel": "Business Entry Cases Briefcase",
      "primaryCategory": "business-entry-cases",
      "categoryTokens": [
        "business-entry-cases"
      ],
      "purposeTags": [
        "business-entry",
        "market-entry",
        "corporate-setup",
        "japan-side-representation",
        "expansion-cases"
      ],
      "visualTags": [
        "line",
        "briefcase",
        "business",
        "formal",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "business-section",
        "market-entry-section",
        "service-card"
      ],
      "rawBestSectionUse": "case-library-card, business-section, market-entry-section, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "market-entry",
        "business-routing",
        "strategy-alignment",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 17",
      "notes": "Harvested from screenshot 17; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"business-entry-cases\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"market-entry, business-routing, strategy-alignment, native-intake, paid-routing, client-briefing\" data-jsi-category=\"business-entry-cases\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "19b-js-case-library-vnext-icon-business-entry-cases-19b",
        "balanced",
        "black-stroke",
        "briefcase",
        "business",
        "business-entry",
        "business-entry-cases",
        "business-entry-cases-briefcase",
        "business-routing",
        "business-section",
        "case-library-business-entry-19b",
        "case-library-card",
        "case-library-vnext-icons",
        "case-library-vnext-icons-business-entry-cases-briefcase",
        "client-briefing",
        "container-eligible",
        "corporate-setup",
        "excellent",
        "expansion-cases",
        "formal",
        "good-with-ivory-plate-or-css-filter",
        "japan-side-representation",
        "line",
        "logistics-local-representation",
        "market-entry",
        "market-entry-section",
        "medium",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-medium",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "recommended-boxed-or-free",
        "service-card",
        "strategy-alignment"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0160",
      "sequence": 160,
      "filename": "31-js-case-library-vnext-icon-privacy-gap-31.svg",
      "handle": "31-js-case-library-vnext-icon-privacy-gap-31",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/31-js-case-library-vnext-icon-privacy-gap-31.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-privacy-gap-lock",
      "rotationGroup": "case-library-privacy-gap-31",
      "cleanLabel": "Privacy Gap Lock Frame",
      "primaryCategory": "privacy-gap",
      "categoryTokens": [
        "privacy-gap"
      ],
      "purposeTags": [
        "privacy-gap",
        "discretion",
        "confidential-handling",
        "sensitive-case",
        "access-control"
      ],
      "visualTags": [
        "line",
        "lock",
        "frame",
        "security",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "privacy-section",
        "trust-card",
        "sensitive-route-note"
      ],
      "rawBestSectionUse": "case-library-card, privacy-section, trust-card, sensitive-route-note",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 17",
      "notes": "Harvested from screenshot 17; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"privacy-gap\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"privacy-gap\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "31-js-case-library-vnext-icon-privacy-gap-31",
        "access-control",
        "access-coordination",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-privacy-gap-31",
        "case-library-vnext-icons",
        "case-library-vnext-icons-privacy-gap-lock",
        "concierge-presence",
        "confidential-handling",
        "container-risk",
        "cultural-navigation",
        "discretion",
        "double-frame-risk",
        "excellent",
        "frame",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "lock",
        "morphology-rounded-square",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "privacy-gap",
        "privacy-gap-lock-frame",
        "privacy-routing",
        "privacy-section",
        "quiet",
        "recommended-free-only",
        "security",
        "sensitive-case",
        "sensitive-route-note",
        "thin-to-medium",
        "travel-cultural-access",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "rounded-square",
        "intrinsicFrameEvidence": [
          "frame/square keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0161",
      "sequence": 161,
      "filename": "24a-js-case-library-vnext-icon-travel-access-cases-24a.svg",
      "handle": "24a-js-case-library-vnext-icon-travel-access-cases-24a",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/24a-js-case-library-vnext-icon-travel-access-cases-24a.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-travel-access-cases-airplane",
      "rotationGroup": "case-library-travel-access-24a",
      "cleanLabel": "Travel Access Cases 24a Airplane",
      "primaryCategory": "travel-access-cases",
      "categoryTokens": [
        "travel-access-cases"
      ],
      "purposeTags": [
        "travel-access",
        "flight-route",
        "private-travel",
        "overseas-coordination",
        "japan-visit"
      ],
      "visualTags": [
        "line",
        "airplane",
        "travel",
        "movement",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "travel-section",
        "access-section",
        "related-card"
      ],
      "rawBestSectionUse": "case-library-card, travel-section, access-section, related-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 17",
      "notes": "Harvested from screenshot 17; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"travel-access-cases\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"travel-access-cases\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "24a-js-case-library-vnext-icon-travel-access-cases-24a",
        "access-coordination",
        "access-section",
        "airplane",
        "balanced",
        "black-stroke",
        "cargo-execution",
        "case-library-card",
        "case-library-travel-access-24a",
        "case-library-vnext-icons",
        "case-library-vnext-icons-travel-access-cases-airplane",
        "concierge-presence",
        "container-eligible",
        "cultural-navigation",
        "excellent",
        "flight-route",
        "good-with-ivory-plate-or-css-filter",
        "handoff-control",
        "japan-visit",
        "line",
        "local-representation",
        "medium",
        "morphology-none",
        "movement",
        "no-double-frame-risk",
        "outline-medium",
        "overseas-coordination",
        "premium-monoline",
        "private-travel",
        "recommended-boxed-or-free",
        "related-card",
        "secondary-variant",
        "travel",
        "travel-access",
        "travel-access-cases",
        "travel-access-cases-24a-airplane",
        "travel-cultural-access",
        "travel-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0162",
      "sequence": 162,
      "filename": "24c-js-case-library-vnext-icon-travel-access-cases-24c.svg",
      "handle": "24c-js-case-library-vnext-icon-travel-access-cases-24c",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/24c-js-case-library-vnext-icon-travel-access-cases-24c.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-travel-access-cases-airplane",
      "rotationGroup": "case-library-travel-access-24c",
      "cleanLabel": "Travel Access Cases 24c Plane Circle",
      "primaryCategory": "travel-access-cases",
      "categoryTokens": [
        "travel-access-cases"
      ],
      "purposeTags": [
        "travel-access",
        "route-coordination",
        "private-travel",
        "airport-path",
        "mobility-cases"
      ],
      "visualTags": [
        "line",
        "airplane",
        "circle",
        "travel",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "travel-section",
        "access-section",
        "process-step"
      ],
      "rawBestSectionUse": "case-library-card, travel-section, access-section, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 3,
      "categoryRank": 3,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 17",
      "notes": "Harvested from screenshot 17; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"travel-access-cases\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence, route-intelligence, coordination, strategy\" data-jsi-category=\"travel-access-cases\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "24c-js-case-library-vnext-icon-travel-access-cases-24c",
        "access-coordination",
        "access-section",
        "airplane",
        "airport-path",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-travel-access-24c",
        "case-library-vnext-icons",
        "case-library-vnext-icons-travel-access-cases-airplane",
        "circle",
        "concierge-presence",
        "container-eligible",
        "coordination",
        "cultural-navigation",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "mobility-cases",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "private-travel",
        "process-step",
        "recommended-boxed-or-free",
        "route-coordination",
        "route-intelligence",
        "secondary-variant",
        "strategy",
        "travel",
        "travel-access",
        "travel-access-cases",
        "travel-access-cases-24c-plane-circle",
        "travel-cultural-access",
        "travel-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0163",
      "sequence": 163,
      "filename": "18-js-case-library-vnext-icon-sensitive-matters-18.svg",
      "handle": "18-js-case-library-vnext-icon-sensitive-matters-18",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/18-js-case-library-vnext-icon-sensitive-matters-18.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-sensitive-matters-door",
      "rotationGroup": "case-library-sensitive-matters-18",
      "cleanLabel": "Sensitive Matters Door",
      "primaryCategory": "sensitive-matters",
      "categoryTokens": [
        "sensitive-matters"
      ],
      "purposeTags": [
        "sensitive-matters",
        "discretion",
        "private-route",
        "confidential-handling",
        "boundary-aware-support"
      ],
      "visualTags": [
        "line",
        "door",
        "threshold",
        "privacy",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "sensitive-section",
        "privacy-section",
        "trust-card"
      ],
      "rawBestSectionUse": "case-library-card, sensitive-section, privacy-section, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 17",
      "notes": "Harvested from screenshot 17; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"sensitive-matters\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, execution-support, outcome-control, completion\" data-jsi-category=\"sensitive-matters\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "18-js-case-library-vnext-icon-sensitive-matters-18",
        "balanced",
        "black-stroke",
        "boundary-aware-support",
        "case-library-card",
        "case-library-sensitive-matters-18",
        "case-library-vnext-icons",
        "case-library-vnext-icons-sensitive-matters-door",
        "completion",
        "confidential-handling",
        "container-eligible",
        "discretion",
        "door",
        "excellent",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "outcome-control",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "privacy",
        "privacy-routing",
        "privacy-section",
        "private-route",
        "quiet",
        "recommended-boxed-or-free",
        "sensitive-discreet-routing",
        "sensitive-matters",
        "sensitive-matters-door",
        "sensitive-section",
        "thin-to-medium",
        "threshold",
        "trust-card",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0164",
      "sequence": 164,
      "filename": "24d-js-case-library-vnext-icon-travel-access-cases-24d.svg",
      "handle": "24d-js-case-library-vnext-icon-travel-access-cases-24d",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/24d-js-case-library-vnext-icon-travel-access-cases-24d.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-travel-access-cases-airplane",
      "rotationGroup": "case-library-travel-access-24d",
      "cleanLabel": "Travel Access Cases 24d Jet Path",
      "primaryCategory": "travel-access-cases",
      "categoryTokens": [
        "travel-access-cases"
      ],
      "purposeTags": [
        "travel-access",
        "flight-path",
        "private-travel",
        "route-design",
        "mobility-cases"
      ],
      "visualTags": [
        "line",
        "airplane",
        "dotted-path",
        "travel",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "travel-section",
        "access-section",
        "related-card"
      ],
      "rawBestSectionUse": "case-library-card, travel-section, access-section, related-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 4,
      "categoryRank": 4,
      "designFamilyRank": 3,
      "variantRole": "rotation-fallback",
      "sourceBatch": "Screenshot 17",
      "notes": "Harvested from screenshot 17; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"travel-access-cases\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"travel-access-cases\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "24d-js-case-library-vnext-icon-travel-access-cases-24d",
        "access-coordination",
        "access-section",
        "airplane",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-travel-access-24d",
        "case-library-vnext-icons",
        "case-library-vnext-icons-travel-access-cases-airplane",
        "concierge-presence",
        "container-eligible",
        "cultural-navigation",
        "dotted-path",
        "excellent",
        "flight-path",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "mobility-cases",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "private-travel",
        "recommended-boxed-or-free",
        "related-card",
        "rotation-fallback",
        "route-design",
        "travel",
        "travel-access",
        "travel-access-cases",
        "travel-access-cases-24d-jet-path",
        "travel-cultural-access",
        "travel-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0165",
      "sequence": 165,
      "filename": "27-js-case-library-vnext-icon-access-gap-27.svg",
      "handle": "27-js-case-library-vnext-icon-access-gap-27",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/27-js-case-library-vnext-icon-access-gap-27.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-access-gap-doorway",
      "rotationGroup": "case-library-access-gap-27",
      "cleanLabel": "Access Gap Doorway",
      "primaryCategory": "access-gap",
      "categoryTokens": [
        "access-gap"
      ],
      "purposeTags": [
        "access-gap",
        "closed-route",
        "local-access",
        "route-failure",
        "private-access"
      ],
      "visualTags": [
        "line",
        "doorway",
        "access",
        "threshold",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "access-section",
        "pain-point-section",
        "service-card"
      ],
      "rawBestSectionUse": "case-library-card, access-section, pain-point-section, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 17",
      "notes": "Harvested from screenshot 17; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"access-gap\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"access-gap\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "27-js-case-library-vnext-icon-access-gap-27",
        "access",
        "access-coordination",
        "access-gap",
        "access-gap-doorway",
        "access-section",
        "balanced",
        "black-stroke",
        "case-library-access-gap-27",
        "case-library-card",
        "case-library-vnext-icons",
        "case-library-vnext-icons-access-gap-doorway",
        "closed-route",
        "concierge-presence",
        "container-eligible",
        "cultural-navigation",
        "doorway",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "local-access",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "pain-point-section",
        "premium-monoline",
        "primary-default",
        "private-access",
        "recommended-boxed-or-free",
        "route-failure",
        "service-card",
        "threshold",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0166",
      "sequence": 166,
      "filename": "19a-js-case-library-vnext-icon-business-entry-cases-19a.svg",
      "handle": "19a-js-case-library-vnext-icon-business-entry-cases-19a",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/19a-js-case-library-vnext-icon-business-entry-cases-19a.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-business-entry-cases-briefcase",
      "rotationGroup": "case-library-business-entry-19a",
      "cleanLabel": "Business Entry Cases 19a Briefcase",
      "primaryCategory": "business-entry-cases",
      "categoryTokens": [
        "business-entry-cases"
      ],
      "purposeTags": [
        "business-entry",
        "market-entry",
        "corporate-route",
        "japan-business",
        "commercial-access"
      ],
      "visualTags": [
        "line",
        "briefcase",
        "business",
        "formal",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "business-section",
        "market-entry-section",
        "service-card"
      ],
      "rawBestSectionUse": "case-library-card, business-section, market-entry-section, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "market-entry",
        "business-routing",
        "strategy-alignment",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"business-entry-cases\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"market-entry, business-routing, strategy-alignment, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"business-entry-cases\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "19a-js-case-library-vnext-icon-business-entry-cases-19a",
        "access-coordination",
        "balanced",
        "black-stroke",
        "briefcase",
        "business",
        "business-entry",
        "business-entry-cases",
        "business-entry-cases-19a-briefcase",
        "business-routing",
        "business-section",
        "case-library-business-entry-19a",
        "case-library-card",
        "case-library-vnext-icons",
        "case-library-vnext-icons-business-entry-cases-briefcase",
        "commercial-access",
        "concierge-presence",
        "container-eligible",
        "corporate-route",
        "cultural-navigation",
        "excellent",
        "formal",
        "good-with-ivory-plate-or-css-filter",
        "japan-business",
        "line",
        "market-entry",
        "market-entry-section",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "recommended-boxed-or-free",
        "secondary-variant",
        "service-card",
        "strategy-alignment",
        "travel-cultural-access"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0167",
      "sequence": 167,
      "filename": "26a-js-case-library-vnext-icon-discreet-matter-cases-26a.svg",
      "handle": "26a-js-case-library-vnext-icon-discreet-matter-cases-26a",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/26a-js-case-library-vnext-icon-discreet-matter-cases-26a.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-secret-matter-cases-door",
      "rotationGroup": "case-library-secret-matter-26a",
      "cleanLabel": "Secret Matter Cases 26a Door Shield",
      "primaryCategory": "secret-matter-cases",
      "categoryTokens": [
        "secret-matter-cases"
      ],
      "purposeTags": [
        "secret-matter",
        "discretion",
        "sensitive-route",
        "confidential-handling",
        "privacy-protection"
      ],
      "visualTags": [
        "line",
        "door",
        "shield",
        "private",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "sensitive-section",
        "privacy-section",
        "trust-card"
      ],
      "rawBestSectionUse": "case-library-card, sensitive-section, privacy-section, trust-card",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL. | Original C handle did not match URL filename; polished handle uses URL as source of truth.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"secret-matter-cases\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing\" data-jsi-category=\"secret-matter-cases\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "26a-js-case-library-vnext-icon-discreet-matter-cases-26a",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-secret-matter-26a",
        "case-library-vnext-icons",
        "case-library-vnext-icons-secret-matter-cases-door",
        "confidential-handling",
        "container-eligible",
        "discretion",
        "door",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "privacy-protection",
        "privacy-routing",
        "privacy-section",
        "private",
        "quiet",
        "recommended-boxed-or-free",
        "secret-matter",
        "secret-matter-cases",
        "secret-matter-cases-26a-door-shield",
        "sensitive-discreet-routing",
        "sensitive-route",
        "sensitive-section",
        "shield",
        "thin-to-medium",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0168",
      "sequence": 168,
      "filename": "29a-js-case-library-vnext-icon-execution-gap-29a.svg",
      "handle": "29a-js-case-library-vnext-icon-execution-gap-29a",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/29a-js-case-library-vnext-icon-execution-gap-29a.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-execution-gap-compass",
      "rotationGroup": "case-library-execution-gap-29a",
      "cleanLabel": "Execution Gap 29a Compass Star",
      "primaryCategory": "execution-gap",
      "categoryTokens": [
        "execution-gap"
      ],
      "purposeTags": [
        "execution-gap",
        "route-correction",
        "operational-gap",
        "execution-support",
        "coordination-failure"
      ],
      "visualTags": [
        "line",
        "compass",
        "star",
        "direction",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "execution-section",
        "pain-point-section",
        "process-step"
      ],
      "rawBestSectionUse": "case-library-card, execution-section, pain-point-section, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"execution-gap\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion, route-intelligence, coordination, strategy\" data-jsi-category=\"execution-gap\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "29a-js-case-library-vnext-icon-execution-gap-29a",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-execution-gap-29a",
        "case-library-vnext-icons",
        "case-library-vnext-icons-execution-gap-compass",
        "compass",
        "completion",
        "container-risk",
        "coordination",
        "coordination-failure",
        "direction",
        "double-frame-risk",
        "excellent",
        "execution-gap",
        "execution-gap-29a-compass-star",
        "execution-section",
        "execution-support",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "morphology-circle-risk",
        "operational-gap",
        "outcome-control",
        "outline-medium",
        "pain-point-section",
        "premium-monoline",
        "process-step",
        "recommended-free-only",
        "route-correction",
        "route-intelligence",
        "secondary-variant",
        "star",
        "strategy"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0169",
      "sequence": 169,
      "filename": "36-js-case-library-vnext-icon-accessible-247-36.svg",
      "handle": "36-js-case-library-vnext-icon-accessible-247-36",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/36-js-case-library-vnext-icon-accessible-247-36.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-accessible-247-clock",
      "rotationGroup": "case-library-accessible-247-36",
      "cleanLabel": "Accessible 24/7 Clock",
      "primaryCategory": "accessible-247",
      "categoryTokens": [
        "accessible-247"
      ],
      "purposeTags": [
        "24-7-access",
        "urgent-support",
        "availability",
        "time-sensitive-route",
        "continuous-assistance"
      ],
      "visualTags": [
        "line",
        "clock",
        "availability",
        "circular",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "urgency-section",
        "support-section",
        "trust-card"
      ],
      "rawBestSectionUse": "case-library-card, urgency-section, support-section, trust-card",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol",
        "sequence-badge"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"accessible-247\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"accessible-247\" data-jsi-style=\"premium-monoline, trust-symbol, sequence-badge\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "24-7-access",
        "36-js-case-library-vnext-icon-accessible-247-36",
        "access-coordination",
        "accessible-24-7-clock",
        "accessible-247",
        "availability",
        "balanced",
        "black-stroke",
        "case-library-accessible-247-36",
        "case-library-card",
        "case-library-vnext-icons",
        "case-library-vnext-icons-accessible-247-clock",
        "circular",
        "clock",
        "concierge-presence",
        "container-risk",
        "continuous-assistance",
        "cultural-navigation",
        "discretion",
        "double-frame-risk",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "morphology-circle",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "recommended-free-only",
        "sequence-badge",
        "support-section",
        "time-sensitive-route",
        "travel-cultural-access",
        "trust-card",
        "trust-protection",
        "trust-symbol",
        "urgency-section",
        "urgent-support"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0170",
      "sequence": 170,
      "filename": "26b-js-case-library-vnext-icon-discreet-matter-cases-26b.svg",
      "handle": "26b-js-case-library-vnext-icon-discreet-matter-cases-26b",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/26b-js-case-library-vnext-icon-discreet-matter-cases-26b.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-secret-matter-cases-crossed-eye",
      "rotationGroup": "case-library-secret-matter-26b",
      "cleanLabel": "Secret Matter Cases 26b Discreet Eye",
      "primaryCategory": "secret-matter-cases",
      "categoryTokens": [
        "secret-matter-cases"
      ],
      "purposeTags": [
        "secret-matter",
        "discreet-operations",
        "privacy",
        "sensitive-route",
        "confidential-review"
      ],
      "visualTags": [
        "line",
        "crossed-eye",
        "privacy",
        "restricted",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "sensitive-section",
        "privacy-section",
        "boundary-note"
      ],
      "rawBestSectionUse": "case-library-card, sensitive-section, privacy-section, boundary-note",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL. | Original C handle did not match URL filename; polished handle uses URL as source of truth.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"secret-matter-cases\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, paid-review, case-intake, suitability-check\" data-jsi-category=\"secret-matter-cases\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "26b-js-case-library-vnext-icon-discreet-matter-cases-26b",
        "balanced",
        "black-stroke",
        "boundary-note",
        "case-intake",
        "case-library-card",
        "case-library-secret-matter-26b",
        "case-library-vnext-icons",
        "case-library-vnext-icons-secret-matter-cases-crossed-eye",
        "confidential-review",
        "container-eligible",
        "crossed-eye",
        "discreet-operations",
        "discretion",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "paid-review",
        "premium-monoline",
        "privacy",
        "privacy-routing",
        "privacy-section",
        "quiet",
        "recommended-boxed-or-free",
        "restricted",
        "secondary-variant",
        "secret-matter",
        "secret-matter-cases",
        "secret-matter-cases-26b-discreet-eye",
        "sensitive-discreet-routing",
        "sensitive-route",
        "sensitive-section",
        "suitability-check",
        "thin-to-medium",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0171",
      "sequence": 171,
      "filename": "33-js-case-library-vnext-icon-discreet-professional-33.svg",
      "handle": "33-js-case-library-vnext-icon-discreet-professional-33",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/33-js-case-library-vnext-icon-discreet-professional-33.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-secret-professional-tie",
      "rotationGroup": "case-library-secret-professional-33",
      "cleanLabel": "Secret Professional 33 Tie Shield",
      "primaryCategory": "secret-professional",
      "categoryTokens": [
        "secret-professional"
      ],
      "purposeTags": [
        "professional-discretion",
        "confidential-professional",
        "sensitive-case",
        "private-representative",
        "trust"
      ],
      "visualTags": [
        "line",
        "tie",
        "shield",
        "professional",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "professional-section",
        "privacy-section",
        "trust-card"
      ],
      "rawBestSectionUse": "case-library-card, professional-section, privacy-section, trust-card",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL. | Original C handle did not match URL filename; polished handle uses URL as source of truth.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"secret-professional\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"secret-professional\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "33-js-case-library-vnext-icon-discreet-professional-33",
        "authority-signal",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-secret-professional-33",
        "case-library-vnext-icons",
        "case-library-vnext-icons-secret-professional-tie",
        "confidential-professional",
        "container-eligible",
        "discretion",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "premium-trust",
        "primary-default",
        "privacy-routing",
        "privacy-section",
        "private-representative",
        "professional",
        "professional-discretion",
        "professional-section",
        "quiet",
        "recommended-boxed-or-free",
        "reserved-access",
        "secret-professional",
        "secret-professional-33-tie-shield",
        "sensitive-case",
        "sensitive-discreet-routing",
        "shield",
        "thin-to-medium",
        "tie",
        "trust",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0172",
      "sequence": 172,
      "filename": "20-js-case-library-vnext-icon-investment-deal-flow-cases-20.svg",
      "handle": "20-js-case-library-vnext-icon-investment-deal-flow-cases-20",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/20-js-case-library-vnext-icon-investment-deal-flow-cases-20.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-investment-deal-flow-cases-growth-arrow",
      "rotationGroup": "case-library-investment-deal-flow-20",
      "cleanLabel": "Investment Deal Flow Cases 20 Growth Arrow",
      "primaryCategory": "investment-deal-flow-cases",
      "categoryTokens": [
        "investment-deal-flow-cases"
      ],
      "purposeTags": [
        "investment",
        "deal-flow",
        "capital-route",
        "opportunity-screening",
        "business-expansion"
      ],
      "visualTags": [
        "line",
        "growth-arrow",
        "circle",
        "capital",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "investment-section",
        "business-section",
        "intelligence-block"
      ],
      "rawBestSectionUse": "case-library-card, investment-section, business-section, intelligence-block",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "intelligence",
        "review-routing",
        "due-diligence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"investment-deal-flow-cases\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, intelligence, review-routing, due-diligence\" data-jsi-category=\"investment-deal-flow-cases\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "20-js-case-library-vnext-icon-investment-deal-flow-cases-20",
        "balanced",
        "black-stroke",
        "business-expansion",
        "business-section",
        "capital",
        "capital-route",
        "case-library-card",
        "case-library-investment-deal-flow-20",
        "case-library-vnext-icons",
        "case-library-vnext-icons-investment-deal-flow-cases-growth-arrow",
        "circle",
        "container-eligible",
        "deal-flow",
        "discretion",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "growth-arrow",
        "intelligence",
        "intelligence-block",
        "investment",
        "investment-deal-flow-cases",
        "investment-deal-flow-cases-20-growth-arrow",
        "investment-section",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "opportunity-screening",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "recommended-boxed-or-free",
        "review-intelligence",
        "review-routing",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0173",
      "sequence": 173,
      "filename": "28-js-case-library-vnext-icon-language-gap-28.svg",
      "handle": "28-js-case-library-vnext-icon-language-gap-28",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/28-js-case-library-vnext-icon-language-gap-28.svg?v=1779243336",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-language-gap-chat-bubbles",
      "rotationGroup": "case-library-language-gap-28",
      "cleanLabel": "Language Gap Chat Bubbles",
      "primaryCategory": "language-gap",
      "categoryTokens": [
        "language-gap"
      ],
      "purposeTags": [
        "language-gap",
        "translation-risk",
        "communication-support",
        "cross-border-communication",
        "interpretation"
      ],
      "visualTags": [
        "line",
        "chat-bubbles",
        "language",
        "message",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "pain-point-section",
        "communication-section",
        "support-card"
      ],
      "rawBestSectionUse": "case-library-card, pain-point-section, communication-section, support-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"language-gap\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"language-gap\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "28-js-case-library-vnext-icon-language-gap-28",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-language-gap-28",
        "case-library-vnext-icons",
        "case-library-vnext-icons-language-gap-chat-bubbles",
        "chat-bubbles",
        "communication-section",
        "communication-support",
        "completion",
        "container-eligible",
        "cross-border-communication",
        "excellent",
        "execution-support",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "interpretation",
        "language",
        "language-gap",
        "language-gap-chat-bubbles",
        "line",
        "medium",
        "message",
        "morphology-none",
        "no-double-frame-risk",
        "outcome-control",
        "outline-medium",
        "pain-point-section",
        "premium-monoline",
        "primary-default",
        "recommended-boxed-or-free",
        "support-card",
        "translation-risk"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0174",
      "sequence": 174,
      "filename": "30c-js-case-library-vnext-icon-verification-gap-30c.svg",
      "handle": "30c-js-case-library-vnext-icon-verification-gap-30c",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/30c-js-case-library-vnext-icon-verification-gap-30c.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-verification-gap-magnifier",
      "rotationGroup": "case-library-verification-gap-30c",
      "cleanLabel": "Verification Gap 30c Magnifier",
      "primaryCategory": "verification-gap",
      "categoryTokens": [
        "verification-gap"
      ],
      "purposeTags": [
        "verification-gap",
        "due-diligence",
        "document-review",
        "authenticity-check",
        "risk-clarification"
      ],
      "visualTags": [
        "line",
        "magnifier",
        "document-review",
        "verification",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "verification-section",
        "due-diligence-section",
        "review-card"
      ],
      "rawBestSectionUse": "case-library-card, verification-section, due-diligence-section, review-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"verification-gap\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, paid-review, case-intake, suitability-check\" data-jsi-category=\"verification-gap\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "30c-js-case-library-vnext-icon-verification-gap-30c",
        "authenticity-check",
        "balanced",
        "black-stroke",
        "case-intake",
        "case-library-card",
        "case-library-verification-gap-30c",
        "case-library-vnext-icons",
        "case-library-vnext-icons-verification-gap-magnifier",
        "container-eligible",
        "document-review",
        "due-diligence",
        "due-diligence-section",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "line",
        "magnifier",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "paid-review",
        "premium-monoline",
        "recommended-boxed-or-free",
        "review-card",
        "review-intelligence",
        "review-routing",
        "risk-clarification",
        "secondary-variant",
        "suitability-check",
        "verification",
        "verification-gap",
        "verification-gap-30c-magnifier",
        "verification-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0175",
      "sequence": 175,
      "filename": "32-js-case-library-vnext-icon-time-sensitive-32.svg",
      "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/32-js-case-library-vnext-icon-time-sensitive-32.svg?v=1779243336",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-time-sensitive-clock",
      "rotationGroup": "case-library-time-sensitive-32",
      "cleanLabel": "Time Sensitive Clock",
      "primaryCategory": "time-sensitive",
      "categoryTokens": [
        "time-sensitive"
      ],
      "purposeTags": [
        "time-sensitive",
        "urgent-window",
        "deadline",
        "calendar-risk",
        "execution-timing"
      ],
      "visualTags": [
        "line",
        "clock",
        "urgency",
        "circular",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "urgency-section",
        "scheduling-note",
        "process-step"
      ],
      "rawBestSectionUse": "case-library-card, urgency-section, scheduling-note, process-step",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol",
        "sequence-badge"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"time-sensitive\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, execution-support, outcome-control, completion\" data-jsi-category=\"time-sensitive\" data-jsi-style=\"premium-monoline, trust-symbol, sequence-badge\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "32-js-case-library-vnext-icon-time-sensitive-32",
        "balanced",
        "black-stroke",
        "calendar-risk",
        "case-library-card",
        "case-library-time-sensitive-32",
        "case-library-vnext-icons",
        "case-library-vnext-icons-time-sensitive-clock",
        "circular",
        "clock",
        "completion",
        "container-risk",
        "deadline",
        "discretion",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "execution-timing",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "morphology-circle",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "process-step",
        "recommended-free-only",
        "scheduling-note",
        "sensitive-discreet-routing",
        "sequence-badge",
        "time-sensitive",
        "time-sensitive-clock",
        "trust-protection",
        "trust-symbol",
        "urgency",
        "urgency-section",
        "urgent-window"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0176",
      "sequence": 176,
      "filename": "30b-js-case-library-vnext-icon-verification-gap-30b.svg",
      "handle": "30b-js-case-library-vnext-icon-verification-gap-30b",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/30b-js-case-library-vnext-icon-verification-gap-30b.svg?v=1779243336",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-verification-gap-briefcase",
      "rotationGroup": "case-library-verification-gap-30b",
      "cleanLabel": "Verification Gap 30b Briefcase Lens",
      "primaryCategory": "verification-gap",
      "categoryTokens": [
        "verification-gap"
      ],
      "purposeTags": [
        "verification-gap",
        "professional-review",
        "document-check",
        "due-diligence",
        "risk-screening"
      ],
      "visualTags": [
        "line",
        "briefcase",
        "magnifier",
        "verification",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "verification-section",
        "due-diligence-section",
        "business-section"
      ],
      "rawBestSectionUse": "case-library-card, verification-section, due-diligence-section, business-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 3,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"verification-gap\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, paid-review, case-intake, suitability-check\" data-jsi-category=\"verification-gap\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "30b-js-case-library-vnext-icon-verification-gap-30b",
        "balanced",
        "black-stroke",
        "briefcase",
        "business-section",
        "case-intake",
        "case-library-card",
        "case-library-verification-gap-30b",
        "case-library-vnext-icons",
        "case-library-vnext-icons-verification-gap-briefcase",
        "container-eligible",
        "document-check",
        "due-diligence",
        "due-diligence-section",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "line",
        "magnifier",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "paid-review",
        "premium-monoline",
        "professional-review",
        "recommended-boxed-or-free",
        "review-intelligence",
        "review-routing",
        "risk-screening",
        "secondary-variant",
        "suitability-check",
        "verification",
        "verification-gap",
        "verification-gap-30b-briefcase-lens",
        "verification-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0177",
      "sequence": 177,
      "filename": "35b-js-case-library-vnext-icon-results-driven-35b.svg",
      "handle": "35b-js-case-library-vnext-icon-results-driven-35b",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/35b-js-case-library-vnext-icon-results-driven-35b.svg?v=1779243335",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-results-driven-target",
      "rotationGroup": "case-library-results-driven-35b",
      "cleanLabel": "Results Driven 35b Target",
      "primaryCategory": "results-driven",
      "categoryTokens": [
        "results-driven"
      ],
      "purposeTags": [
        "results-driven",
        "target-outcome",
        "precision",
        "route-success",
        "focused-execution"
      ],
      "visualTags": [
        "line",
        "target",
        "arrow",
        "result",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "results-section",
        "execution-section",
        "process-step"
      ],
      "rawBestSectionUse": "case-library-card, results-section, execution-section, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"results-driven\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"results-driven\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "35b-js-case-library-vnext-icon-results-driven-35b",
        "arrow",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-results-driven-35b",
        "case-library-vnext-icons",
        "case-library-vnext-icons-results-driven-target",
        "completion",
        "container-eligible",
        "excellent",
        "execution-section",
        "execution-support",
        "focused-execution",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outcome-control",
        "outline-medium",
        "precision",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "result",
        "results-driven",
        "results-driven-35b-target",
        "results-section",
        "route-success",
        "target",
        "target-outcome"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0178",
      "sequence": 178,
      "filename": "35a-js-case-library-vnext-icon-results-driven-35a.svg",
      "handle": "35a-js-case-library-vnext-icon-results-driven-35a",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/35a-js-case-library-vnext-icon-results-driven-35a.svg?v=1779243336",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-results-driven-spark",
      "rotationGroup": "case-library-results-driven-35a",
      "cleanLabel": "Results Driven 35a Spark",
      "primaryCategory": "results-driven",
      "categoryTokens": [
        "results-driven"
      ],
      "purposeTags": [
        "results-driven",
        "outcome-clarity",
        "breakthrough",
        "route-activation",
        "success-signal"
      ],
      "visualTags": [
        "line",
        "spark",
        "starburst",
        "result",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "results-section",
        "success-section",
        "emphasis-card"
      ],
      "rawBestSectionUse": "case-library-card, results-section, success-section, emphasis-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-statement",
      "visualDensity": "dense-statement",
      "lineWeight": "medium-bold",
      "intensity": "statement",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 61.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"results-driven\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"results-driven\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_statement\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "35a-js-case-library-vnext-icon-results-driven-35a",
        "black-stroke",
        "breakthrough",
        "case-library-card",
        "case-library-results-driven-35a",
        "case-library-vnext-icons",
        "case-library-vnext-icons-results-driven-spark",
        "completion",
        "container-eligible",
        "dense-statement",
        "emphasis-card",
        "excellent",
        "execution-support",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium-bold",
        "morphology-none",
        "no-double-frame-risk",
        "outcome-clarity",
        "outcome-control",
        "outline-statement",
        "premium-monoline",
        "recommended-boxed-or-free",
        "result",
        "results-driven",
        "results-driven-35a-spark",
        "results-section",
        "route-activation",
        "secondary-variant",
        "spark",
        "starburst",
        "statement",
        "success-section",
        "success-signal"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0179",
      "sequence": 179,
      "filename": "34-js-case-library-vnext-icon-japan-based-execution-34.svg",
      "handle": "34-js-case-library-vnext-icon-japan-based-execution-34",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/34-js-case-library-vnext-icon-japan-based-execution-34.svg?v=1779243336",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-japan-based-execution-target",
      "rotationGroup": "case-library-japan-based-execution-34",
      "cleanLabel": "Japan-Based Execution Target",
      "primaryCategory": "japan-based-execution",
      "categoryTokens": [
        "japan-based-execution"
      ],
      "purposeTags": [
        "japan-based-execution",
        "local-operation",
        "ground-team",
        "route-completion",
        "execution-control"
      ],
      "visualTags": [
        "line",
        "target",
        "circle",
        "japan-execution",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "execution-section",
        "local-representation-section",
        "trust-card"
      ],
      "rawBestSectionUse": "case-library-card, execution-section, local-representation-section, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 18",
      "notes": "Harvested from screenshot 18; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"japan-based-execution\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"japan-based-execution\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "34-js-case-library-vnext-icon-japan-based-execution-34",
        "balanced",
        "black-stroke",
        "case-library-card",
        "case-library-japan-based-execution-34",
        "case-library-vnext-icons",
        "case-library-vnext-icons-japan-based-execution-target",
        "circle",
        "completion",
        "container-eligible",
        "excellent",
        "execution-control",
        "execution-section",
        "execution-support",
        "good-with-ivory-plate-or-css-filter",
        "ground-team",
        "japan-based-execution",
        "japan-based-execution-target",
        "japan-execution",
        "line",
        "local-operation",
        "local-representation-section",
        "logistics-local-representation",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "recommended-boxed-or-free",
        "route-completion",
        "target",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0180",
      "sequence": 180,
      "filename": "37-js-case-library-vnext-icon-non-refundable-review-37.svg",
      "handle": "37-js-case-library-vnext-icon-non-refundable-review-37",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/37-js-case-library-vnext-icon-non-refundable-review-37.svg?v=1779243336",
      "assetType": "svg",
      "assetFamily": "Case Library vNext Icons",
      "familyKey": "case-library-vnext-icons-refundable-review-receipt",
      "rotationGroup": "case-library-refundable-review-37",
      "cleanLabel": "Refundable Review Receipt",
      "primaryCategory": "refundable-review",
      "categoryTokens": [
        "refundable-review"
      ],
      "purposeTags": [
        "refundable-review",
        "refund-logic",
        "review-terms",
        "paid-review",
        "eligibility",
        "receipt"
      ],
      "visualTags": [
        "line",
        "receipt",
        "document",
        "dotted-edge",
        "black-stroke"
      ],
      "sectionFit": [
        "case-library-card",
        "pricing-note",
        "review-section",
        "intake-confirmation",
        "product-card"
      ],
      "rawBestSectionUse": "case-library-card, pricing-note, review-section, intake-confirmation, product-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 19",
      "notes": "Harvested from screenshot 19; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL. | Original C handle did not match URL filename; polished handle uses URL as source of truth.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"refundable-review\" data-jsi-section=\"case-library-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, native-intake, paid-routing, client-briefing\" data-jsi-category=\"refundable-review\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "37-js-case-library-vnext-icon-non-refundable-review-37",
        "balanced",
        "black-stroke",
        "case-intake",
        "case-library-card",
        "case-library-refundable-review-37",
        "case-library-vnext-icons",
        "case-library-vnext-icons-refundable-review-receipt",
        "client-briefing",
        "container-eligible",
        "document",
        "dotted-edge",
        "eligibility",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "line",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-light",
        "paid-review",
        "paid-routing",
        "premium-monoline",
        "pricing-note",
        "primary-default",
        "product-card",
        "quiet",
        "receipt",
        "recommended-boxed-or-free",
        "refund-logic",
        "refundable-review",
        "refundable-review-receipt",
        "review-intelligence",
        "review-section",
        "review-terms",
        "suitability-check",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0181",
      "sequence": 181,
      "filename": "10-js-faq-vnext-icon-process-three-gates-10.svg",
      "handle": "10-js-faq-vnext-icon-process-three-gates-10",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/10-js-faq-vnext-icon-process-three-gates-10.svg?v=1779252646",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-process-gates",
      "rotationGroup": "faq-process-three-gates-10",
      "cleanLabel": "Process Three Gates",
      "primaryCategory": "faq-process",
      "categoryTokens": [
        "faq-process"
      ],
      "purposeTags": [
        "process-gates",
        "review-gates",
        "staged-intake",
        "decision-checkpoints",
        "eligibility"
      ],
      "visualTags": [
        "line",
        "gates",
        "vertical-markers",
        "process",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "process-step",
        "intake-section",
        "how-it-works-card"
      ],
      "rawBestSectionUse": "FAQ-row, process-step, intake-section, how-it-works-card",
      "styleFamily": [
        "premium-monoline",
        "japan-cultural-symbol"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-process\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"faq-process\" data-jsi-style=\"premium-monoline, japan-cultural-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "10-js-faq-vnext-icon-process-three-gates-10",
        "access-coordination",
        "balanced",
        "black-stroke",
        "case-intake",
        "concierge-presence",
        "container-eligible",
        "cultural-navigation",
        "decision-checkpoints",
        "eligibility",
        "excellent",
        "faq-process",
        "faq-process-three-gates-10",
        "faq-row",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-process-gates",
        "gates",
        "good-with-ivory-plate-or-css-filter",
        "how-it-works-card",
        "intake-section",
        "japan-cultural-symbol",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "paid-review",
        "premium-monoline",
        "primary-default",
        "process",
        "process-gates",
        "process-step",
        "process-three-gates",
        "recommended-boxed-or-free",
        "review-gates",
        "review-intelligence",
        "staged-intake",
        "suitability-check",
        "vertical-markers"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0182",
      "sequence": 182,
      "filename": "11-js-faq-vnext-icon-payment-invoice-coins-11.svg",
      "handle": "11-js-faq-vnext-icon-payment-invoice-coins-11",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/11-js-faq-vnext-icon-payment-invoice-coins-11.svg?v=1779252646",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-payment-invoice",
      "rotationGroup": "faq-payment-invoice-coins-11",
      "cleanLabel": "Payment Invoice Coins",
      "primaryCategory": "faq-payment",
      "categoryTokens": [
        "faq-payment"
      ],
      "purposeTags": [
        "payment",
        "invoice",
        "pricing",
        "fees",
        "paid-review",
        "billing-clarity"
      ],
      "visualTags": [
        "line",
        "invoice",
        "coin",
        "money",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "pricing-note",
        "payment-section",
        "product-card"
      ],
      "rawBestSectionUse": "FAQ-row, pricing-note, payment-section, product-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-payment\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check\" data-jsi-category=\"faq-payment\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "11-js-faq-vnext-icon-payment-invoice-coins-11",
        "balanced",
        "billing-clarity",
        "black-stroke",
        "case-intake",
        "coin",
        "container-risk",
        "double-frame-risk",
        "excellent",
        "faq-payment",
        "faq-payment-invoice-coins-11",
        "faq-row",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-payment-invoice",
        "fees",
        "good-with-ivory-plate-or-css-filter",
        "invoice",
        "line",
        "medium",
        "money",
        "morphology-circle",
        "outline-medium",
        "paid-review",
        "payment",
        "payment-invoice-coins",
        "payment-section",
        "premium-monoline",
        "pricing",
        "pricing-note",
        "primary-default",
        "product-card",
        "recommended-free-only",
        "review-intelligence",
        "suitability-check"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0183",
      "sequence": 183,
      "filename": "12-js-faq-vnext-icon-engagement-sealed-12.svg",
      "handle": "12-js-faq-vnext-icon-engagement-sealed-12",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/12-js-faq-vnext-icon-engagement-sealed-12.svg?v=1779252647",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-engagement-document",
      "rotationGroup": "faq-engagement-sealed-12",
      "cleanLabel": "Engagement Sealed",
      "primaryCategory": "faq-engagement",
      "categoryTokens": [
        "faq-engagement"
      ],
      "purposeTags": [
        "engagement-terms",
        "sealed-request",
        "formal-acceptance",
        "documents",
        "confirmation"
      ],
      "visualTags": [
        "line",
        "document",
        "seal",
        "question-badge",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "intake-confirmation",
        "terms-section",
        "review-card"
      ],
      "rawBestSectionUse": "FAQ-row, intake-confirmation, terms-section, review-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-engagement\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, native-intake, paid-routing, client-briefing\" data-jsi-category=\"faq-engagement\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "12-js-faq-vnext-icon-engagement-sealed-12",
        "balanced",
        "black-stroke",
        "case-intake",
        "client-briefing",
        "confirmation",
        "container-risk",
        "document",
        "documents",
        "double-frame-risk",
        "engagement-sealed",
        "engagement-terms",
        "excellent",
        "faq-engagement",
        "faq-engagement-sealed-12",
        "faq-row",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-engagement-document",
        "formal-acceptance",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "line",
        "morphology-circle",
        "native-intake",
        "outline-light",
        "paid-review",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "question-badge",
        "quiet",
        "recommended-free-only",
        "review-card",
        "review-intelligence",
        "seal",
        "sealed-request",
        "suitability-check",
        "terms-section",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0184",
      "sequence": 184,
      "filename": "18-js-faq-vnext-icon-structure-layer-stack-18.svg",
      "handle": "18-js-faq-vnext-icon-structure-layer-stack-18",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/18-js-faq-vnext-icon-structure-layer-stack-18.svg?v=1779252647",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-structure-layered-stack",
      "rotationGroup": "faq-structure-layer-stack-18",
      "cleanLabel": "Structure Layer Stack",
      "primaryCategory": "faq-structure",
      "categoryTokens": [
        "faq-structure"
      ],
      "purposeTags": [
        "structure",
        "layers",
        "service-architecture",
        "staged-process",
        "pathway-logic"
      ],
      "visualTags": [
        "line",
        "layered-stack",
        "modular",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "structure-section",
        "process-step",
        "service-card"
      ],
      "rawBestSectionUse": "FAQ-row, structure-section, process-step, service-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-structure\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing\" data-jsi-category=\"faq-structure\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "18-js-faq-vnext-icon-structure-layer-stack-18",
        "balanced",
        "black-stroke",
        "client-briefing",
        "container-eligible",
        "excellent",
        "faq-row",
        "faq-structure",
        "faq-structure-layer-stack-18",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-structure-layered-stack",
        "good-with-ivory-plate-or-css-filter",
        "layered-stack",
        "layers",
        "line",
        "medium",
        "modular",
        "morphology-none",
        "native-intake",
        "native-intake-system",
        "no-double-frame-risk",
        "outline-medium",
        "paid-routing",
        "pathway-logic",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "service-architecture",
        "service-card",
        "staged-process",
        "structure",
        "structure-layer-stack",
        "structure-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0185",
      "sequence": 185,
      "filename": "16-js-faq-vnext-icon-discretion-shield-16.svg",
      "handle": "16-js-faq-vnext-icon-discretion-shield-16",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/16-js-faq-vnext-icon-discretion-shield-16.svg?v=1779252646",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-discretion-shield",
      "rotationGroup": "faq-discretion-shield-16",
      "cleanLabel": "Discretion Shield",
      "primaryCategory": "faq-discretion",
      "categoryTokens": [
        "faq-discretion"
      ],
      "purposeTags": [
        "discretion",
        "privacy",
        "sensitive-matters",
        "confidentiality",
        "protection"
      ],
      "visualTags": [
        "line",
        "shield",
        "keyhole",
        "privacy",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "trust-card",
        "privacy-section",
        "boundary-note"
      ],
      "rawBestSectionUse": "FAQ-row, trust-card, privacy-section, boundary-note",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-discretion\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing\" data-jsi-category=\"faq-discretion\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "16-js-faq-vnext-icon-discretion-shield-16",
        "balanced",
        "black-stroke",
        "boundary-note",
        "confidentiality",
        "container-eligible",
        "discretion",
        "discretion-shield",
        "excellent",
        "faq-discretion",
        "faq-discretion-shield-16",
        "faq-row",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-discretion-shield",
        "good-with-ivory-plate-or-css-filter",
        "keyhole",
        "line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "privacy",
        "privacy-routing",
        "privacy-section",
        "protection",
        "quiet",
        "recommended-boxed-or-free",
        "sensitive-discreet-routing",
        "sensitive-matters",
        "shield",
        "thin-to-medium",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0186",
      "sequence": 186,
      "filename": "09-js-faq-vnext-icon-general-scroll-question-09.svg",
      "handle": "09-js-faq-vnext-icon-general-scroll-question-09",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/09-js-faq-vnext-icon-general-scroll-question-09.svg?v=1779252646",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-general-scroll",
      "rotationGroup": "faq-general-scroll-question-09",
      "cleanLabel": "General Scroll Question",
      "primaryCategory": "faq-general",
      "categoryTokens": [
        "faq-general"
      ],
      "purposeTags": [
        "general-questions",
        "faq",
        "scroll",
        "explanation",
        "client-question"
      ],
      "visualTags": [
        "line",
        "scroll",
        "question-badge",
        "document",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "explainer-card",
        "guidance-section",
        "support-note"
      ],
      "rawBestSectionUse": "FAQ-row, explainer-card, guidance-section, support-note",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "native-intake",
        "paid-routing",
        "client-briefing",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-general\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"native-intake, paid-routing, client-briefing, execution-support, outcome-control, completion\" data-jsi-category=\"faq-general\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "09-js-faq-vnext-icon-general-scroll-question-09",
        "balanced",
        "black-stroke",
        "client-briefing",
        "client-question",
        "completion",
        "container-risk",
        "document",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "explainer-card",
        "explanation",
        "faq",
        "faq-general",
        "faq-general-scroll-question-09",
        "faq-row",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-general-scroll",
        "general-japansolved-system",
        "general-questions",
        "general-scroll-question",
        "good-with-ivory-plate-or-css-filter",
        "guidance-section",
        "line",
        "morphology-circle",
        "native-intake",
        "outcome-control",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "question-badge",
        "quiet",
        "recommended-free-only",
        "scroll",
        "support-note",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0187",
      "sequence": 187,
      "filename": "17-js-faq-vnext-icon-integrity-vertical-seal-17.svg",
      "handle": "17-js-faq-vnext-icon-integrity-vertical-seal-17",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/17-js-faq-vnext-icon-integrity-vertical-seal-17.svg?v=1779252646",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-integrity-vertical-seal",
      "rotationGroup": "faq-integrity-vertical-seal-17",
      "cleanLabel": "Integrity Vertical Seal",
      "primaryCategory": "faq-integrity",
      "categoryTokens": [
        "faq-integrity"
      ],
      "purposeTags": [
        "integrity",
        "seal",
        "standard",
        "trust",
        "formal-review",
        "principled-handling"
      ],
      "visualTags": [
        "line",
        "vertical-seal",
        "authority-mark",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "trust-card",
        "policy-section",
        "intake-confirmation"
      ],
      "rawBestSectionUse": "FAQ-row, trust-card, policy-section, intake-confirmation",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "paid-review",
        "case-intake",
        "suitability-check",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-integrity\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"paid-review, case-intake, suitability-check, native-intake, paid-routing, client-briefing\" data-jsi-category=\"faq-integrity\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "17-js-faq-vnext-icon-integrity-vertical-seal-17",
        "authority-mark",
        "balanced",
        "black-stroke",
        "case-intake",
        "client-briefing",
        "container-risk",
        "double-frame-risk",
        "excellent",
        "faq-integrity",
        "faq-integrity-vertical-seal-17",
        "faq-row",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-integrity-vertical-seal",
        "formal-review",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "integrity",
        "integrity-vertical-seal",
        "line",
        "morphology-circle",
        "native-intake",
        "outline-light",
        "paid-review",
        "paid-routing",
        "policy-section",
        "premium-monoline",
        "primary-default",
        "principled-handling",
        "quiet",
        "recommended-free-only",
        "review-intelligence",
        "seal",
        "standard",
        "suitability-check",
        "thin-to-medium",
        "trust",
        "trust-card",
        "vertical-seal"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0188",
      "sequence": 188,
      "filename": "14-js-faq-vnext-icon-scope-boundary-compass-14.svg",
      "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/14-js-faq-vnext-icon-scope-boundary-compass-14.svg?v=1779252646",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-scope-compass-square",
      "rotationGroup": "faq-scope-boundary-compass-14",
      "cleanLabel": "Scope Boundary Compass",
      "primaryCategory": "faq-scope",
      "categoryTokens": [
        "faq-scope"
      ],
      "purposeTags": [
        "scope",
        "boundaries",
        "compass",
        "direction",
        "route-limits",
        "eligibility"
      ],
      "visualTags": [
        "line",
        "compass-square",
        "boundary-frame",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "boundary-note",
        "route-section",
        "scope-section"
      ],
      "rawBestSectionUse": "FAQ-row, boundary-note, route-section, scope-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-scope\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing\" data-jsi-category=\"faq-scope\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "14-js-faq-vnext-icon-scope-boundary-compass-14",
        "balanced",
        "black-stroke",
        "boundaries",
        "boundary-frame",
        "boundary-note",
        "compass",
        "compass-square",
        "container-risk",
        "direction",
        "discretion",
        "double-frame-risk",
        "eligibility",
        "excellent",
        "faq-row",
        "faq-scope",
        "faq-scope-boundary-compass-14",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-scope-compass-square",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "morphology-circle-risk",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "recommended-free-only",
        "route-limits",
        "route-section",
        "scope",
        "scope-boundary-compass",
        "scope-section",
        "sensitive-discreet-routing",
        "trust-protection"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0189",
      "sequence": 189,
      "filename": "13-js-faq-vnext-icon-privacy-shield-keyhole-13.svg",
      "handle": "13-js-faq-vnext-icon-privacy-shield-keyhole-13",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/13-js-faq-vnext-icon-privacy-shield-keyhole-13.svg?v=1779252646",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-privacy-shield",
      "rotationGroup": "faq-privacy-shield-keyhole-13",
      "cleanLabel": "Privacy Shield Keyhole",
      "primaryCategory": "faq-privacy",
      "categoryTokens": [
        "faq-privacy"
      ],
      "purposeTags": [
        "privacy",
        "sensitive-data",
        "confidentiality",
        "lawful-handling",
        "trust"
      ],
      "visualTags": [
        "line",
        "shield",
        "keyhole",
        "privacy",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "privacy-section",
        "trust-card",
        "intake-confirmation"
      ],
      "rawBestSectionUse": "FAQ-row, privacy-section, trust-card, intake-confirmation",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-privacy\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"faq-privacy\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "13-js-faq-vnext-icon-privacy-shield-keyhole-13",
        "balanced",
        "black-stroke",
        "client-briefing",
        "confidentiality",
        "container-eligible",
        "discretion",
        "excellent",
        "faq-privacy",
        "faq-privacy-shield-keyhole-13",
        "faq-row",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-privacy-shield",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "keyhole",
        "lawful-handling",
        "line",
        "morphology-none",
        "native-intake",
        "no-double-frame-risk",
        "outline-light",
        "paid-routing",
        "premium-monoline",
        "primary-default",
        "privacy",
        "privacy-routing",
        "privacy-section",
        "privacy-shield-keyhole",
        "quiet",
        "recommended-boxed-or-free",
        "sensitive-data",
        "sensitive-discreet-routing",
        "shield",
        "thin-to-medium",
        "trust",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0190",
      "sequence": 190,
      "filename": "15-js-faq-vnext-icon-side-question-seal-15.svg",
      "handle": "15-js-faq-vnext-icon-side-question-seal-15",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/15-js-faq-vnext-icon-side-question-seal-15.svg?v=1779252646",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-question-speech-bubble",
      "rotationGroup": "faq-side-question-seal-15",
      "cleanLabel": "Side Question Seal",
      "primaryCategory": "faq-question",
      "categoryTokens": [
        "faq-question"
      ],
      "purposeTags": [
        "side-question",
        "extra-faq",
        "support-question",
        "clarification",
        "help"
      ],
      "visualTags": [
        "line",
        "speech-bubble",
        "question-mark",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "support-note",
        "explainer-card",
        "help-section"
      ],
      "rawBestSectionUse": "FAQ-row, support-note, explainer-card, help-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 62.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-question\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"faq-question\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "15-js-faq-vnext-icon-side-question-seal-15",
        "balanced",
        "black-stroke",
        "clarification",
        "completion",
        "container-risk",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "explainer-card",
        "extra-faq",
        "faq-question",
        "faq-row",
        "faq-side-question-seal-15",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-question-speech-bubble",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "help",
        "help-section",
        "line",
        "morphology-circle",
        "outcome-control",
        "outline-light",
        "premium-monoline",
        "primary-default",
        "question-mark",
        "quiet",
        "recommended-free-only",
        "side-question",
        "side-question-seal",
        "speech-bubble",
        "support-note",
        "support-question",
        "thin-to-medium"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0191",
      "sequence": 191,
      "filename": "19-js-faq-vnext-icon-results-target-dot-19.svg",
      "handle": "19-js-faq-vnext-icon-results-target-dot-19",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/19-js-faq-vnext-icon-results-target-dot-19.svg?v=1779252647",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-results-target",
      "rotationGroup": "faq-results-target-dot-19",
      "cleanLabel": "Results Target Dot",
      "primaryCategory": "faq-results",
      "categoryTokens": [
        "faq-results"
      ],
      "purposeTags": [
        "results",
        "target",
        "outcomes",
        "precision",
        "execution-clarity"
      ],
      "visualTags": [
        "line",
        "target",
        "dot",
        "crosshair",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "results-section",
        "process-step",
        "trust-card"
      ],
      "rawBestSectionUse": "FAQ-row, results-section, process-step, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-results\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"faq-results\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "19-js-faq-vnext-icon-results-target-dot-19",
        "balanced",
        "black-stroke",
        "completion",
        "container-eligible",
        "crosshair",
        "dot",
        "excellent",
        "execution-clarity",
        "execution-support",
        "faq-results",
        "faq-results-target-dot-19",
        "faq-row",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-results-target",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outcome-control",
        "outcomes",
        "outline-medium",
        "precision",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "results",
        "results-section",
        "results-target-dot",
        "target",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0192",
      "sequence": 192,
      "filename": "20-js-faq-vnext-icon-doctrine-review-structure-activation-20.svg",
      "handle": "20-js-faq-vnext-icon-doctrine-review-structure-activation-20",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/20-js-faq-vnext-icon-doctrine-review-structure-activation-20.svg?v=1779252857",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-activation-node-path",
      "rotationGroup": "faq-decision-structure-activation-20",
      "cleanLabel": "Decision Structure Activation",
      "primaryCategory": "faq-activation",
      "categoryTokens": [
        "faq-activation"
      ],
      "purposeTags": [
        "decision-structure",
        "activation",
        "sequence",
        "process-trigger",
        "route-start"
      ],
      "visualTags": [
        "line",
        "node-path",
        "structure",
        "activation",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "process-step",
        "structure-section",
        "route-section"
      ],
      "rawBestSectionUse": "FAQ-row, process-step, structure-section, route-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "general-service-support"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 20",
      "notes": "Harvested from screenshot 20; Shopify file type SVG. Full handle inferred from truncated display; verify from CDN URL. | Original C handle did not match URL filename; polished handle uses URL as source of truth.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-activation\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"general-service-support\" data-jsi-category=\"faq-activation\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "20-js-faq-vnext-icon-doctrine-review-structure-activation-20",
        "activation",
        "balanced",
        "black-stroke",
        "container-eligible",
        "decision-structure",
        "decision-structure-activation",
        "excellent",
        "faq-activation",
        "faq-decision-structure-activation-20",
        "faq-row",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-activation-node-path",
        "general-japansolved-system",
        "general-service-support",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "node-path",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process-step",
        "process-trigger",
        "recommended-boxed-or-free",
        "route-section",
        "route-start",
        "sequence",
        "structure",
        "structure-section"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0193",
      "sequence": 193,
      "filename": "JapanSolved_Dotcom_Logo_Primary_Header_Black.svg",
      "handle": "japansolved-dotcom-logo-primary-header-black",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/JapanSolved_Dotcom_Logo_Primary_Header_Black.svg?v=1778634400",
      "assetType": "svg",
      "assetFamily": "Brand · Header / Dotcom Logos",
      "familyKey": "brand-header-dotcom-logos-brand-logo-black",
      "rotationGroup": "brand-logo-primary-header-black",
      "cleanLabel": "Dotcom Logo Primary Header Black",
      "primaryCategory": "brand-logo",
      "categoryTokens": [
        "brand-logo"
      ],
      "purposeTags": [
        "brand-identity",
        "header-logo",
        "primary-wordmark",
        "site-header"
      ],
      "visualTags": [
        "black",
        "wordmark",
        "minimal",
        "header",
        "brandmark"
      ],
      "sectionFit": [
        "header",
        "navigation",
        "hero-branding",
        "footer-branding"
      ],
      "rawBestSectionUse": "header, navigation, hero-branding, footer-branding",
      "styleFamily": [
        "brand-asset",
        "identity-system"
      ],
      "solutionPillars": [
        "brand-system",
        "identity-asset"
      ],
      "pageWingFit": [
        "brand-system"
      ],
      "fillLevel": "brand-signature",
      "visualDensity": "minimal",
      "lineWeight": "mixed",
      "intensity": "signature",
      "darkThemeFit": "plate-required",
      "lightThemeFit": "good",
      "themeTreatmentNote": "brand/logo asset: inspect on dark plate before live use",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 64.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "brand-signature-asset",
      "sourceBatch": "Screenshot 21",
      "notes": "Harvested from screenshot 21; Shopify file type SVG. Paste the matching Shopify CDN URL to verify C/D filename match.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"brand-logo\" data-jsi-section=\"header\" data-jsi-page-wing=\"brand-system\" data-jsi-pillars=\"brand-system, identity-asset\" data-jsi-category=\"brand-logo\" data-jsi-style=\"brand-asset, identity-system\" data-jsi-fill=\"brand_signature\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "black",
        "brand-asset",
        "brand-header-dotcom-logos",
        "brand-header-dotcom-logos-brand-logo-black",
        "brand-identity",
        "brand-logo",
        "brand-logo-primary-header-black",
        "brand-signature",
        "brand-signature-asset",
        "brand-system",
        "brandmark",
        "container-risk",
        "dotcom-logo-primary-header-black",
        "double-frame-risk",
        "footer-branding",
        "good",
        "header",
        "header-logo",
        "hero-branding",
        "identity-asset",
        "identity-system",
        "japansolved-dotcom-logo-primary-header-black",
        "minimal",
        "mixed",
        "morphology-brand-lockup",
        "navigation",
        "plate-required",
        "primary-wordmark",
        "recommended-brand-only-no-auto-icon",
        "signature",
        "site-header",
        "wordmark"
      ],
      "morphology": {
        "intrinsicFrame": "brand-lockup",
        "intrinsicFrameEvidence": [
          "brand/logo lockup"
        ],
        "containerEligible": false,
        "freeFloatEligible": false,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "brand-only-no-auto-icon",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "avoid-auto-icon",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": []
    },
    {
      "id": "JSICON-0194",
      "sequence": 194,
      "filename": "JapanSolved_Dotcom_Logo_Primary_Header_All_Black.svg",
      "handle": "japansolved-dotcom-logo-primary-header-all-black",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/JapanSolved_Dotcom_Logo_Primary_Header_All_Black.svg?v=1778634464",
      "assetType": "svg",
      "assetFamily": "Brand · Header / Dotcom Logos",
      "familyKey": "brand-header-dotcom-logos-brand-logo-all-black",
      "rotationGroup": "brand-logo-primary-header-all-black",
      "cleanLabel": "Dotcom Logo Primary Header All Black",
      "primaryCategory": "brand-logo",
      "categoryTokens": [
        "brand-logo"
      ],
      "purposeTags": [
        "brand-identity",
        "header-logo",
        "primary-wordmark",
        "monochrome-lockup"
      ],
      "visualTags": [
        "all-black",
        "wordmark",
        "minimal",
        "header",
        "brandmark"
      ],
      "sectionFit": [
        "header",
        "navigation",
        "hero-branding",
        "footer-branding"
      ],
      "rawBestSectionUse": "header, navigation, hero-branding, footer-branding",
      "styleFamily": [
        "brand-asset",
        "identity-system"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "brand-system",
        "identity-asset"
      ],
      "pageWingFit": [
        "brand-system"
      ],
      "fillLevel": "brand-signature",
      "visualDensity": "minimal",
      "lineWeight": "mixed",
      "intensity": "signature",
      "darkThemeFit": "plate-required",
      "lightThemeFit": "good",
      "themeTreatmentNote": "brand/logo asset: inspect on dark plate before live use",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 64.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "brand-signature-asset",
      "sourceBatch": "Screenshot 21",
      "notes": "Harvested from screenshot 21; Shopify file type SVG. Handle inferred from Shopify truncated display; paste the matching Shopify CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"brand-logo\" data-jsi-section=\"header\" data-jsi-page-wing=\"brand-system\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, brand-system, identity-asset\" data-jsi-category=\"brand-logo\" data-jsi-style=\"brand-asset, identity-system\" data-jsi-fill=\"brand_signature\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "all-black",
        "brand-asset",
        "brand-header-dotcom-logos",
        "brand-header-dotcom-logos-brand-logo-all-black",
        "brand-identity",
        "brand-logo",
        "brand-logo-primary-header-all-black",
        "brand-signature",
        "brand-signature-asset",
        "brand-system",
        "brandmark",
        "container-risk",
        "discretion",
        "dotcom-logo-primary-header-all-black",
        "double-frame-risk",
        "footer-branding",
        "good",
        "header",
        "header-logo",
        "hero-branding",
        "identity-asset",
        "identity-system",
        "japansolved-dotcom-logo-primary-header-all-black",
        "minimal",
        "mixed",
        "monochrome-lockup",
        "morphology-brand-lockup",
        "navigation",
        "plate-required",
        "primary-wordmark",
        "privacy-routing",
        "recommended-brand-only-no-auto-icon",
        "signature",
        "trust-protection",
        "wordmark"
      ],
      "morphology": {
        "intrinsicFrame": "brand-lockup",
        "intrinsicFrameEvidence": [
          "brand/logo lockup"
        ],
        "containerEligible": false,
        "freeFloatEligible": false,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "brand-only-no-auto-icon",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "avoid-auto-icon",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": []
    },
    {
      "id": "JSICON-0195",
      "sequence": 195,
      "filename": "japansolved-logo-square-compact-wordmark-black-gold-transparent.webp",
      "handle": "japansolved-logo-square-compact-wordmark-black-gold-transparent",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/japansolved-logo-square-compact-wordmark-black-gold-transparent.webp?v=1778635066",
      "assetType": "webp",
      "assetFamily": "Brand · Core Logo Assets",
      "familyKey": "brand-core-logo-assets-brand-logo-black",
      "rotationGroup": "brand-logo-square-black-gold-transparent",
      "cleanLabel": "Logo Square Black Gold Transparent",
      "primaryCategory": "brand-logo",
      "categoryTokens": [
        "brand-logo"
      ],
      "purposeTags": [
        "brand-identity",
        "square-logo",
        "avatar",
        "social-tile",
        "badge"
      ],
      "visualTags": [
        "black",
        "gold",
        "square",
        "transparent-background",
        "logo-tile"
      ],
      "sectionFit": [
        "footer",
        "favicon-like-use",
        "social-tile",
        "watermark",
        "profile-badge"
      ],
      "rawBestSectionUse": "footer, favicon-like use, social tile, watermark, profile badge",
      "styleFamily": [
        "brand-asset",
        "identity-system"
      ],
      "solutionPillars": [
        "asset-intelligence",
        "capital-review",
        "risk-screening",
        "brand-system",
        "identity-asset"
      ],
      "pageWingFit": [
        "brand-system"
      ],
      "fillLevel": "brand-signature",
      "visualDensity": "brand-surface",
      "lineWeight": "mixed",
      "intensity": "medium",
      "darkThemeFit": "plate-required",
      "lightThemeFit": "good",
      "themeTreatmentNote": "brand/logo asset: inspect on dark plate before live use",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · URL resolved full filename",
      "errorFlag": "OK · resolved from CDN URL",
      "defaultPriorityScore": 48.0,
      "familyCategoryRank": 3,
      "categoryRank": 6,
      "designFamilyRank": 1,
      "variantRole": "brand-signature-asset",
      "sourceBatch": "Screenshot 21",
      "notes": "Harvested from screenshot 21; Shopify file type WEBP. Handle inferred from Shopify truncated display; paste the matching Shopify CDN URL to verify exact filename and non-SVG asset details.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"brand-logo\" data-jsi-section=\"footer\" data-jsi-page-wing=\"brand-system\" data-jsi-pillars=\"asset-intelligence, capital-review, risk-screening, brand-system, identity-asset\" data-jsi-category=\"brand-logo\" data-jsi-style=\"brand-asset, identity-system\" data-jsi-fill=\"brand_signature\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "asset-intelligence",
        "avatar",
        "badge",
        "black",
        "brand-asset",
        "brand-core-logo-assets",
        "brand-core-logo-assets-brand-logo-black",
        "brand-identity",
        "brand-logo",
        "brand-logo-square-black-gold-transparent",
        "brand-signature",
        "brand-signature-asset",
        "brand-surface",
        "brand-system",
        "capital-review",
        "container-risk",
        "double-frame-risk",
        "favicon-like-use",
        "footer",
        "gold",
        "good",
        "identity-asset",
        "identity-system",
        "japansolved-logo-square-compact-wordmark-black-gold-transparent",
        "logo-square-black-gold-transparent",
        "logo-tile",
        "medium",
        "mixed",
        "morphology-circle",
        "plate-required",
        "profile-badge",
        "recommended-free-only",
        "risk-screening",
        "social-tile",
        "square",
        "square-logo",
        "transparent-background",
        "watermark"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0196",
      "sequence": 196,
      "filename": "Elegant_JapanSolved_branding_logo_design.png",
      "handle": "elegant-japansolved-branding-logo-design",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/Elegant_JapanSolved_branding_logo_design.png?v=1778842878",
      "assetType": "png",
      "assetFamily": "Brand · Core Logo Assets",
      "familyKey": "brand-core-logo-assets-brand-logo-elegant",
      "rotationGroup": "brand-logo-elegant-design",
      "cleanLabel": "Elegant Branding Logo Design",
      "primaryCategory": "brand-logo",
      "categoryTokens": [
        "brand-logo"
      ],
      "purposeTags": [
        "brand-identity",
        "logo-concept",
        "elegant-mark",
        "branding-asset",
        "visual-identity"
      ],
      "visualTags": [
        "logo",
        "elegant",
        "light",
        "minimal",
        "brandmark",
        "png"
      ],
      "sectionFit": [
        "brand-library",
        "design-reference",
        "logo-reference",
        "visual-identity"
      ],
      "rawBestSectionUse": "brand-library, design-reference, logo-reference, visual-identity",
      "styleFamily": [
        "brand-asset",
        "identity-system"
      ],
      "solutionPillars": [
        "asset-intelligence",
        "capital-review",
        "risk-screening",
        "brand-system",
        "identity-asset"
      ],
      "pageWingFit": [
        "brand-system"
      ],
      "fillLevel": "brand-signature",
      "visualDensity": "minimal",
      "lineWeight": "mixed",
      "intensity": "signature",
      "darkThemeFit": "plate-required",
      "lightThemeFit": "good",
      "themeTreatmentNote": "brand/logo asset: inspect on dark plate before live use",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 58.0,
      "familyCategoryRank": 1,
      "categoryRank": 3,
      "designFamilyRank": 1,
      "variantRole": "brand-signature-asset",
      "sourceBatch": "Screenshot 22",
      "notes": "Harvested from screenshot 22; Shopify file type PNG. Paste the matching Shopify CDN URL to verify C/D filename match and preserve the exact PNG asset path.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"brand-logo\" data-jsi-section=\"brand-library\" data-jsi-page-wing=\"brand-system\" data-jsi-pillars=\"asset-intelligence, capital-review, risk-screening, brand-system, identity-asset\" data-jsi-category=\"brand-logo\" data-jsi-style=\"brand-asset, identity-system\" data-jsi-fill=\"brand_signature\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "asset-intelligence",
        "brand-asset",
        "brand-core-logo-assets",
        "brand-core-logo-assets-brand-logo-elegant",
        "brand-identity",
        "brand-library",
        "brand-logo",
        "brand-logo-elegant-design",
        "brand-signature",
        "brand-signature-asset",
        "brand-system",
        "branding-asset",
        "brandmark",
        "capital-review",
        "container-risk",
        "design-reference",
        "double-frame-risk",
        "elegant",
        "elegant-branding-logo-design",
        "elegant-japansolved-branding-logo-design",
        "elegant-mark",
        "good",
        "identity-asset",
        "identity-system",
        "light",
        "logo",
        "logo-concept",
        "logo-reference",
        "minimal",
        "mixed",
        "morphology-brand-lockup",
        "plate-required",
        "png",
        "recommended-brand-only-no-auto-icon",
        "risk-screening",
        "signature",
        "visual-identity"
      ],
      "morphology": {
        "intrinsicFrame": "brand-lockup",
        "intrinsicFrameEvidence": [
          "brand/logo lockup"
        ],
        "containerEligible": false,
        "freeFloatEligible": false,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "brand-only-no-auto-icon",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "avoid-auto-icon",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": []
    },
    {
      "id": "JSICON-0197",
      "sequence": 197,
      "filename": "01-js-solutions-vnext-icon-capability-architecture-mono-line-01.svg",
      "handle": "01-js-solutions-vnext-icon-capability-architecture-mono-line-01",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/01-js-solutions-vnext-icon-capability-architecture-mono-line-01.svg?v=1779783927",
      "assetType": "svg",
      "assetFamily": "Solutions vNext Mono-Line Icons",
      "familyKey": "solutions-vnext-mono-line-icons-solutions-architecture-compass-star",
      "rotationGroup": "solutions-architecture-mono-line-01",
      "cleanLabel": "Solutions Architecture Mono Line",
      "primaryCategory": "solutions-architecture",
      "categoryTokens": [
        "solutions-architecture"
      ],
      "purposeTags": [
        "architecture",
        "structured-expansion",
        "planning",
        "systems-frame",
        "service-architecture"
      ],
      "visualTags": [
        "line",
        "compass-star",
        "mono-line",
        "black-stroke",
        "solutions-vnext"
      ],
      "sectionFit": [
        "service-card",
        "process-step",
        "solution-pillar",
        "route-section"
      ],
      "rawBestSectionUse": "service-card, process-step, solution-pillar, route-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "market-entry",
        "business-routing",
        "strategy-alignment",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · URL resolved full filename",
      "errorFlag": "OK · resolved from CDN URL",
      "defaultPriorityScore": 53.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"solutions-architecture\" data-jsi-section=\"service-card\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"market-entry, business-routing, strategy-alignment, route-intelligence, coordination, strategy\" data-jsi-category=\"solutions-architecture\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "01-js-solutions-vnext-icon-capability-architecture-mono-line-01",
        "architecture",
        "balanced",
        "black-stroke",
        "business-routing",
        "compass-star",
        "container-risk",
        "coordination",
        "double-frame-risk",
        "excellent",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "market-entry",
        "medium",
        "mono-line",
        "morphology-circle-risk",
        "outline-medium",
        "planning",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-free-only",
        "route-intelligence",
        "route-section",
        "service-architecture",
        "service-card",
        "solution-pillar",
        "solutions-architecture",
        "solutions-architecture-mono-line",
        "solutions-architecture-mono-line-01",
        "solutions-vnext",
        "solutions-vnext-mono-line-icons",
        "solutions-vnext-mono-line-icons-solutions-architecture-compass-star",
        "strategy",
        "strategy-alignment",
        "structured-expansion",
        "systems-frame"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0198",
      "sequence": 198,
      "filename": "02-js-solutions-vnext-icon-business-market-entry-mono-line-02.svg",
      "handle": "02-js-solutions-vnext-icon-business-market-entry-mono-line-02",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/02-js-solutions-vnext-icon-business-market-entry-mono-line-02.svg?v=1779783929",
      "assetType": "svg",
      "assetFamily": "Solutions vNext Mono-Line Icons",
      "familyKey": "solutions-vnext-mono-line-icons-market-entry-torii-gateway",
      "rotationGroup": "solutions-market-entry-mono-line-02",
      "cleanLabel": "Market Entry Mono Line",
      "primaryCategory": "market-entry",
      "categoryTokens": [
        "market-entry"
      ],
      "purposeTags": [
        "business-market-entry",
        "japan-entry",
        "route-opening",
        "expansion"
      ],
      "visualTags": [
        "line",
        "torii-gateway",
        "mono-line",
        "black-stroke",
        "solutions-vnext"
      ],
      "sectionFit": [
        "service-card",
        "process-step",
        "market-entry-section",
        "solution-pillar"
      ],
      "rawBestSectionUse": "service-card, process-step, market-entry-section, solution-pillar",
      "styleFamily": [
        "premium-monoline",
        "japan-cultural-symbol"
      ],
      "solutionPillars": [
        "market-entry",
        "business-routing",
        "strategy-alignment",
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "business-market-entry"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · URL resolved full filename",
      "errorFlag": "OK · resolved from CDN URL",
      "defaultPriorityScore": 53.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"market-entry\" data-jsi-section=\"service-card\" data-jsi-page-wing=\"business-market-entry\" data-jsi-pillars=\"market-entry, business-routing, strategy-alignment, cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"market-entry\" data-jsi-style=\"premium-monoline, japan-cultural-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "02-js-solutions-vnext-icon-business-market-entry-mono-line-02",
        "access-coordination",
        "balanced",
        "black-stroke",
        "business-market-entry",
        "business-routing",
        "concierge-presence",
        "container-eligible",
        "cultural-navigation",
        "excellent",
        "expansion",
        "good-with-ivory-plate-or-css-filter",
        "japan-cultural-symbol",
        "japan-entry",
        "line",
        "market-entry",
        "market-entry-mono-line",
        "market-entry-section",
        "medium",
        "mono-line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "route-opening",
        "service-card",
        "solution-pillar",
        "solutions-market-entry-mono-line-02",
        "solutions-vnext",
        "solutions-vnext-mono-line-icons",
        "solutions-vnext-mono-line-icons-market-entry-torii-gateway",
        "strategy-alignment",
        "torii-gateway"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0199",
      "sequence": 199,
      "filename": "03-js-solutions-vnext-icon-investment-capital-mono-line-03.svg",
      "handle": "03-js-solutions-vnext-icon-investment-capital-mono-line-03",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/03-js-solutions-vnext-icon-investment-capital-mono-line-03.svg?v=1779783931",
      "assetType": "svg",
      "assetFamily": "Solutions vNext Mono-Line Icons",
      "familyKey": "solutions-vnext-mono-line-icons-investment-capital-nodes",
      "rotationGroup": "solutions-investment-capital-mono-line-03",
      "cleanLabel": "Investment Capital Mono Line",
      "primaryCategory": "investment-capital",
      "categoryTokens": [
        "investment-capital"
      ],
      "purposeTags": [
        "investment",
        "capital",
        "capital-flow",
        "coordination",
        "finance-route"
      ],
      "visualTags": [
        "line",
        "nodes",
        "capital-network",
        "mono-line",
        "black-stroke"
      ],
      "sectionFit": [
        "service-card",
        "investment-section",
        "process-step",
        "route-section"
      ],
      "rawBestSectionUse": "service-card, investment-section, process-step, route-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "asset-intelligence",
        "capital-review",
        "risk-screening",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "asset-capital-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"investment-capital\" data-jsi-section=\"service-card\" data-jsi-page-wing=\"asset-capital-intelligence\" data-jsi-pillars=\"asset-intelligence, capital-review, risk-screening, route-intelligence, coordination, strategy\" data-jsi-category=\"investment-capital\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "03-js-solutions-vnext-icon-investment-capital-mono-line-03",
        "asset-capital-intelligence",
        "asset-intelligence",
        "balanced",
        "black-stroke",
        "capital",
        "capital-flow",
        "capital-network",
        "capital-review",
        "container-eligible",
        "coordination",
        "excellent",
        "finance-route",
        "good-with-ivory-plate-or-css-filter",
        "investment",
        "investment-capital",
        "investment-capital-mono-line",
        "investment-section",
        "line",
        "medium",
        "mono-line",
        "morphology-none",
        "no-double-frame-risk",
        "nodes",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "risk-screening",
        "route-intelligence",
        "route-section",
        "service-card",
        "solutions-investment-capital-mono-line-03",
        "solutions-vnext-mono-line-icons",
        "solutions-vnext-mono-line-icons-investment-capital-nodes",
        "strategy"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0200",
      "sequence": 200,
      "filename": "04-js-solutions-vnext-icon-property-relocation-mono-line-04.svg",
      "handle": "04-js-solutions-vnext-icon-property-relocation-mono-line-04",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/04-js-solutions-vnext-icon-property-relocation-mono-line-04.svg?v=1779783935",
      "assetType": "svg",
      "assetFamily": "Solutions vNext Mono-Line Icons",
      "familyKey": "solutions-vnext-mono-line-icons-property-relocation-house",
      "rotationGroup": "solutions-property-relocation-mono-line-04",
      "cleanLabel": "Property Relocation Mono Line",
      "primaryCategory": "property-relocation",
      "categoryTokens": [
        "property-relocation"
      ],
      "purposeTags": [
        "property-relocation",
        "home-search",
        "settling",
        "overseas-transition"
      ],
      "visualTags": [
        "line",
        "house",
        "location-pin",
        "mono-line",
        "black-stroke"
      ],
      "sectionFit": [
        "service-card",
        "relocation-section",
        "process-step",
        "route-section"
      ],
      "rawBestSectionUse": "service-card, relocation-section, process-step, route-section",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "relocation-support",
        "local-setup",
        "property-routing"
      ],
      "pageWingFit": [
        "property-relocation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 4,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"property-relocation\" data-jsi-section=\"service-card\" data-jsi-page-wing=\"property-relocation\" data-jsi-pillars=\"relocation-support, local-setup, property-routing\" data-jsi-category=\"property-relocation\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "04-js-solutions-vnext-icon-property-relocation-mono-line-04",
        "balanced",
        "black-stroke",
        "container-eligible",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "home-search",
        "house",
        "line",
        "local-setup",
        "location-pin",
        "medium",
        "mono-line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "overseas-transition",
        "premium-monoline",
        "primary-default",
        "process-step",
        "property-relocation",
        "property-relocation-mono-line",
        "property-routing",
        "recommended-boxed-or-free",
        "relocation-section",
        "relocation-support",
        "route-section",
        "service-card",
        "settling",
        "solutions-property-relocation-mono-line-04",
        "solutions-vnext-mono-line-icons",
        "solutions-vnext-mono-line-icons-property-relocation-house"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0201",
      "sequence": 201,
      "filename": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05.svg",
      "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/05-js-solutions-vnext-icon-sourcing-export-mono-line-05.svg?v=1779783941",
      "assetType": "svg",
      "assetFamily": "Solutions vNext Mono-Line Icons",
      "familyKey": "solutions-vnext-mono-line-icons-sourcing-export-package",
      "rotationGroup": "solutions-sourcing-export-mono-line-05",
      "cleanLabel": "Sourcing Export Mono Line",
      "primaryCategory": "sourcing-export",
      "categoryTokens": [
        "sourcing-export"
      ],
      "purposeTags": [
        "sourcing",
        "procurement",
        "export",
        "goods-movement",
        "supplier-route"
      ],
      "visualTags": [
        "line",
        "package",
        "export",
        "globe",
        "mono-line",
        "black-stroke"
      ],
      "sectionFit": [
        "service-card",
        "sourcing-section",
        "logistics-section",
        "process-step"
      ],
      "rawBestSectionUse": "service-card, sourcing-section, logistics-section, process-step",
      "styleFamily": [
        "premium-monoline",
        "operations-symbol"
      ],
      "solutionPillars": [
        "cargo-execution",
        "local-representation",
        "handoff-control",
        "sourcing",
        "private-buyer",
        "procurement-routing"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 63.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"sourcing-export\" data-jsi-section=\"service-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"cargo-execution, local-representation, handoff-control, sourcing, private-buyer, procurement-routing\" data-jsi-category=\"sourcing-export\" data-jsi-style=\"premium-monoline, operations-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
        "balanced",
        "black-stroke",
        "cargo-execution",
        "container-eligible",
        "excellent",
        "export",
        "globe",
        "good-with-ivory-plate-or-css-filter",
        "goods-movement",
        "handoff-control",
        "line",
        "local-representation",
        "logistics-local-representation",
        "logistics-section",
        "medium",
        "mono-line",
        "morphology-none",
        "no-double-frame-risk",
        "object-cube-package",
        "operations-symbol",
        "outline-medium",
        "package",
        "premium-monoline",
        "primary-default",
        "private-buyer",
        "process-step",
        "procurement",
        "procurement-routing",
        "recommended-boxed-or-free",
        "service-card",
        "solutions-sourcing-export-mono-line-05",
        "solutions-vnext-mono-line-icons",
        "solutions-vnext-mono-line-icons-sourcing-export-package",
        "sourcing",
        "sourcing-export",
        "sourcing-export-mono-line",
        "sourcing-section",
        "supplier-route"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [
          "cube/package object; not a frame, but low-fit in premium boxed UI unless exact"
        ],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "cube/package",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0202",
      "sequence": 202,
      "filename": "06-js-solutions-vnext-icon-logistics-representation-mono-line-06.svg",
      "handle": "06-js-solutions-vnext-icon-logistics-representation-mono-line-06",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/06-js-solutions-vnext-icon-logistics-representation-mono-line-06.svg?v=1779783942",
      "assetType": "svg",
      "assetFamily": "Solutions vNext Mono-Line Icons",
      "familyKey": "solutions-vnext-mono-line-icons-local-representation-route-scroll",
      "rotationGroup": "solutions-representation-mono-line-06",
      "cleanLabel": "Representation Mono Line",
      "primaryCategory": "local-representation",
      "categoryTokens": [
        "local-representation"
      ],
      "purposeTags": [
        "representation",
        "local-proxy",
        "japan-side-presence",
        "delegated-handling"
      ],
      "visualTags": [
        "line",
        "route-scroll",
        "representation",
        "mono-line",
        "black-stroke"
      ],
      "sectionFit": [
        "service-card",
        "representation-section",
        "trust-card",
        "process-step"
      ],
      "rawBestSectionUse": "service-card, representation-section, trust-card, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "logistics-local-representation"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · URL resolved full filename",
      "errorFlag": "OK · resolved from CDN URL",
      "defaultPriorityScore": 53.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"local-representation\" data-jsi-section=\"service-card\" data-jsi-page-wing=\"logistics-local-representation\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"local-representation\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "06-js-solutions-vnext-icon-logistics-representation-mono-line-06",
        "access-coordination",
        "balanced",
        "black-stroke",
        "concierge-presence",
        "container-eligible",
        "cultural-navigation",
        "delegated-handling",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "japan-side-presence",
        "line",
        "local-proxy",
        "local-representation",
        "logistics-local-representation",
        "medium",
        "mono-line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "representation",
        "representation-mono-line",
        "representation-section",
        "route-scroll",
        "service-card",
        "solutions-representation-mono-line-06",
        "solutions-vnext-mono-line-icons",
        "solutions-vnext-mono-line-icons-local-representation-route-scroll",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0203",
      "sequence": 203,
      "filename": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07.svg",
      "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07.svg?v=1779783951",
      "assetType": "svg",
      "assetFamily": "Solutions vNext Mono-Line Icons",
      "familyKey": "solutions-vnext-mono-line-icons-cultural-access-compass",
      "rotationGroup": "solutions-cultural-access-mono-line-07",
      "cleanLabel": "Cultural Access Mono Line",
      "primaryCategory": "cultural-access",
      "categoryTokens": [
        "cultural-access"
      ],
      "purposeTags": [
        "cultural-access",
        "private-access",
        "curated-gateway",
        "travel-route"
      ],
      "visualTags": [
        "line",
        "compass",
        "lantern-gateway",
        "mono-line",
        "black-stroke"
      ],
      "sectionFit": [
        "service-card",
        "travel-section",
        "access-section",
        "process-step"
      ],
      "rawBestSectionUse": "service-card, travel-section, access-section, process-step",
      "styleFamily": [
        "premium-monoline",
        "japan-cultural-symbol"
      ],
      "solutionPillars": [
        "cultural-navigation",
        "access-coordination",
        "concierge-presence"
      ],
      "pageWingFit": [
        "travel-cultural-access"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · URL resolved full filename",
      "errorFlag": "OK · resolved from CDN URL",
      "defaultPriorityScore": 53.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"cultural-access\" data-jsi-section=\"service-card\" data-jsi-page-wing=\"travel-cultural-access\" data-jsi-pillars=\"cultural-navigation, access-coordination, concierge-presence\" data-jsi-category=\"cultural-access\" data-jsi-style=\"premium-monoline, japan-cultural-symbol\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
        "access-coordination",
        "access-section",
        "balanced",
        "black-stroke",
        "compass",
        "concierge-presence",
        "container-risk",
        "cultural-access",
        "cultural-access-mono-line",
        "cultural-navigation",
        "curated-gateway",
        "double-frame-risk",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "japan-cultural-symbol",
        "lantern-gateway",
        "line",
        "medium",
        "mono-line",
        "morphology-circle-risk",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "private-access",
        "process-step",
        "recommended-free-only",
        "service-card",
        "solutions-cultural-access-mono-line-07",
        "solutions-vnext-mono-line-icons",
        "solutions-vnext-mono-line-icons-cultural-access-compass",
        "travel-cultural-access",
        "travel-route",
        "travel-section"
      ],
      "morphology": {
        "intrinsicFrame": "circle-risk",
        "intrinsicFrameEvidence": [
          "compass/target/radar circular geometry"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0204",
      "sequence": 204,
      "filename": "08-js-solutions-vnext-icon-advisory-intelligence-mono-line-08.svg",
      "handle": "08-js-solutions-vnext-icon-advisory-intelligence-mono-line-08",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/08-js-solutions-vnext-icon-advisory-intelligence-mono-line-08.svg?v=1779783955",
      "assetType": "svg",
      "assetFamily": "Solutions vNext Mono-Line Icons",
      "familyKey": "solutions-vnext-mono-line-icons-advisory-intelligence-magnifier",
      "rotationGroup": "solutions-intelligence-mono-line-08",
      "cleanLabel": "Intelligence Mono Line",
      "primaryCategory": "advisory-intelligence",
      "categoryTokens": [
        "advisory-intelligence"
      ],
      "purposeTags": [
        "intelligence",
        "analysis",
        "advisory",
        "route-clarity",
        "investigation"
      ],
      "visualTags": [
        "line",
        "magnifier",
        "nodes",
        "mono-line",
        "black-stroke"
      ],
      "sectionFit": [
        "service-card",
        "intelligence-section",
        "trust-card",
        "process-step"
      ],
      "rawBestSectionUse": "service-card, intelligence-section, trust-card, process-step",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "intelligence",
        "review-routing",
        "due-diligence",
        "route-intelligence",
        "coordination",
        "strategy"
      ],
      "pageWingFit": [
        "review-intelligence"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · URL resolved full filename",
      "errorFlag": "OK · resolved from CDN URL",
      "defaultPriorityScore": 53.0,
      "familyCategoryRank": 1,
      "categoryRank": 16,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"advisory-intelligence\" data-jsi-section=\"service-card\" data-jsi-page-wing=\"review-intelligence\" data-jsi-pillars=\"intelligence, review-routing, due-diligence, route-intelligence, coordination, strategy\" data-jsi-category=\"advisory-intelligence\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "08-js-solutions-vnext-icon-advisory-intelligence-mono-line-08",
        "advisory",
        "advisory-intelligence",
        "analysis",
        "balanced",
        "black-stroke",
        "container-eligible",
        "coordination",
        "due-diligence",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "intelligence",
        "intelligence-mono-line",
        "intelligence-section",
        "investigation",
        "line",
        "magnifier",
        "medium",
        "mono-line",
        "morphology-none",
        "no-double-frame-risk",
        "nodes",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "process-step",
        "recommended-boxed-or-free",
        "review-intelligence",
        "review-routing",
        "route-clarity",
        "route-intelligence",
        "service-card",
        "solutions-intelligence-mono-line-08",
        "solutions-vnext-mono-line-icons",
        "solutions-vnext-mono-line-icons-advisory-intelligence-magnifier",
        "strategy",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0205",
      "sequence": 205,
      "filename": "09-js-solutions-vnext-icon-private-discreet-matters-mono-line-09.svg",
      "handle": "09-js-solutions-vnext-icon-private-discreet-matters-mono-line-09",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/09-js-solutions-vnext-icon-private-discreet-matters-mono-line-09.svg?v=1779783958",
      "assetType": "svg",
      "assetFamily": "Solutions vNext Mono-Line Icons",
      "familyKey": "solutions-vnext-mono-line-icons-sensitive-matters-shield",
      "rotationGroup": "solutions-sensitive-matters-mono-line-09",
      "cleanLabel": "Sensitive Matters Mono Line",
      "primaryCategory": "sensitive-matters",
      "categoryTokens": [
        "sensitive-matters"
      ],
      "purposeTags": [
        "sensitive-matters",
        "privacy",
        "discretion",
        "protected-handling",
        "confidential-review"
      ],
      "visualTags": [
        "line",
        "shield",
        "lock",
        "mono-line",
        "black-stroke"
      ],
      "sectionFit": [
        "service-card",
        "sensitive-section",
        "privacy-section",
        "trust-card"
      ],
      "rawBestSectionUse": "service-card, sensitive-section, privacy-section, trust-card",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "paid-review",
        "case-intake",
        "suitability-check"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · URL resolved full filename",
      "errorFlag": "OK · resolved from CDN URL",
      "defaultPriorityScore": 52.0,
      "familyCategoryRank": 1,
      "categoryRank": 2,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"sensitive-matters\" data-jsi-section=\"service-card\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, paid-review, case-intake, suitability-check\" data-jsi-category=\"sensitive-matters\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "09-js-solutions-vnext-icon-private-discreet-matters-mono-line-09",
        "balanced",
        "black-stroke",
        "case-intake",
        "confidential-review",
        "container-eligible",
        "discretion",
        "excellent",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "lock",
        "mono-line",
        "morphology-none",
        "no-double-frame-risk",
        "outline-light",
        "paid-review",
        "premium-monoline",
        "primary-default",
        "privacy",
        "privacy-routing",
        "privacy-section",
        "protected-handling",
        "quiet",
        "recommended-boxed-or-free",
        "sensitive-discreet-routing",
        "sensitive-matters",
        "sensitive-matters-mono-line",
        "sensitive-section",
        "service-card",
        "shield",
        "solutions-sensitive-matters-mono-line-09",
        "solutions-vnext-mono-line-icons",
        "solutions-vnext-mono-line-icons-sensitive-matters-shield",
        "suitability-check",
        "thin-to-medium",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0206",
      "sequence": 206,
      "filename": "22-js-faq-vnext-icon-trust-japan-based-expertise-map-pin-22.svg",
      "handle": "22-js-faq-vnext-icon-trust-japan-based-expertise-map-pin-22",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/22-js-faq-vnext-icon-trust-japan-based-expertise-map-pin-22.svg?v=1779787591",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-expertise-map-route",
      "rotationGroup": "faq-trusted-expertise-map-in-22",
      "cleanLabel": "Trusted Expertise Map In",
      "primaryCategory": "faq-expertise",
      "categoryTokens": [
        "faq-expertise"
      ],
      "purposeTags": [
        "expertise-map",
        "route-mapping",
        "guided-support",
        "trusted-knowledge"
      ],
      "visualTags": [
        "line",
        "map-route",
        "arrow",
        "expertise",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "route-note",
        "support-section",
        "trust-card"
      ],
      "rawBestSectionUse": "FAQ-row, route-note, support-section, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · URL resolved full filename",
      "errorFlag": "OK · resolved from CDN URL",
      "defaultPriorityScore": 53.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-expertise\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"faq-expertise\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "22-js-faq-vnext-icon-trust-japan-based-expertise-map-pin-22",
        "arrow",
        "balanced",
        "black-stroke",
        "completion",
        "container-eligible",
        "excellent",
        "execution-support",
        "expertise",
        "expertise-map",
        "faq-expertise",
        "faq-row",
        "faq-trusted-expertise-map-in-22",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-expertise-map-route",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "guided-support",
        "line",
        "map-route",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "recommended-boxed-or-free",
        "route-mapping",
        "route-note",
        "support-section",
        "trust-card",
        "trusted-expertise-map-in",
        "trusted-knowledge"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0207",
      "sequence": 207,
      "filename": "23-js-faq-vnext-icon-trust-results-driven-target-arrow-23.svg",
      "handle": "23-js-faq-vnext-icon-trust-results-driven-target-arrow-23",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/23-js-faq-vnext-icon-trust-results-driven-target-arrow-23.svg?v=1779787595",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-results-target",
      "rotationGroup": "faq-target-driven-target-arrow-23",
      "cleanLabel": "Target Driven Target Arrow",
      "primaryCategory": "faq-results",
      "categoryTokens": [
        "faq-results"
      ],
      "purposeTags": [
        "target-driven",
        "results",
        "precision",
        "aim",
        "execution-focus"
      ],
      "visualTags": [
        "line",
        "target",
        "arrow",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "results-section",
        "process-step",
        "trust-card"
      ],
      "rawBestSectionUse": "FAQ-row, results-section, process-step, trust-card",
      "styleFamily": [
        "premium-monoline"
      ],
      "solutionPillars": [
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "general-japansolved-system"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · URL resolved full filename",
      "errorFlag": "OK · resolved from CDN URL",
      "defaultPriorityScore": 53.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-results\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"general-japansolved-system\" data-jsi-pillars=\"execution-support, outcome-control, completion\" data-jsi-category=\"faq-results\" data-jsi-style=\"premium-monoline\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "23-js-faq-vnext-icon-trust-results-driven-target-arrow-23",
        "aim",
        "arrow",
        "balanced",
        "black-stroke",
        "completion",
        "container-eligible",
        "excellent",
        "execution-focus",
        "execution-support",
        "faq-results",
        "faq-row",
        "faq-target-driven-target-arrow-23",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-results-target",
        "general-japansolved-system",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "morphology-none",
        "no-double-frame-risk",
        "outcome-control",
        "outline-medium",
        "precision",
        "premium-monoline",
        "process-step",
        "recommended-boxed-or-free",
        "results",
        "results-section",
        "secondary-variant",
        "target",
        "target-driven",
        "target-driven-target-arrow",
        "trust-card"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0208",
      "sequence": 208,
      "filename": "24-js-faq-vnext-icon-trust-accessible-24-7-clock-support-24.svg",
      "handle": "24-js-faq-vnext-icon-trust-accessible-24-7-clock-support-24",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/24-js-faq-vnext-icon-trust-accessible-24-7-clock-support-24.svg?v=1779787598",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-support-clock",
      "rotationGroup": "faq-time-24-7-clock-support-24",
      "cleanLabel": "24/7 Clock Support",
      "primaryCategory": "faq-support",
      "categoryTokens": [
        "faq-support"
      ],
      "purposeTags": [
        "time",
        "24-7-support",
        "responsiveness",
        "availability",
        "time-sensitive"
      ],
      "visualTags": [
        "line",
        "clock",
        "circular",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "support-section",
        "availability-note",
        "trust-card"
      ],
      "rawBestSectionUse": "FAQ-row, support-section, availability-note, trust-card",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol",
        "sequence-badge"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "execution-support",
        "outcome-control",
        "completion"
      ],
      "pageWingFit": [
        "sensitive-discreet-routing"
      ],
      "fillLevel": "outline-medium",
      "visualDensity": "balanced",
      "lineWeight": "medium",
      "intensity": "medium",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "Review · duplicate URL",
      "urlAuditStatus": "OK · URL resolved full filename",
      "errorFlag": "WARNING · duplicate URL also used by order 209",
      "defaultPriorityScore": 43.0,
      "familyCategoryRank": 1,
      "categoryRank": 1,
      "designFamilyRank": 1,
      "variantRole": "primary-default",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename. | Duplicate URL audit: this CDN URL appears on more than one registry row.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-support\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"sensitive-discreet-routing\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, execution-support, outcome-control, completion\" data-jsi-category=\"faq-support\" data-jsi-style=\"premium-monoline, trust-symbol, sequence-badge\" data-jsi-fill=\"outline_medium\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "24-7-clock-support",
        "24-7-support",
        "24-js-faq-vnext-icon-trust-accessible-24-7-clock-support-24",
        "availability",
        "availability-note",
        "balanced",
        "black-stroke",
        "circular",
        "clock",
        "completion",
        "container-risk",
        "discretion",
        "double-frame-risk",
        "excellent",
        "execution-support",
        "faq-row",
        "faq-support",
        "faq-time-24-7-clock-support-24",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-support-clock",
        "good-with-ivory-plate-or-css-filter",
        "line",
        "medium",
        "morphology-circle",
        "outcome-control",
        "outline-medium",
        "premium-monoline",
        "primary-default",
        "privacy-routing",
        "recommended-free-only",
        "responsiveness",
        "sensitive-discreet-routing",
        "sequence-badge",
        "support-section",
        "time",
        "time-sensitive",
        "trust-card",
        "trust-protection",
        "trust-symbol"
      ],
      "morphology": {
        "intrinsicFrame": "circle",
        "intrinsicFrameEvidence": [
          "circle/coin/badge keyword"
        ],
        "containerEligible": false,
        "freeFloatEligible": true,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "medium",
        "recommendedTreatment": "free-only",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "free",
        "ghost",
        "left-anchor-large",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0209",
      "sequence": 209,
      "filename": "25-js-faq-vnext-icon-transparent-fees-invoice-lock-25.svg",
      "handle": "25-js-faq-vnext-icon-transparent-fees-invoice-lock-25",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/24-js-faq-vnext-icon-trust-accessible-24-7-clock-support-24.svg?v=1779787598",
      "assetType": "svg",
      "assetFamily": "FAQ vNext Icons",
      "familyKey": "faq-vnext-icons-faq-payment-invoice",
      "rotationGroup": "faq-transparent-fees-invoice-lock-25",
      "cleanLabel": "Transparent Fees Invoice Lock",
      "primaryCategory": "faq-payment",
      "categoryTokens": [
        "faq-payment"
      ],
      "purposeTags": [
        "transparent-fees",
        "invoice",
        "locked-terms",
        "payment-clarity",
        "billing"
      ],
      "visualTags": [
        "line",
        "invoice",
        "lock",
        "yen",
        "black-stroke"
      ],
      "sectionFit": [
        "faq-row",
        "payment-note",
        "intake-confirmation",
        "trust-card"
      ],
      "rawBestSectionUse": "FAQ-row, payment-note, intake-confirmation, trust-card",
      "styleFamily": [
        "premium-monoline",
        "trust-symbol"
      ],
      "solutionPillars": [
        "discretion",
        "trust-protection",
        "privacy-routing",
        "native-intake",
        "paid-routing",
        "client-briefing"
      ],
      "pageWingFit": [
        "native-intake-system"
      ],
      "fillLevel": "outline-light",
      "visualDensity": "balanced",
      "lineWeight": "thin-to-medium",
      "intensity": "quiet",
      "darkThemeFit": "good-with-ivory-plate-or-css-filter",
      "lightThemeFit": "excellent",
      "themeTreatmentNote": "black-stroke SVG: needs light plate/filter on dark mode",
      "status": "URL Paste Error",
      "urlAuditStatus": "ERROR · URL filename does not match intended icon number/name",
      "errorFlag": "ERROR · likely wrong CDN URL pasted + duplicate URL also used by order 208",
      "defaultPriorityScore": 42.0,
      "familyCategoryRank": 2,
      "categoryRank": 2,
      "designFamilyRank": 2,
      "variantRole": "secondary-variant",
      "sourceBatch": "Screenshot 23",
      "notes": "Harvested from screenshot 23; Shopify file type SVG. Full handle inferred from truncated display; paste CDN URL to verify exact filename. | Audit note: CDN URL filename conflicts with intended file handle; replace the URL before using in registry logic. | Duplicate URL audit: this CDN URL appears on more than one registry row.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"faq-payment\" data-jsi-section=\"faq-row\" data-jsi-page-wing=\"native-intake-system\" data-jsi-pillars=\"discretion, trust-protection, privacy-routing, native-intake, paid-routing, client-briefing\" data-jsi-category=\"faq-payment\" data-jsi-style=\"premium-monoline, trust-symbol\" data-jsi-fill=\"outline_light\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "25-js-faq-vnext-icon-transparent-fees-invoice-lock-25",
        "balanced",
        "billing",
        "black-stroke",
        "client-briefing",
        "container-eligible",
        "discretion",
        "excellent",
        "faq-payment",
        "faq-row",
        "faq-transparent-fees-invoice-lock-25",
        "faq-vnext-icons",
        "faq-vnext-icons-faq-payment-invoice",
        "good-with-ivory-plate-or-css-filter",
        "intake-confirmation",
        "invoice",
        "line",
        "lock",
        "locked-terms",
        "morphology-none",
        "native-intake",
        "native-intake-system",
        "no-double-frame-risk",
        "outline-light",
        "paid-routing",
        "payment-clarity",
        "payment-note",
        "premium-monoline",
        "privacy-routing",
        "quiet",
        "recommended-boxed-or-free",
        "secondary-variant",
        "thin-to-medium",
        "transparent-fees",
        "transparent-fees-invoice-lock",
        "trust-card",
        "trust-protection",
        "trust-symbol",
        "yen"
      ],
      "morphology": {
        "intrinsicFrame": "none",
        "intrinsicFrameEvidence": [],
        "containerEligible": true,
        "freeFloatEligible": true,
        "doubleFrameRisk": false,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "boxed-or-free",
        "boxedSlotRule": "eligible",
        "freeSlotRule": "eligible",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": [
        "boxed",
        "contained-stamp",
        "free",
        "ghost",
        "hairline-frame",
        "left-anchor-large",
        "rounded-square",
        "soft-plate",
        "top-center-free",
        "top-left-inline",
        "watermark"
      ]
    },
    {
      "id": "JSICON-0210",
      "sequence": 210,
      "filename": "JapanSolved_Logo.png",
      "handle": "japansolved-logo",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/JapanSolved_Logo.png?v=1779981390",
      "assetType": "png",
      "assetFamily": "Brand · Core Logo Assets",
      "familyKey": "brand-core-logo-assets-brand-logo-brandmark",
      "rotationGroup": "brand-logo-japansolved-logo",
      "cleanLabel": "JapanSolved Logo",
      "primaryCategory": "brand-logo",
      "categoryTokens": [
        "brand-logo"
      ],
      "purposeTags": [
        "brand-identity",
        "logo",
        "primary-logo",
        "png-brand-asset"
      ],
      "visualTags": [
        "logo",
        "minimal",
        "light",
        "brandmark",
        "png"
      ],
      "sectionFit": [
        "brand-library",
        "header-reference",
        "footer-reference",
        "visual-identity"
      ],
      "rawBestSectionUse": "brand-library, header-reference, footer-reference, visual-identity",
      "styleFamily": [
        "brand-asset",
        "identity-system"
      ],
      "solutionPillars": [
        "asset-intelligence",
        "capital-review",
        "risk-screening",
        "brand-system",
        "identity-asset"
      ],
      "pageWingFit": [
        "brand-system"
      ],
      "fillLevel": "brand-signature",
      "visualDensity": "minimal",
      "lineWeight": "mixed",
      "intensity": "signature",
      "darkThemeFit": "plate-required",
      "lightThemeFit": "good",
      "themeTreatmentNote": "brand/logo asset: inspect on dark plate before live use",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 58.0,
      "familyCategoryRank": 2,
      "categoryRank": 4,
      "designFamilyRank": 1,
      "variantRole": "brand-signature-asset",
      "sourceBatch": "Screenshot 24",
      "notes": "Harvested from screenshot 24; Shopify file type PNG. Paste CDN URL to verify C/D filename match and preserve exact asset path.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"brand-logo\" data-jsi-section=\"brand-library\" data-jsi-page-wing=\"brand-system\" data-jsi-pillars=\"asset-intelligence, capital-review, risk-screening, brand-system, identity-asset\" data-jsi-category=\"brand-logo\" data-jsi-style=\"brand-asset, identity-system\" data-jsi-fill=\"brand_signature\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "asset-intelligence",
        "brand-asset",
        "brand-core-logo-assets",
        "brand-core-logo-assets-brand-logo-brandmark",
        "brand-identity",
        "brand-library",
        "brand-logo",
        "brand-logo-japansolved-logo",
        "brand-signature",
        "brand-signature-asset",
        "brand-system",
        "brandmark",
        "capital-review",
        "container-risk",
        "double-frame-risk",
        "footer-reference",
        "good",
        "header-reference",
        "identity-asset",
        "identity-system",
        "japansolved-logo",
        "light",
        "logo",
        "minimal",
        "mixed",
        "morphology-brand-lockup",
        "plate-required",
        "png",
        "png-brand-asset",
        "primary-logo",
        "recommended-brand-only-no-auto-icon",
        "risk-screening",
        "signature",
        "visual-identity"
      ],
      "morphology": {
        "intrinsicFrame": "brand-lockup",
        "intrinsicFrameEvidence": [
          "brand/logo lockup"
        ],
        "containerEligible": false,
        "freeFloatEligible": false,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "brand-only-no-auto-icon",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "avoid-auto-icon",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": []
    },
    {
      "id": "JSICON-0211",
      "sequence": 211,
      "filename": "JapanSolved_Logo_-_VIP.png",
      "handle": "japansolved-logo-vip",
      "url": "https://cdn.shopify.com/s/files/1/0707/0937/9151/files/JapanSolved_Logo_-_VIP.png?v=1779981523",
      "assetType": "png",
      "assetFamily": "Brand · VIP / Premium Logos",
      "familyKey": "brand-vip-premium-logos-brand-logo-vip",
      "rotationGroup": "brand-logo-japansolved-logo-vip",
      "cleanLabel": "JapanSolved Logo VIP",
      "primaryCategory": "brand-logo",
      "categoryTokens": [
        "brand-logo"
      ],
      "purposeTags": [
        "brand-identity",
        "vip-logo",
        "premium-logo",
        "png-brand-asset"
      ],
      "visualTags": [
        "logo",
        "vip",
        "minimal",
        "light",
        "brandmark",
        "png"
      ],
      "sectionFit": [
        "brand-library",
        "vip-page",
        "premium-section",
        "visual-identity"
      ],
      "rawBestSectionUse": "brand-library, VIP-page, premium-section, visual-identity",
      "styleFamily": [
        "brand-asset",
        "identity-system"
      ],
      "solutionPillars": [
        "asset-intelligence",
        "capital-review",
        "risk-screening",
        "authority-signal",
        "premium-trust",
        "reserved-access"
      ],
      "pageWingFit": [
        "brand-system"
      ],
      "fillLevel": "brand-signature",
      "visualDensity": "minimal",
      "lineWeight": "mixed",
      "intensity": "signature",
      "darkThemeFit": "plate-required",
      "lightThemeFit": "good",
      "themeTreatmentNote": "brand/logo asset: inspect on dark plate before live use",
      "status": "Ready · URL verified",
      "urlAuditStatus": "OK · exact C/D filename match",
      "errorFlag": "OK",
      "defaultPriorityScore": 58.0,
      "familyCategoryRank": 1,
      "categoryRank": 5,
      "designFamilyRank": 1,
      "variantRole": "brand-signature-asset",
      "sourceBatch": "Screenshot 24",
      "notes": "Harvested from screenshot 24; Shopify file type PNG. Paste CDN URL to verify C/D filename match and preserve exact asset path.",
      "iconCallTemplate": "<span class=\"jsi-icon-slot\" data-jsi-call=\"brand-logo\" data-jsi-section=\"brand-library\" data-jsi-page-wing=\"brand-system\" data-jsi-pillars=\"asset-intelligence, capital-review, risk-screening, authority-signal, premium-trust, reserved-access\" data-jsi-category=\"brand-logo\" data-jsi-style=\"brand-asset, identity-system\" data-jsi-fill=\"brand_signature\" data-jsi-no-repeat=\"true\" data-jsi-avoid-family-repeat=\"true\"></span>",
      "searchTokens": [
        "asset-intelligence",
        "authority-signal",
        "brand-asset",
        "brand-identity",
        "brand-library",
        "brand-logo",
        "brand-logo-japansolved-logo-vip",
        "brand-signature",
        "brand-signature-asset",
        "brand-system",
        "brand-vip-premium-logos",
        "brand-vip-premium-logos-brand-logo-vip",
        "brandmark",
        "capital-review",
        "container-risk",
        "double-frame-risk",
        "good",
        "identity-system",
        "japansolved-logo-vip",
        "light",
        "logo",
        "minimal",
        "mixed",
        "morphology-brand-lockup",
        "plate-required",
        "png",
        "png-brand-asset",
        "premium-logo",
        "premium-section",
        "premium-trust",
        "recommended-brand-only-no-auto-icon",
        "reserved-access",
        "risk-screening",
        "signature",
        "vip",
        "vip-logo",
        "vip-page",
        "visual-identity"
      ],
      "morphology": {
        "intrinsicFrame": "brand-lockup",
        "intrinsicFrameEvidence": [
          "brand/logo lockup"
        ],
        "containerEligible": false,
        "freeFloatEligible": false,
        "doubleFrameRisk": true,
        "objectShape": "none",
        "visualWeight": "light",
        "recommendedTreatment": "brand-only-no-auto-icon",
        "boxedSlotRule": "avoid-page-container",
        "freeSlotRule": "avoid-auto-icon",
        "classificationSource": "heuristic from registry descriptors + user visual sweep",
        "classifiedAt": "2026-07-07"
      },
      "treatmentCompatibility": []
    }
  ]
};
})();
